import { GraphQLClient, RequestOptions } from 'graphql-request';
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
type GraphQLClientRequestHeaders = RequestOptions['requestHeaders'];
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** Fecha sin hora, en ISO 8601 (YYYY-MM-DD). */
  Date: { input: string; output: string; }
  /** Instante con zona horaria, en RFC 3339. */
  DateTime: { input: string; output: string; }
  /** Decimal exacto serializado como cadena: los importes no pasan por f64. */
  Decimal: { input: string; output: string; }
  JSON: { input: Record<string, unknown>; output: Record<string, unknown>; }
  /**
   * CRM Postventa — contrato GraphQL del BFF.
   *
   * Este documento es la ÚNICA fuente de verdad de la interfaz entre el backend
   * (Rust / async-graphql) y los dos clientes (React web y Expo móvil). El servidor
   * lo implementa; los clientes generan sus tipos a partir de él. Si algo no está
   * aquí, no existe.
   *
   * Convenciones
   *   · Los enums replican los tipos de la base en SCREAMING_SNAKE. El paquete
   *     @crm/design-tokens traduce cada valor a su token de color, etiqueta e icono
   *     mediante `enumToTokenKey`, de modo que web y móvil pintan idéntico.
   *   · Las duraciones viajan en la unidad que declara su nombre (`...Minutes`,
   *     `...Hours`) y se miden en TIEMPO HÁBIL, no de reloj.
   *   · Los listados usan paginación por desplazamiento (`page` / `pageSize`):
   *     es lo que necesitan tanto la tabla de escritorio como el scroll infinito
   *     del móvil, sin el coste de mantener cursores.
   *   · Toda mutación que pueda fallar por reglas de negocio devuelve el objeto
   *     afectado; los errores viajan por `errors` con un `code` estable.
   */
  UUID: { input: string; output: string; }
  Upload: { input: File; output: File; }
};

export type AgentWorkload = {
  avgMttrHours: Maybe<Scalars['Float']['output']>;
  avgTpaHours: Maybe<Scalars['Float']['output']>;
  fcrPct: Maybe<Scalars['Float']['output']>;
  newTickets: Scalars['Int']['output'];
  openTickets: Scalars['Int']['output'];
  overdueTickets: Scalars['Int']['output'];
};

export type AttachmentKind =
  | 'AUDIO'
  | 'DOCUMENTO'
  | 'EVIDENCIA'
  | 'FOTO'
  | 'OTRO'
  | 'VIDEO';

/** Previsualización de a cuántos clientes llegaría una campaña, y a cuántos no. */
export type AudiencePreview = {
  excludedNoWhatsapp: Scalars['Int']['output'];
  excludedOptOut: Scalars['Int']['output'];
  reachable: Scalars['Int']['output'];
  sample: Array<Customer>;
  totalMatched: Scalars['Int']['output'];
};

export type AuthPayload = {
  accessToken: Scalars['String']['output'];
  /** Segundos de vida del token de acceso. */
  expiresIn: Scalars['Int']['output'];
  mustChangePassword: Scalars['Boolean']['output'];
  refreshToken: Scalars['String']['output'];
  user: User;
};

export type BotAction =
  | 'CONSULTAR_ESTADO'
  | 'CREAR_TICKET'
  | 'DERIVAR_HUMANO'
  | 'MENU'
  | 'RESPONDER';

export type BotRule = {
  action: BotAction;
  id: Scalars['UUID']['output'];
  isActive: Scalars['Boolean']['output'];
  keywords: Array<Scalars['String']['output']>;
  matchCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  params: Scalars['JSON']['output'];
  pattern: Maybe<Scalars['String']['output']>;
  priority: Scalars['Int']['output'];
  response: Maybe<Scalars['String']['output']>;
};

export type BotRuleInput = {
  action: BotAction;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  keywords: Array<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  params?: InputMaybe<Scalars['JSON']['input']>;
  pattern?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  response?: InputMaybe<Scalars['String']['input']>;
};

export type Campaign = {
  /**
   * Días tras el envío durante los cuales una compra del cliente se atribuye a
   * esta campaña.
   *
   * Se devuelve para poder precargarlo al editar: sin él, guardar una campaña
   * desde el formulario reenviaba `attributionDays` vacío y le cambiaba la
   * ventana en silencio.
   */
  attributionDays: Scalars['Int']['output'];
  audienceFilter: Scalars['JSON']['output'];
  channel: ContactChannel;
  code: Scalars['String']['output'];
  /** Compras atribuidas / entregados, en porcentaje. */
  conversionRate: Maybe<Scalars['Float']['output']>;
  convertedCount: Scalars['Int']['output'];
  cost: Scalars['Decimal']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Maybe<User>;
  deliveredCount: Scalars['Int']['output'];
  /** Entregados / enviados, en porcentaje. */
  deliveryRate: Maybe<Scalars['Float']['output']>;
  description: Maybe<Scalars['String']['output']>;
  failedCount: Scalars['Int']['output'];
  finishedAt: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  mediaUrl: Maybe<Scalars['String']['output']>;
  messageBody: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  products: Array<Product>;
  readCount: Scalars['Int']['output'];
  readRate: Maybe<Scalars['Float']['output']>;
  recipients: CampaignRecipientConnection;
  repliedCount: Scalars['Int']['output'];
  replyRate: Maybe<Scalars['Float']['output']>;
  revenue: Scalars['Decimal']['output'];
  /** Retorno sobre la inversión de la campaña. */
  roi: Maybe<Scalars['Float']['output']>;
  scheduledAt: Maybe<Scalars['DateTime']['output']>;
  sentCount: Scalars['Int']['output'];
  startedAt: Maybe<Scalars['DateTime']['output']>;
  status: CampaignStatus;
  template: Maybe<MessageTemplate>;
  totalRecipients: Scalars['Int']['output'];
};


export type CampaignRecipientsArgs = {
  page?: InputMaybe<PageInput>;
  status?: InputMaybe<Array<CampaignRecipientStatus>>;
};

export type CampaignConnection = {
  nodes: Array<Campaign>;
  pageInfo: PageInfo;
};

export type CampaignFilter = {
  channel?: InputMaybe<Array<ContactChannel>>;
  createdBetween?: InputMaybe<DateRangeInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<CampaignStatus>>;
};

export type CampaignInput = {
  attributionDays?: InputMaybe<Scalars['Int']['input']>;
  /** Se guarda el filtro, no la lista: permite reevaluar la audiencia al enviar. */
  audienceFilter?: InputMaybe<CustomerFilter>;
  channel?: InputMaybe<ContactChannel>;
  description?: InputMaybe<Scalars['String']['input']>;
  mediaUrl?: InputMaybe<Scalars['String']['input']>;
  messageBody?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  productIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  scheduledAt?: InputMaybe<Scalars['DateTime']['input']>;
  templateId?: InputMaybe<Scalars['UUID']['input']>;
};

export type CampaignRecipient = {
  convertedSale: Maybe<Sale>;
  customer: Customer;
  deliveredAt: Maybe<Scalars['DateTime']['output']>;
  error: Maybe<Scalars['String']['output']>;
  excludedReason: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  phone: Maybe<Scalars['String']['output']>;
  readAt: Maybe<Scalars['DateTime']['output']>;
  repliedAt: Maybe<Scalars['DateTime']['output']>;
  sentAt: Maybe<Scalars['DateTime']['output']>;
  status: CampaignRecipientStatus;
};

export type CampaignRecipientConnection = {
  nodes: Array<CampaignRecipient>;
  pageInfo: PageInfo;
};

export type CampaignRecipientStatus =
  | 'CONVERTIDO'
  | 'ENTREGADO'
  | 'ENVIADO'
  | 'EXCLUIDO'
  | 'FALLIDO'
  | 'LEIDO'
  | 'PENDIENTE'
  | 'RESPONDIDO';

export type CampaignStatus =
  | 'BORRADOR'
  | 'CANCELADA'
  | 'ENVIADA'
  | 'ENVIANDO'
  | 'FALLIDA'
  | 'PROGRAMADA';

export type ChurnRisk =
  | 'ALTO'
  | 'BAJO'
  | 'CRITICO'
  | 'MEDIO';

export type ContactChannel =
  | 'EMAIL'
  | 'FACEBOOK'
  | 'MESSENGER'
  | 'PRESENCIAL'
  | 'SISTEMA'
  | 'TELEFONO'
  | 'WEB'
  | 'WHATSAPP';

export type Conversation = {
  assignedUser: Maybe<User>;
  avatarUrl: Maybe<Scalars['String']['output']>;
  botGreetedAt: Maybe<Scalars['DateTime']['output']>;
  canSendFreeform: Scalars['Boolean']['output'];
  channel: ContactChannel;
  contact: Maybe<CustomerContact>;
  createdAt: Scalars['DateTime']['output'];
  customer: Maybe<Customer>;
  displayName: Maybe<Scalars['String']['output']>;
  externalId: Scalars['String']['output'];
  handoffAt: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  lastMessageAt: Maybe<Scalars['DateTime']['output']>;
  lastMessagePreview: Maybe<Scalars['String']['output']>;
  messages: MessageConnection;
  phone: Maybe<Scalars['String']['output']>;
  status: ConversationStatus;
  ticket: Maybe<Ticket>;
  unreadCount: Scalars['Int']['output'];
  /**
   * Fin de la ventana de 24 h de WhatsApp. Pasada esa hora sólo se puede
   * escribir con una plantilla aprobada: la UI debe bloquear el compositor.
   */
  windowExpiresAt: Maybe<Scalars['DateTime']['output']>;
};


export type ConversationMessagesArgs = {
  before?: InputMaybe<Scalars['DateTime']['input']>;
  page?: InputMaybe<PageInput>;
};

export type ConversationConnection = {
  nodes: Array<Conversation>;
  pageInfo: PageInfo;
};

export type ConversationFilter = {
  assignedUserId?: InputMaybe<Scalars['UUID']['input']>;
  channel?: InputMaybe<Array<ContactChannel>>;
  customerId?: InputMaybe<Scalars['UUID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<ConversationStatus>>;
  unassigned?: InputMaybe<Scalars['Boolean']['input']>;
  unreadOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConversationStatus =
  | 'ABIERTA'
  | 'BOT'
  | 'CERRADA'
  | 'EN_ESPERA';

export type CorrectiveAction = {
  actionType: CorrectiveActionType;
  cost: Scalars['Decimal']['output'];
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  durationMinutes: Maybe<Scalars['Int']['output']>;
  id: Scalars['UUID']['output'];
  isEffective: Maybe<Scalars['Boolean']['output']>;
  performedAt: Scalars['DateTime']['output'];
  result: Maybe<Scalars['String']['output']>;
  technician: Maybe<User>;
};

export type CorrectiveActionInput = {
  actionType: CorrectiveActionType;
  cost?: InputMaybe<Scalars['Decimal']['input']>;
  description: Scalars['String']['input'];
  durationMinutes?: InputMaybe<Scalars['Int']['input']>;
  isEffective?: InputMaybe<Scalars['Boolean']['input']>;
  performedAt?: InputMaybe<Scalars['DateTime']['input']>;
  result?: InputMaybe<Scalars['String']['input']>;
  technicianId?: InputMaybe<Scalars['UUID']['input']>;
  ticketId: Scalars['UUID']['input'];
};

export type CorrectiveActionType =
  | 'CAPACITACION'
  | 'CONTACTO_CLIENTE'
  | 'DIAGNOSTICO'
  | 'OTRO'
  | 'PROPUESTA_SOLUCION'
  | 'REEMBOLSO'
  | 'REEMPLAZO'
  | 'REPARACION'
  | 'VISITA_TECNICA';

export type Customer = {
  activeWarrantyCount: Scalars['Int']['output'];
  address: Maybe<Scalars['String']['output']>;
  assets: Array<CustomerAsset>;
  assignedUser: Maybe<User>;
  avgTicket: Scalars['Decimal']['output'];
  churnReason: Maybe<Scalars['String']['output']>;
  churnRisk: ChurnRisk;
  /** Probabilidad estimada de abandono, 0..1. */
  churnScore: Maybe<Scalars['Float']['output']>;
  code: Scalars['String']['output'];
  contacts: Array<CustomerContact>;
  conversation: Maybe<Conversation>;
  createdAt: Scalars['DateTime']['output'];
  crops: Array<CustomerCrop>;
  daysSincePurchase: Maybe<Scalars['Int']['output']>;
  department: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  district: Maybe<Scalars['String']['output']>;
  docNumber: Scalars['String']['output'];
  docType: DocumentType;
  email: Maybe<Scalars['String']['output']>;
  firstPurchaseAt: Maybe<Scalars['DateTime']['output']>;
  followups: Array<Followup>;
  id: Scalars['UUID']['output'];
  kind: CustomerKind;
  lastPurchaseAt: Maybe<Scalars['DateTime']['output']>;
  latitude: Maybe<Scalars['Float']['output']>;
  legalName: Scalars['String']['output'];
  lifetimeValue: Scalars['Decimal']['output'];
  longitude: Maybe<Scalars['Float']['output']>;
  marketingOptIn: Scalars['Boolean']['output'];
  nextFollowupAt: Maybe<Scalars['DateTime']['output']>;
  notes: Maybe<Scalars['String']['output']>;
  openTicketCount: Scalars['Int']['output'];
  phone: Maybe<Scalars['String']['output']>;
  province: Maybe<Scalars['String']['output']>;
  purchaseCount: Scalars['Int']['output'];
  /** Historial de compras, más reciente primero. */
  sales: SaleConnection;
  source: ContactChannel;
  status: CustomerStatus;
  tags: Array<Scalars['String']['output']>;
  ticketCount: Scalars['Int']['output'];
  tickets: TicketConnection;
  tier: CustomerTier;
  tradeName: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  warranties: Array<Warranty>;
  whatsapp: Maybe<Scalars['String']['output']>;
};


export type CustomerFollowupsArgs = {
  status?: InputMaybe<Array<FollowupStatus>>;
};


export type CustomerSalesArgs = {
  page?: InputMaybe<PageInput>;
};


export type CustomerTicketsArgs = {
  page?: InputMaybe<PageInput>;
  status?: InputMaybe<Array<TicketStatus>>;
};

/** Una máquina concreta en campo del cliente. Es lo que referencia un ticket. */
export type CustomerAsset = {
  alias: Maybe<Scalars['String']['output']>;
  hoursUsed: Scalars['Decimal']['output'];
  id: Scalars['UUID']['output'];
  installedAt: Maybe<Scalars['Date']['output']>;
  isActive: Scalars['Boolean']['output'];
  lastMaintenanceAt: Maybe<Scalars['Date']['output']>;
  location: Maybe<Scalars['String']['output']>;
  nextMaintenanceAt: Maybe<Scalars['Date']['output']>;
  notes: Maybe<Scalars['String']['output']>;
  product: Product;
  purchasedAt: Maybe<Scalars['Date']['output']>;
  serialNumber: Maybe<Scalars['String']['output']>;
  warranty: Maybe<Warranty>;
};

export type CustomerAssetInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  hoursUsed?: InputMaybe<Scalars['Decimal']['input']>;
  installedAt?: InputMaybe<Scalars['Date']['input']>;
  /**
   * Máquina aún en campo. Al ponerla en `false` sale del inventario activo del
   * cliente pero conserva sus tickets, garantías y mantenimientos.
   */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  nextMaintenanceAt?: InputMaybe<Scalars['Date']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  productId: Scalars['UUID']['input'];
  purchasedAt?: InputMaybe<Scalars['Date']['input']>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerConnection = {
  nodes: Array<Customer>;
  pageInfo: PageInfo;
};

export type CustomerContact = {
  email: Maybe<Scalars['String']['output']>;
  fullName: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  isPrimary: Scalars['Boolean']['output'];
  jobTitle: Maybe<Scalars['String']['output']>;
  notes: Maybe<Scalars['String']['output']>;
  phone: Maybe<Scalars['String']['output']>;
  whatsapp: Maybe<Scalars['String']['output']>;
};

export type CustomerContactInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  fullName: Scalars['String']['input'];
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  whatsapp?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerCrop = {
  cropName: Scalars['String']['output'];
  hectares: Maybe<Scalars['Decimal']['output']>;
  id: Scalars['UUID']['output'];
  location: Maybe<Scalars['String']['output']>;
  notes: Maybe<Scalars['String']['output']>;
  seasonEnd: Maybe<Scalars['Int']['output']>;
  seasonStart: Maybe<Scalars['Int']['output']>;
  variety: Maybe<Scalars['String']['output']>;
};

export type CustomerCropInput = {
  cropName: Scalars['String']['input'];
  hectares?: InputMaybe<Scalars['Decimal']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  seasonEnd?: InputMaybe<Scalars['Int']['input']>;
  seasonStart?: InputMaybe<Scalars['Int']['input']>;
  variety?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerFilter = {
  assignedUserId?: InputMaybe<Scalars['UUID']['input']>;
  churnRisk?: InputMaybe<Array<ChurnRisk>>;
  createdBetween?: InputMaybe<DateRangeInput>;
  crop?: InputMaybe<Scalars['String']['input']>;
  department?: InputMaybe<Scalars['String']['input']>;
  hasOpenTickets?: InputMaybe<Scalars['Boolean']['input']>;
  /** Clientes sin comprar desde hace al menos N días. */
  inactiveForDays?: InputMaybe<Scalars['Int']['input']>;
  kind?: InputMaybe<CustomerKind>;
  /** Busca en nombre, razón social, documento, teléfono y WhatsApp. */
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<CustomerStatus>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  tier?: InputMaybe<Array<CustomerTier>>;
};

export type CustomerInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  assignedUserId?: InputMaybe<Scalars['UUID']['input']>;
  department?: InputMaybe<Scalars['String']['input']>;
  district?: InputMaybe<Scalars['String']['input']>;
  docNumber: Scalars['String']['input'];
  docType: DocumentType;
  email?: InputMaybe<Scalars['String']['input']>;
  kind: CustomerKind;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  legalName: Scalars['String']['input'];
  longitude?: InputMaybe<Scalars['Float']['input']>;
  marketingOptIn?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  province?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<ContactChannel>;
  status?: InputMaybe<CustomerStatus>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  tradeName?: InputMaybe<Scalars['String']['input']>;
  whatsapp?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerKind =
  | 'EMPRESA'
  | 'INDIVIDUAL';

export type CustomerSort = {
  direction?: SortDirection;
  field?: CustomerSortField;
};

export type CustomerSortField =
  | 'CODIGO'
  | 'CREADO'
  | 'NOMBRE'
  | 'RIESGO_CHURN'
  | 'ULTIMA_COMPRA'
  | 'VALOR_VIDA';

export type CustomerStatus =
  | 'ACTIVO'
  | 'INACTIVO'
  | 'PERDIDO'
  | 'POTENCIAL';

export type CustomerTier =
  | 'BRONCE'
  | 'ORO'
  | 'PLATA'
  | 'PLATINO';

/** Tablero gerencial: la pantalla 1 del mockup, en una sola consulta. */
export type Dashboard = {
  activeCustomers: Scalars['Int']['output'];
  agentLeaderboard: Array<User>;
  customersAtRisk: Array<Customer>;
  customersByTier: Array<StatusCount>;
  /** Los ocho indicadores de la investigación, ya evaluados contra su meta. */
  kpis: Array<KpiValue>;
  newCustomers: Scalars['Int']['output'];
  openTickets: Scalars['Int']['output'];
  overdueTickets: Scalars['Int']['output'];
  pendingPartRequests: Scalars['Int']['output'];
  range: DateRange;
  /**
   * Porcentaje de los tickets ABIERTOS en el rango que ya estan resueltos hoy.
   *
   * Es una cohorte cerrada —numerador y denominador son el mismo conjunto de
   * tickets—, asi que nunca pasa de 100. No es `ticketsResolved / ticketsCreated`:
   * esos dos conteos son conjuntos distintos y su cociente puede superar el 100 %
   * en cuanto se resuelve algo abierto el mes anterior.
   */
  resolvedPct: Maybe<Scalars['Float']['output']>;
  scheduledFollowupsToday: Scalars['Int']['output'];
  ticketsByChannel: Array<StatusCount>;
  ticketsByPriority: Array<StatusCount>;
  ticketsByStatus: Array<StatusCount>;
  ticketsByType: Array<StatusCount>;
  /** Tickets abiertos dentro del rango. */
  ticketsCreated: Scalars['Int']['output'];
  /** Tickets resueltos dentro del rango, se hubieran abierto cuando se hubieran abierto. */
  ticketsResolved: Scalars['Int']['output'];
  /** Productos con más reclamos por unidad vendida. */
  topClaimedProducts: Array<ProductPerformanceRow>;
  topProducts: Array<ProductPerformanceRow>;
  unreadConversations: Scalars['Int']['output'];
  warrantiesExpiringSoon: Scalars['Int']['output'];
};

export type DateRange = {
  from: Scalars['DateTime']['output'];
  to: Scalars['DateTime']['output'];
};

export type DateRangeInput = {
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
};

export type DocumentType =
  | 'CE'
  | 'DNI'
  | 'PASAPORTE'
  | 'RUC';

export type Followup = {
  asset: Maybe<CustomerAsset>;
  assignedUser: Maybe<User>;
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  customer: Customer;
  description: Maybe<Scalars['String']['output']>;
  durationMinutes: Scalars['Int']['output'];
  id: Scalars['UUID']['output'];
  /** Programado y ya pasado de fecha. */
  isOverdue: Scalars['Boolean']['output'];
  latitude: Maybe<Scalars['Float']['output']>;
  location: Maybe<Scalars['String']['output']>;
  longitude: Maybe<Scalars['Float']['output']>;
  nextActionAt: Maybe<Scalars['DateTime']['output']>;
  outcomePositive: Maybe<Scalars['Boolean']['output']>;
  performedAt: Maybe<Scalars['DateTime']['output']>;
  result: Maybe<Scalars['String']['output']>;
  resultingSale: Maybe<Sale>;
  scheduledAt: Scalars['DateTime']['output'];
  status: FollowupStatus;
  ticket: Maybe<Ticket>;
  title: Scalars['String']['output'];
  type: FollowupType;
};

export type FollowupConnection = {
  nodes: Array<Followup>;
  pageInfo: PageInfo;
};

export type FollowupFilter = {
  assignedUserId?: InputMaybe<Scalars['UUID']['input']>;
  customerId?: InputMaybe<Scalars['UUID']['input']>;
  overdueOnly?: InputMaybe<Scalars['Boolean']['input']>;
  scheduledBetween?: InputMaybe<DateRangeInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<FollowupStatus>>;
  ticketId?: InputMaybe<Scalars['UUID']['input']>;
  type?: InputMaybe<Array<FollowupType>>;
};

export type FollowupInput = {
  assetId?: InputMaybe<Scalars['UUID']['input']>;
  assignedUserId?: InputMaybe<Scalars['UUID']['input']>;
  customerId: Scalars['UUID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  durationMinutes?: InputMaybe<Scalars['Int']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  scheduledAt: Scalars['DateTime']['input'];
  ticketId?: InputMaybe<Scalars['UUID']['input']>;
  title: Scalars['String']['input'];
  type: FollowupType;
};

export type FollowupResultInput = {
  id: Scalars['UUID']['input'];
  /**
   * Dónde se realizó de verdad la visita (RF-06).
   *
   * Se registra al cerrar y no antes: lo que interesa es el punto en el que el
   * técnico estaba cuando dio el trabajo por hecho, que no tiene por qué
   * coincidir con la ubicación que se programó. Va en la misma sentencia que el
   * cierre para que no pueda quedar una visita con coordenadas nuevas y sin
   * cerrar.
   */
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  nextActionAt?: InputMaybe<Scalars['DateTime']['input']>;
  outcomePositive?: InputMaybe<Scalars['Boolean']['input']>;
  result?: InputMaybe<Scalars['String']['input']>;
  resultingSaleId?: InputMaybe<Scalars['UUID']['input']>;
  status: FollowupStatus;
};

export type FollowupStatus =
  | 'CANCELADO'
  | 'CONFIRMADO'
  | 'EN_CURSO'
  | 'NO_REALIZADO'
  | 'PROGRAMADO'
  | 'REALIZADO';

export type FollowupType =
  | 'ENCUESTA'
  | 'LLAMADA'
  | 'MANTENIMIENTO'
  | 'RECORDATORIO'
  | 'VISITA_TECNICA';

export type ImportJob = {
  createdAt: Scalars['DateTime']['output'];
  createdBy: Maybe<User>;
  dryRun: Scalars['Boolean']['output'];
  errorRows: Scalars['Int']['output'];
  errors: Scalars['JSON']['output'];
  fileName: Scalars['String']['output'];
  finishedAt: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  kind: ImportKind;
  okRows: Scalars['Int']['output'];
  status: JobStatus;
  totalRows: Scalars['Int']['output'];
};

export type ImportKind =
  | 'CLIENTES'
  | 'PRODUCTOS'
  | 'REPUESTOS'
  | 'VENTAS';

export type JobStatus =
  | 'COMPLETADO'
  | 'FALLIDO'
  | 'PENDIENTE'
  | 'PROCESANDO';

export type KpiGoal =
  | 'MAYOR_MEJOR'
  | 'MENOR_MEJOR';

export type KpiGranularity =
  | 'ANIO'
  | 'DIA'
  | 'MES'
  | 'SEMANA'
  | 'TRIMESTRE';

export type KpiPoint = {
  denominator: Maybe<Scalars['Float']['output']>;
  numerator: Maybe<Scalars['Float']['output']>;
  periodEnd: Scalars['Date']['output'];
  periodStart: Scalars['Date']['output'];
  sampleSize: Scalars['Int']['output'];
  value: Maybe<Scalars['Float']['output']>;
};

export type KpiSeries = {
  goal: KpiGoal;
  granularity: KpiGranularity;
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  points: Array<KpiPoint>;
  target: Scalars['Float']['output'];
  unit: Scalars['String']['output'];
};

/** Semáforo del indicador respecto de su meta. */
export type KpiStatus =
  | 'CUMPLE'
  | 'INCUMPLE'
  | 'RIESGO'
  | 'SIN_DATOS';

export type KpiTarget = {
  description: Maybe<Scalars['String']['output']>;
  /** 1 = tiempos, 2 = eficiencia, 3 = retención. */
  dimension: Scalars['Int']['output'];
  goal: KpiGoal;
  isActive: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  /**
   * Meta EFECTIVA del indicador, ya resuelta por el servidor.
   *
   * Algunas metas se declaran como un incremento sobre la linea base previa a la
   * implementacion en vez de como un valor absoluto —`repurchasePct` exige
   * «+15 % sobre la linea base», no «llegar al 15 %»—. El servidor aplica esa
   * regla y entrega aqui el numero contra el que de verdad se evalua el
   * semaforo, para que web y movil no tengan que recalcularlo cada una por su
   * cuenta. Si la meta es de incremento y no hay linea base registrada, se cae
   * al valor absoluto configurado.
   */
  targetValue: Scalars['Float']['output'];
  tolerancePct: Scalars['Float']['output'];
  unit: Scalars['String']['output'];
};

export type KpiValue = {
  /** Línea base pre-implementación, para la comparativa antes/después. */
  baseline: Maybe<Scalars['Float']['output']>;
  /** Mejora frente a la línea base, en porcentaje. */
  baselineImprovementPct: Maybe<Scalars['Float']['output']>;
  /** Diferencia con el periodo anterior, en las unidades del indicador. */
  delta: Maybe<Scalars['Float']['output']>;
  deltaPct: Maybe<Scalars['Float']['output']>;
  denominator: Maybe<Scalars['Float']['output']>;
  dimension: Scalars['Int']['output'];
  goal: KpiGoal;
  /** `true` si el delta va en la dirección deseada del indicador. */
  improved: Maybe<Scalars['Boolean']['output']>;
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  numerator: Maybe<Scalars['Float']['output']>;
  /** Valor del periodo inmediatamente anterior, de igual duración. */
  previousValue: Maybe<Scalars['Float']['output']>;
  sampleSize: Scalars['Int']['output'];
  status: KpiStatus;
  /** Meta efectiva contra la que se evalua `status`. Ver `KpiTarget.targetValue`. */
  target: Scalars['Float']['output'];
  unit: Scalars['String']['output'];
  value: Maybe<Scalars['Float']['output']>;
};

export type Message = {
  body: Maybe<Scalars['String']['output']>;
  conversationId: Scalars['UUID']['output'];
  createdAt: Scalars['DateTime']['output'];
  deliveredAt: Maybe<Scalars['DateTime']['output']>;
  direction: MessageDirection;
  errorMessage: Maybe<Scalars['String']['output']>;
  externalId: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  kind: MessageKind;
  latitude: Maybe<Scalars['Float']['output']>;
  longitude: Maybe<Scalars['Float']['output']>;
  mediaMime: Maybe<Scalars['String']['output']>;
  mediaName: Maybe<Scalars['String']['output']>;
  mediaUrl: Maybe<Scalars['String']['output']>;
  readAt: Maybe<Scalars['DateTime']['output']>;
  repliedTo: Maybe<Message>;
  senderType: MessageSenderType;
  senderUser: Maybe<User>;
  sentAt: Maybe<Scalars['DateTime']['output']>;
  status: MessageStatus;
  templateName: Maybe<Scalars['String']['output']>;
  ticket: Maybe<Ticket>;
};

export type MessageConnection = {
  nodes: Array<Message>;
  pageInfo: PageInfo;
};

export type MessageDirection =
  | 'ENTRANTE'
  | 'SALIENTE';

export type MessageKind =
  | 'AUDIO'
  | 'CONTACTO'
  | 'DOCUMENTO'
  | 'IMAGEN'
  | 'INTERACTIVO'
  | 'PLANTILLA'
  | 'SISTEMA'
  | 'TEXTO'
  | 'UBICACION'
  | 'VIDEO';

export type MessageSenderType =
  | 'AGENTE'
  | 'BOT'
  | 'CLIENTE'
  | 'SISTEMA';

export type MessageStatus =
  | 'ENTREGADO'
  | 'ENVIADO'
  | 'FALLIDO'
  | 'LEIDO'
  | 'PENDIENTE';

export type MessageTemplate = {
  body: Scalars['String']['output'];
  category: Scalars['String']['output'];
  channel: ContactChannel;
  footer: Maybe<Scalars['String']['output']>;
  header: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  isActive: Scalars['Boolean']['output'];
  language: Scalars['String']['output'];
  name: Scalars['String']['output'];
  providerStatus: Scalars['String']['output'];
  variables: Scalars['JSON']['output'];
};

export type Mutation = {
  addCorrectiveAction: CorrectiveAction;
  addCustomerAsset: CustomerAsset;
  addCustomerContact: CustomerContact;
  addCustomerCrop: CustomerCrop;
  addTicketNote: TicketEvent;
  adjustStock: Product;
  assignConversation: Conversation;
  assignTicket: Ticket;
  cancelCampaign: Campaign;
  cancelFollowup: Followup;
  cancelSale: Sale;
  changePassword: Scalars['Boolean']['output'];
  changeTicketPriority: Ticket;
  changeTicketStatus: Ticket;
  closeConversation: Conversation;
  closeTicket: Ticket;
  completeFollowup: Followup;
  createBotRule: BotRule;
  createCampaign: Campaign;
  createCustomer: Customer;
  createFollowup: Followup;
  createPartRequest: PartRequest;
  createProduct: Product;
  createSale: Sale;
  createTicket: Ticket;
  createTicketFromConversation: Ticket;
  createUser: User;
  createWarranty: Warranty;
  deleteAttachment: Scalars['Boolean']['output'];
  deleteBotRule: Scalars['Boolean']['output'];
  deleteCampaign: Scalars['Boolean']['output'];
  deleteCustomer: Scalars['Boolean']['output'];
  /**
   * Retira la máquina del inventario activo del cliente (baja lógica).
   *
   * No borra nada: los tickets, las garantías y el historial de mantenimiento
   * siguen siendo consultables. Devuelve `false` si el activo no existía o ya
   * estaba dado de baja.
   */
  deleteCustomerAsset: Scalars['Boolean']['output'];
  deleteCustomerContact: Scalars['Boolean']['output'];
  deleteCustomerCrop: Scalars['Boolean']['output'];
  escalateTicket: Ticket;
  /** Saca la conversación del bot y la pasa a un asesor (RF-05). */
  handoffConversation: Conversation;
  /** Carga masiva desde Excel. Con `dryRun` valida y reporta sin escribir. */
  importFromExcel: ImportJob;
  /** Materializa la audiencia y encola los envíos. */
  launchCampaign: Campaign;
  /** Vincula un hilo anónimo con un cliente, o lo da de alta al vuelo. */
  linkConversationToCustomer: Conversation;
  login: AuthPayload;
  logout: Scalars['Boolean']['output'];
  markAllNotificationsRead: Scalars['Int']['output'];
  markConversationRead: Conversation;
  markNotificationRead: Notification;
  rateTicket: Ticket;
  refreshToken: AuthPayload;
  registerPushToken: Scalars['Boolean']['output'];
  reopenTicket: Ticket;
  /** Responde al cliente por su canal, o deja una nota interna. */
  replyToTicket: TicketEvent;
  resetUserPassword: Scalars['Boolean']['output'];
  /** Cierra el ticket con su solución. Marca el FCR si corresponde. */
  resolveTicket: Ticket;
  sendMessage: Message;
  /** Registra el valor pre-implementación de un indicador, para la comparativa. */
  setKpiBaseline: Scalars['Boolean']['output'];
  setProductCompatibility: Product;
  /** Arranca el cronómetro de atención operativa (Indicador 1.2). */
  startWork: WorkLog;
  stopWork: WorkLog;
  unregisterPushToken: Scalars['Boolean']['output'];
  updateBotRule: BotRule;
  updateCampaign: Campaign;
  updateCustomer: Customer;
  updateCustomerAsset: CustomerAsset;
  updateCustomerContact: CustomerContact;
  updateCustomerCrop: CustomerCrop;
  updateFollowup: Followup;
  updateKpiTarget: KpiTarget;
  updatePartRequestStatus: PartRequest;
  updateProduct: Product;
  updateSale: Sale;
  updateSetting: Setting;
  updateTicket: Ticket;
  updateUser: User;
  uploadAttachment: TicketAttachment;
  uploadFile: UploadedFile;
  voidWarranty: Warranty;
};


export type MutationAddCorrectiveActionArgs = {
  input: CorrectiveActionInput;
};


export type MutationAddCustomerAssetArgs = {
  customerId: Scalars['UUID']['input'];
  input: CustomerAssetInput;
};


export type MutationAddCustomerContactArgs = {
  customerId: Scalars['UUID']['input'];
  input: CustomerContactInput;
};


export type MutationAddCustomerCropArgs = {
  customerId: Scalars['UUID']['input'];
  input: CustomerCropInput;
};


export type MutationAddTicketNoteArgs = {
  body: Scalars['String']['input'];
  ticketId: Scalars['UUID']['input'];
};


export type MutationAdjustStockArgs = {
  delta: Scalars['Int']['input'];
  productId: Scalars['UUID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAssignConversationArgs = {
  id: Scalars['UUID']['input'];
  userId?: InputMaybe<Scalars['UUID']['input']>;
};


export type MutationAssignTicketArgs = {
  id: Scalars['UUID']['input'];
  userId?: InputMaybe<Scalars['UUID']['input']>;
};


export type MutationCancelCampaignArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationCancelFollowupArgs = {
  id: Scalars['UUID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCancelSaleArgs = {
  id: Scalars['UUID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationChangePasswordArgs = {
  currentPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
};


export type MutationChangeTicketPriorityArgs = {
  id: Scalars['UUID']['input'];
  priority: TicketPriority;
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationChangeTicketStatusArgs = {
  id: Scalars['UUID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  status: TicketStatus;
};


export type MutationCloseConversationArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationCloseTicketArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationCompleteFollowupArgs = {
  input: FollowupResultInput;
};


export type MutationCreateBotRuleArgs = {
  input: BotRuleInput;
};


export type MutationCreateCampaignArgs = {
  input: CampaignInput;
};


export type MutationCreateCustomerArgs = {
  input: CustomerInput;
};


export type MutationCreateFollowupArgs = {
  input: FollowupInput;
};


export type MutationCreatePartRequestArgs = {
  input: PartRequestInput;
};


export type MutationCreateProductArgs = {
  input: ProductInput;
};


export type MutationCreateSaleArgs = {
  input: SaleInput;
};


export type MutationCreateTicketArgs = {
  input: TicketInput;
};


export type MutationCreateTicketFromConversationArgs = {
  conversationId: Scalars['UUID']['input'];
  input?: InputMaybe<TicketInput>;
};


export type MutationCreateUserArgs = {
  email: Scalars['String']['input'];
  fullName: Scalars['String']['input'];
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  role: UserRole;
};


export type MutationCreateWarrantyArgs = {
  input: WarrantyInput;
};


export type MutationDeleteAttachmentArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteBotRuleArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteCampaignArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteCustomerArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteCustomerAssetArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteCustomerContactArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteCustomerCropArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationEscalateTicketArgs = {
  id: Scalars['UUID']['input'];
  reason: Scalars['String']['input'];
  toUserId?: InputMaybe<Scalars['UUID']['input']>;
};


export type MutationHandoffConversationArgs = {
  id: Scalars['UUID']['input'];
  userId?: InputMaybe<Scalars['UUID']['input']>;
};


export type MutationImportFromExcelArgs = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  file: Scalars['Upload']['input'];
  kind: ImportKind;
};


export type MutationLaunchCampaignArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationLinkConversationToCustomerArgs = {
  conversationId: Scalars['UUID']['input'];
  customerId?: InputMaybe<Scalars['UUID']['input']>;
  newCustomer?: InputMaybe<CustomerInput>;
};


export type MutationLoginArgs = {
  device?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationLogoutArgs = {
  refreshToken?: InputMaybe<Scalars['String']['input']>;
};


export type MutationMarkConversationReadArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationMarkNotificationReadArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationRateTicketArgs = {
  comment?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  score: Scalars['Int']['input'];
};


export type MutationRefreshTokenArgs = {
  refreshToken: Scalars['String']['input'];
};


export type MutationRegisterPushTokenArgs = {
  platform: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationReopenTicketArgs = {
  id: Scalars['UUID']['input'];
  reason: Scalars['String']['input'];
};


export type MutationReplyToTicketArgs = {
  input: TicketReplyInput;
};


export type MutationResetUserPasswordArgs = {
  id: Scalars['UUID']['input'];
  newPassword: Scalars['String']['input'];
};


export type MutationResolveTicketArgs = {
  id: Scalars['UUID']['input'];
  resolutionSummary: Scalars['String']['input'];
  rootCause?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSendMessageArgs = {
  input: SendMessageInput;
};


export type MutationSetKpiBaselineArgs = {
  key: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  periodEnd: Scalars['Date']['input'];
  periodStart: Scalars['Date']['input'];
  value: Scalars['Float']['input'];
};


export type MutationSetProductCompatibilityArgs = {
  machineId: Scalars['UUID']['input'];
  partIds: Array<Scalars['UUID']['input']>;
};


export type MutationStartWorkArgs = {
  ticketId: Scalars['UUID']['input'];
};


export type MutationStopWorkArgs = {
  note?: InputMaybe<Scalars['String']['input']>;
  workLogId: Scalars['UUID']['input'];
};


export type MutationUnregisterPushTokenArgs = {
  token: Scalars['String']['input'];
};


export type MutationUpdateBotRuleArgs = {
  id: Scalars['UUID']['input'];
  input: BotRuleInput;
};


export type MutationUpdateCampaignArgs = {
  id: Scalars['UUID']['input'];
  input: CampaignInput;
};


export type MutationUpdateCustomerArgs = {
  id: Scalars['UUID']['input'];
  input: CustomerInput;
};


export type MutationUpdateCustomerAssetArgs = {
  id: Scalars['UUID']['input'];
  input: CustomerAssetInput;
};


export type MutationUpdateCustomerContactArgs = {
  id: Scalars['UUID']['input'];
  input: CustomerContactInput;
};


export type MutationUpdateCustomerCropArgs = {
  id: Scalars['UUID']['input'];
  input: CustomerCropInput;
};


export type MutationUpdateFollowupArgs = {
  id: Scalars['UUID']['input'];
  input: FollowupInput;
};


export type MutationUpdateKpiTargetArgs = {
  key: Scalars['String']['input'];
  targetValue: Scalars['Float']['input'];
  tolerancePct?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationUpdatePartRequestStatusArgs = {
  id: Scalars['UUID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  status: PartRequestStatus;
};


export type MutationUpdateProductArgs = {
  id: Scalars['UUID']['input'];
  input: ProductInput;
};


export type MutationUpdateSaleArgs = {
  id: Scalars['UUID']['input'];
  input: SaleInput;
};


export type MutationUpdateSettingArgs = {
  key: Scalars['String']['input'];
  value: Scalars['JSON']['input'];
};


export type MutationUpdateTicketArgs = {
  id: Scalars['UUID']['input'];
  input: TicketUpdateInput;
};


export type MutationUpdateUserArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  maxOpenTickets?: InputMaybe<Scalars['Int']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<UserRole>;
};


export type MutationUploadAttachmentArgs = {
  caption?: InputMaybe<Scalars['String']['input']>;
  file: Scalars['Upload']['input'];
  kind?: InputMaybe<AttachmentKind>;
  ticketId: Scalars['UUID']['input'];
};


export type MutationUploadFileArgs = {
  file: Scalars['Upload']['input'];
};


export type MutationVoidWarrantyArgs = {
  id: Scalars['UUID']['input'];
  reason: Scalars['String']['input'];
};

export type Notification = {
  body: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deepLink: Maybe<Scalars['String']['output']>;
  entity: Maybe<Scalars['String']['output']>;
  entityId: Maybe<Scalars['UUID']['output']>;
  id: Scalars['UUID']['output'];
  kind: NotificationKind;
  readAt: Maybe<Scalars['DateTime']['output']>;
  title: Scalars['String']['output'];
};

export type NotificationKind =
  | 'CAMPANIA_FINALIZADA'
  | 'CLIENTE_EN_RIESGO'
  | 'GARANTIA_POR_VENCER'
  | 'MENSAJE_NUEVO'
  | 'SEGUIMIENTO_HOY'
  | 'SLA_INCUMPLIDO'
  | 'SLA_POR_VENCER'
  | 'TICKET_ASIGNADO'
  | 'TICKET_ESCALADO';

export type PageInfo = {
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  page: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PageInput = {
  /** Base 1. */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Máximo 200. */
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type PartRequest = {
  approvedAt: Maybe<Scalars['DateTime']['output']>;
  asset: Maybe<CustomerAsset>;
  code: Scalars['String']['output'];
  customer: Customer;
  deliveredAt: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  /** En espera y con fecha de necesidad ya pasada. */
  isOverdue: Scalars['Boolean']['output'];
  neededBy: Maybe<Scalars['Date']['output']>;
  notes: Maybe<Scalars['String']['output']>;
  product: Product;
  quantity: Scalars['Decimal']['output'];
  quotedAt: Maybe<Scalars['DateTime']['output']>;
  rejectedReason: Maybe<Scalars['String']['output']>;
  requestedAt: Scalars['DateTime']['output'];
  requestedBy: Maybe<User>;
  shippedAt: Maybe<Scalars['DateTime']['output']>;
  status: PartRequestStatus;
  supplier: Maybe<Scalars['String']['output']>;
  ticket: Maybe<Ticket>;
  total: Scalars['Decimal']['output'];
  underWarranty: Scalars['Boolean']['output'];
  unitPrice: Scalars['Decimal']['output'];
  warranty: Maybe<Warranty>;
};

export type PartRequestConnection = {
  nodes: Array<PartRequest>;
  pageInfo: PageInfo;
};

export type PartRequestFilter = {
  customerId?: InputMaybe<Scalars['UUID']['input']>;
  pendingOnly?: InputMaybe<Scalars['Boolean']['input']>;
  productId?: InputMaybe<Scalars['UUID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<PartRequestStatus>>;
  ticketId?: InputMaybe<Scalars['UUID']['input']>;
};

export type PartRequestInput = {
  assetId?: InputMaybe<Scalars['UUID']['input']>;
  customerId: Scalars['UUID']['input'];
  neededBy?: InputMaybe<Scalars['Date']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  productId: Scalars['UUID']['input'];
  quantity: Scalars['Decimal']['input'];
  supplier?: InputMaybe<Scalars['String']['input']>;
  ticketId?: InputMaybe<Scalars['UUID']['input']>;
  underWarranty?: InputMaybe<Scalars['Boolean']['input']>;
  unitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  warrantyId?: InputMaybe<Scalars['UUID']['input']>;
};

export type PartRequestSort = {
  direction?: SortDirection;
  field?: PartRequestSortField;
};

/** `NECESARIO` ordena por la fecha en que el cliente necesita el repuesto. */
export type PartRequestSortField =
  | 'CREADO'
  | 'ESTADO'
  | 'NECESARIO'
  | 'SOLICITADO';

export type PartRequestStatus =
  | 'APROBADO'
  | 'CANCELADO'
  | 'COTIZADO'
  | 'ENTREGADO'
  | 'EN_TRANSITO'
  | 'RECHAZADO'
  | 'SOLICITADO';

export type Product = {
  attributes: Scalars['JSON']['output'];
  brand: Maybe<Scalars['String']['output']>;
  category: Maybe<ProductCategory>;
  /** Repuestos compatibles con esta máquina (RF-07). */
  compatibleParts: Array<Product>;
  cost: Scalars['Decimal']['output'];
  currency: Scalars['String']['output'];
  description: Maybe<Scalars['String']['output']>;
  /** Máquinas para las que sirve este repuesto. */
  fitsMachines: Array<Product>;
  id: Scalars['UUID']['output'];
  imageUrl: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  isLowStock: Scalars['Boolean']['output'];
  kind: ProductKind;
  maintenanceIntervalDays: Maybe<Scalars['Int']['output']>;
  /** Margen unitario en porcentaje sobre el precio. */
  marginPct: Maybe<Scalars['Float']['output']>;
  minStock: Scalars['Int']['output'];
  model: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** Rentabilidad del producto en el periodo indicado. */
  performance: ProductPerformance;
  price: Scalars['Decimal']['output'];
  reservedStock: Scalars['Int']['output'];
  sku: Scalars['String']['output'];
  stock: Scalars['Int']['output'];
  unit: Scalars['String']['output'];
  warrantyMonths: Scalars['Int']['output'];
};


export type ProductPerformanceArgs = {
  range?: InputMaybe<DateRangeInput>;
};

export type ProductCategory = {
  children: Array<ProductCategory>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  parent: Maybe<ProductCategory>;
  productCount: Scalars['Int']['output'];
  slug: Scalars['String']['output'];
};

export type ProductConnection = {
  nodes: Array<Product>;
  pageInfo: PageInfo;
};

export type ProductFilter = {
  brand?: InputMaybe<Scalars['String']['input']>;
  categoryId?: InputMaybe<Scalars['UUID']['input']>;
  compatibleWithProductId?: InputMaybe<Scalars['UUID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<Array<ProductKind>>;
  lowStockOnly?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type ProductInput = {
  attributes?: InputMaybe<Scalars['JSON']['input']>;
  brand?: InputMaybe<Scalars['String']['input']>;
  categoryId?: InputMaybe<Scalars['UUID']['input']>;
  cost?: InputMaybe<Scalars['Decimal']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  kind: ProductKind;
  maintenanceIntervalDays?: InputMaybe<Scalars['Int']['input']>;
  minStock?: InputMaybe<Scalars['Int']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  price: Scalars['Decimal']['input'];
  sku: Scalars['String']['input'];
  stock?: InputMaybe<Scalars['Int']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  warrantyMonths?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductKind =
  | 'INSUMO'
  | 'MAQUINARIA'
  | 'REPUESTO'
  | 'SERVICIO';

export type ProductPerformance = {
  /** Reclamos por cada 100 unidades vendidas: señal temprana de calidad. */
  claimRate: Maybe<Scalars['Float']['output']>;
  customerCount: Scalars['Int']['output'];
  margin: Scalars['Decimal']['output'];
  revenue: Scalars['Decimal']['output'];
  ticketCount: Scalars['Int']['output'];
  unitsSold: Scalars['Decimal']['output'];
};

export type ProductPerformanceRow = {
  claimRate: Maybe<Scalars['Float']['output']>;
  /** Clientes distintos que compraron el producto en el periodo. */
  customerCount: Scalars['Int']['output'];
  margin: Scalars['Decimal']['output'];
  product: Product;
  revenue: Scalars['Decimal']['output'];
  ticketCount: Scalars['Int']['output'];
  unitsSold: Scalars['Decimal']['output'];
};

export type ProductSort = {
  direction?: SortDirection;
  field?: ProductSortField;
};

export type ProductSortField =
  | 'CREADO'
  | 'NOMBRE'
  | 'PRECIO'
  | 'SKU'
  | 'STOCK';

export type Query = {
  /** Agenda del día para un usuario (por omisión, el actual). */
  agenda: Array<Followup>;
  /**
   * Compañeros a los que se puede pasar un ticket.
   *
   * Deliberadamente SIN `@auth`: reasignar un caso es parte del trabajo diario de
   * un asesor o un técnico, y con `users` protegido no podían ni ver a quién
   * pasárselo. No sustituye a `users`, que sigue siendo el listado administrativo
   * y sigue restringido: son dos cosas distintas.
   *
   * Devuelve sólo cuentas activas con rol `ASESOR`, `TECNICO` o `SUPERVISOR`
   * —quien no atiende tickets no aparece—, ordenadas por nombre para que la lista
   * no baile entre consultas. `workload` trae la carga abierta de cada uno, que
   * es lo que permite elegir con criterio y no por orden alfabético.
   */
  assignableUsers: Array<User>;
  /** Cuántos clientes alcanzaría un filtro, antes de crear la campaña. */
  audiencePreview: AudiencePreview;
  botRules: Array<BotRule>;
  campaign: Maybe<Campaign>;
  campaigns: CampaignConnection;
  conversation: Maybe<Conversation>;
  conversations: ConversationConnection;
  customer: Maybe<Customer>;
  /** Sugerencias para el autocompletado de las pantallas de alta. */
  customerSearch: Array<Customer>;
  customers: CustomerConnection;
  dashboard: Dashboard;
  followup: Maybe<Followup>;
  followups: FollowupConnection;
  importJob: Maybe<ImportJob>;
  importJobs: Array<ImportJob>;
  kpi: KpiValue;
  kpiSeries: KpiSeries;
  kpiTargets: Array<KpiTarget>;
  kpis: Array<KpiValue>;
  /** Usuario de la sesión actual. */
  me: User;
  messageTemplates: Array<MessageTemplate>;
  /** Cola del usuario actual, ordenada por urgencia de SLA. Pantalla de inicio del móvil. */
  myTickets: TicketConnection;
  notifications: Array<Notification>;
  partRequest: Maybe<PartRequest>;
  partRequests: PartRequestConnection;
  product: Maybe<Product>;
  productCategories: Array<ProductCategory>;
  products: ProductConnection;
  sale: Maybe<Sale>;
  sales: SaleConnection;
  settings: Array<Setting>;
  ticket: Maybe<Ticket>;
  tickets: TicketConnection;
  /**
   * Conversaciones con mensajes sin leer, para el distintivo de la bandeja.
   *
   * Existe para no tener que pedir una página de `conversations` sólo para leer
   * su `totalCount`: el móvil lo sondea cada minuto y esto se resuelve con un
   * `count(*)` sobre el índice parcial de no leídas.
   */
  unreadConversationCount: Scalars['Int']['output'];
  unreadNotificationCount: Scalars['Int']['output'];
  user: Maybe<User>;
  /** Listado administrativo completo, con los datos de gestión de cada cuenta. */
  users: Array<User>;
  warranties: WarrantyConnection;
  warranty: Maybe<Warranty>;
};


export type QueryAgendaArgs = {
  day?: InputMaybe<Scalars['Date']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryAssignableUsersArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAudiencePreviewArgs = {
  filter: CustomerFilter;
  sampleSize?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryBotRulesArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCampaignArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryCampaignsArgs = {
  filter?: InputMaybe<CampaignFilter>;
  page?: InputMaybe<PageInput>;
};


export type QueryConversationArgs = {
  customerId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryConversationsArgs = {
  filter?: InputMaybe<ConversationFilter>;
  page?: InputMaybe<PageInput>;
};


export type QueryCustomerArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
  docNumber?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryCustomerSearchArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
};


export type QueryCustomersArgs = {
  filter?: InputMaybe<CustomerFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<CustomerSort>;
};


export type QueryDashboardArgs = {
  range?: InputMaybe<DateRangeInput>;
};


export type QueryFollowupArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryFollowupsArgs = {
  filter?: InputMaybe<FollowupFilter>;
  page?: InputMaybe<PageInput>;
};


export type QueryImportJobArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryImportJobsArgs = {
  kind?: InputMaybe<ImportKind>;
  page?: InputMaybe<PageInput>;
};


export type QueryKpiArgs = {
  key: Scalars['String']['input'];
  range?: InputMaybe<DateRangeInput>;
};


export type QueryKpiSeriesArgs = {
  granularity?: KpiGranularity;
  key: Scalars['String']['input'];
  range: DateRangeInput;
};


export type QueryKpisArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
  range?: InputMaybe<DateRangeInput>;
};


export type QueryMessageTemplatesArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  channel?: InputMaybe<ContactChannel>;
};


export type QueryMyTicketsArgs = {
  page?: InputMaybe<PageInput>;
  status?: InputMaybe<Array<TicketStatus>>;
};


export type QueryNotificationsArgs = {
  page?: InputMaybe<PageInput>;
  unreadOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPartRequestArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryPartRequestsArgs = {
  filter?: InputMaybe<PartRequestFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<PartRequestSort>;
};


export type QueryProductArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProductsArgs = {
  filter?: InputMaybe<ProductFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<ProductSort>;
};


export type QuerySaleArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type QuerySalesArgs = {
  filter?: InputMaybe<SaleFilter>;
  page?: InputMaybe<PageInput>;
};


export type QuerySettingsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryTicketArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryTicketsArgs = {
  filter?: InputMaybe<TicketFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<TicketSort>;
};


export type QueryUserArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryUsersArgs = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  role?: InputMaybe<Array<UserRole>>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryWarrantiesArgs = {
  filter?: InputMaybe<WarrantyFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<WarrantySort>;
};


export type QueryWarrantyArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
};

export type Sale = {
  campaign: Maybe<Campaign>;
  channel: ContactChannel;
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  customer: Customer;
  discount: Scalars['Decimal']['output'];
  id: Scalars['UUID']['output'];
  invoiceNumber: Maybe<Scalars['String']['output']>;
  items: Array<SaleItem>;
  notes: Maybe<Scalars['String']['output']>;
  saleDate: Scalars['DateTime']['output'];
  salesperson: Maybe<User>;
  status: SaleStatus;
  subtotal: Scalars['Decimal']['output'];
  tax: Scalars['Decimal']['output'];
  total: Scalars['Decimal']['output'];
};

export type SaleConnection = {
  nodes: Array<Sale>;
  pageInfo: PageInfo;
};

export type SaleFilter = {
  campaignId?: InputMaybe<Scalars['UUID']['input']>;
  customerId?: InputMaybe<Scalars['UUID']['input']>;
  productId?: InputMaybe<Scalars['UUID']['input']>;
  range?: InputMaybe<DateRangeInput>;
  salespersonId?: InputMaybe<Scalars['UUID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<SaleStatus>>;
};

export type SaleInput = {
  campaignId?: InputMaybe<Scalars['UUID']['input']>;
  channel?: InputMaybe<ContactChannel>;
  customerId: Scalars['UUID']['input'];
  discount?: InputMaybe<Scalars['Decimal']['input']>;
  invoiceNumber?: InputMaybe<Scalars['String']['input']>;
  /** Emitir las garantías de las líneas que declaran meses de cobertura. */
  issueWarranties?: InputMaybe<Scalars['Boolean']['input']>;
  items: Array<SaleItemInput>;
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Registrar los activos del cliente a partir de las líneas con número de serie. */
  registerAssets?: InputMaybe<Scalars['Boolean']['input']>;
  saleDate?: InputMaybe<Scalars['DateTime']['input']>;
  salespersonId?: InputMaybe<Scalars['UUID']['input']>;
  status?: InputMaybe<SaleStatus>;
  tax?: InputMaybe<Scalars['Decimal']['input']>;
};

export type SaleItem = {
  discount: Scalars['Decimal']['output'];
  id: Scalars['UUID']['output'];
  product: Product;
  quantity: Scalars['Decimal']['output'];
  serialNumbers: Array<Scalars['String']['output']>;
  total: Scalars['Decimal']['output'];
  unitPrice: Scalars['Decimal']['output'];
  warrantyMonths: Scalars['Int']['output'];
};

export type SaleItemInput = {
  discount?: InputMaybe<Scalars['Decimal']['input']>;
  productId: Scalars['UUID']['input'];
  quantity: Scalars['Decimal']['input'];
  serialNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  unitPrice: Scalars['Decimal']['input'];
  warrantyMonths?: InputMaybe<Scalars['Int']['input']>;
};

export type SaleStatus =
  | 'ANULADA'
  | 'CONFIRMADA'
  | 'COTIZACION'
  | 'ENTREGADA';

export type SendMessageInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<ContactChannel>;
  conversationId?: InputMaybe<Scalars['UUID']['input']>;
  /** Alternativa a `conversationId`: abre o reutiliza el hilo del cliente. */
  customerId?: InputMaybe<Scalars['UUID']['input']>;
  kind?: InputMaybe<MessageKind>;
  mediaUrl?: InputMaybe<Scalars['String']['input']>;
  /** Obligatorio fuera de la ventana de 24 h. */
  templateName?: InputMaybe<Scalars['String']['input']>;
  templateVariables?: InputMaybe<Scalars['JSON']['input']>;
  ticketId?: InputMaybe<Scalars['UUID']['input']>;
};

export type Setting = {
  description: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  value: Scalars['JSON']['output'];
};

export type SortDirection =
  | 'ASC'
  | 'DESC';

export type StatusCount = {
  count: Scalars['Int']['output'];
  /** Valor del enum tal cual lo devuelve la API, para resolver su token de color. */
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  pct: Scalars['Float']['output'];
};

export type Subscription = {
  /** Cambios en la bandeja: para reordenar sin recargar. */
  conversationUpdated: Conversation;
  /** Mensajes nuevos. Sin `conversationId`, todos los del usuario. */
  messageReceived: Message;
  notificationReceived: Notification;
  /** Cambios en un ticket o, sin filtro, en los del usuario. */
  ticketUpdated: Ticket;
};


export type SubscriptionMessageReceivedArgs = {
  conversationId?: InputMaybe<Scalars['UUID']['input']>;
};


export type SubscriptionTicketUpdatedArgs = {
  ticketId?: InputMaybe<Scalars['UUID']['input']>;
};

export type Ticket = {
  asset: Maybe<CustomerAsset>;
  assignedAt: Maybe<Scalars['DateTime']['output']>;
  assignedUser: Maybe<User>;
  attachmentCount: Scalars['Int']['output'];
  attachments: Array<TicketAttachment>;
  channel: ContactChannel;
  closedAt: Maybe<Scalars['DateTime']['output']>;
  code: Scalars['String']['output'];
  contact: Maybe<CustomerContact>;
  correctiveActions: Array<CorrectiveAction>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Maybe<User>;
  customer: Customer;
  customerReplies: Scalars['Int']['output'];
  description: Maybe<Scalars['String']['output']>;
  /** Minutos hábiles transcurridos desde la apertura. */
  elapsedMinutes: Scalars['Int']['output'];
  escalatedAt: Maybe<Scalars['DateTime']['output']>;
  escalationLevel: Scalars['Int']['output'];
  events: Array<TicketEvent>;
  /** Indicador 2.1 — resuelto en el primer contacto. */
  firstContactResolution: Scalars['Boolean']['output'];
  firstResponseAt: Maybe<Scalars['DateTime']['output']>;
  firstResponseDueAt: Maybe<Scalars['DateTime']['output']>;
  /** Indicador 1.1 — minutos hábiles hasta la primera respuesta. */
  firstResponseMinutes: Maybe<Scalars['Int']['output']>;
  /** Indicador 1.2 — minutos de trabajo efectivo acumulados. */
  handlingMinutes: Scalars['Int']['output'];
  id: Scalars['UUID']['output'];
  /** Indicador 2.3 — incumplió algún plazo comprometido. */
  isOverdue: Scalars['Boolean']['output'];
  openedAt: Scalars['DateTime']['output'];
  overdueReason: Maybe<Scalars['String']['output']>;
  partRequests: Array<PartRequest>;
  priority: TicketPriority;
  product: Maybe<Product>;
  reopenedCount: Scalars['Int']['output'];
  resolutionDueAt: Maybe<Scalars['DateTime']['output']>;
  /** Indicador 2.2 — minutos hábiles hasta la resolución. */
  resolutionMinutes: Maybe<Scalars['Int']['output']>;
  resolutionSlaMinutesLeft: Maybe<Scalars['Int']['output']>;
  resolutionSummary: Maybe<Scalars['String']['output']>;
  resolvedAt: Maybe<Scalars['DateTime']['output']>;
  /** Minutos hábiles que restan del plazo de primera respuesta. Negativo = vencido. */
  responseSlaMinutesLeft: Maybe<Scalars['Int']['output']>;
  rootCause: Maybe<Scalars['String']['output']>;
  sale: Maybe<Sale>;
  satisfactionComment: Maybe<Scalars['String']['output']>;
  satisfactionScore: Maybe<Scalars['Int']['output']>;
  slaStatus: KpiStatus;
  /** Identificador externo del origen: el post de la fanpage, el mensaje… */
  sourceReference: Maybe<Scalars['String']['output']>;
  status: TicketStatus;
  subject: Scalars['String']['output'];
  tags: Array<Scalars['String']['output']>;
  technician: Maybe<User>;
  type: TicketType;
  updatedAt: Scalars['DateTime']['output'];
  warranty: Maybe<Warranty>;
  workLogs: Array<WorkLog>;
  workStartedAt: Maybe<Scalars['DateTime']['output']>;
};


export type TicketEventsArgs = {
  kinds?: InputMaybe<Array<TicketEventKind>>;
  publicOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TicketAttachment = {
  caption: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  fileName: Scalars['String']['output'];
  height: Maybe<Scalars['Int']['output']>;
  id: Scalars['UUID']['output'];
  kind: AttachmentKind;
  mimeType: Scalars['String']['output'];
  sizeBytes: Scalars['Int']['output'];
  uploadedBy: Maybe<User>;
  url: Scalars['String']['output'];
  width: Maybe<Scalars['Int']['output']>;
};

export type TicketConnection = {
  nodes: Array<Ticket>;
  pageInfo: PageInfo;
};

export type TicketEvent = {
  actorContact: Maybe<CustomerContact>;
  actorUser: Maybe<User>;
  attachments: Array<TicketAttachment>;
  body: Maybe<Scalars['String']['output']>;
  channel: Maybe<ContactChannel>;
  fromStatus: Maybe<TicketStatus>;
  fromUser: Maybe<User>;
  id: Scalars['UUID']['output'];
  isPublic: Scalars['Boolean']['output'];
  kind: TicketEventKind;
  metadata: Scalars['JSON']['output'];
  occurredAt: Scalars['DateTime']['output'];
  toStatus: Maybe<TicketStatus>;
  toUser: Maybe<User>;
};

export type TicketEventKind =
  | 'ACCION_CORRECTIVA'
  | 'ADJUNTO'
  | 'ASIGNADO'
  | 'CAMBIO_ESTADO'
  | 'CAMBIO_PRIORIDAD'
  | 'CERRADO'
  | 'CREADO'
  | 'ESCALADO'
  | 'MENSAJE_CLIENTE'
  | 'NOTA_INTERNA'
  | 'REABIERTO'
  | 'RESPUESTA_CLIENTE'
  | 'RESUELTO'
  | 'SLA_INCUMPLIDO';

export type TicketFilter = {
  assignedUserId?: InputMaybe<Scalars['UUID']['input']>;
  /** Con el plazo a punto de vencer, según `sla.warn_before_minutes`. */
  atRiskOnly?: InputMaybe<Scalars['Boolean']['input']>;
  channel?: InputMaybe<Array<ContactChannel>>;
  customerId?: InputMaybe<Scalars['UUID']['input']>;
  openedBetween?: InputMaybe<DateRangeInput>;
  overdueOnly?: InputMaybe<Scalars['Boolean']['input']>;
  priority?: InputMaybe<Array<TicketPriority>>;
  productId?: InputMaybe<Scalars['UUID']['input']>;
  resolvedBetween?: InputMaybe<DateRangeInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<TicketStatus>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  technicianId?: InputMaybe<Scalars['UUID']['input']>;
  type?: InputMaybe<Array<TicketType>>;
  /** Sin asesor asignado. */
  unassigned?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TicketInput = {
  assetId?: InputMaybe<Scalars['UUID']['input']>;
  assignedUserId?: InputMaybe<Scalars['UUID']['input']>;
  channel?: InputMaybe<ContactChannel>;
  contactId?: InputMaybe<Scalars['UUID']['input']>;
  /** Abrirlo desde una conversación existente y enlazarlos. */
  conversationId?: InputMaybe<Scalars['UUID']['input']>;
  customerId: Scalars['UUID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<TicketPriority>;
  productId?: InputMaybe<Scalars['UUID']['input']>;
  saleId?: InputMaybe<Scalars['UUID']['input']>;
  sourceReference?: InputMaybe<Scalars['String']['input']>;
  subject: Scalars['String']['input'];
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  technicianId?: InputMaybe<Scalars['UUID']['input']>;
  type: TicketType;
  warrantyId?: InputMaybe<Scalars['UUID']['input']>;
};

export type TicketPriority =
  | 'ALTA'
  | 'BAJA'
  | 'MEDIA';

export type TicketReplyInput = {
  attachmentIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  body: Scalars['String']['input'];
  /** Canal de salida. Por omisión, el mismo por el que entró el ticket. */
  channel?: InputMaybe<ContactChannel>;
  /** `false` deja una nota interna que no llega al cliente ni cuenta para el TPA. */
  isPublic?: Scalars['Boolean']['input'];
  ticketId: Scalars['UUID']['input'];
};

export type TicketSort = {
  direction?: SortDirection;
  field?: TicketSortField;
};

export type TicketSortField =
  | 'ABIERTO'
  | 'ACTUALIZADO'
  | 'CLIENTE'
  | 'ESTADO'
  | 'PRIORIDAD'
  | 'VENCIMIENTO';

export type TicketStatus =
  | 'CERRADO'
  | 'EN_PROCESO'
  | 'ESCALADO'
  | 'NUEVO'
  | 'PENDIENTE'
  | 'RESUELTO';

export type TicketType =
  | 'CONSULTA_TECNICA'
  | 'GARANTIA'
  | 'RECLAMO'
  | 'REPUESTO'
  | 'SEGUIMIENTO';

export type TicketUpdateInput = {
  assetId?: InputMaybe<Scalars['UUID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<TicketPriority>;
  productId?: InputMaybe<Scalars['UUID']['input']>;
  rootCause?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  technicianId?: InputMaybe<Scalars['UUID']['input']>;
  type?: InputMaybe<TicketType>;
  warrantyId?: InputMaybe<Scalars['UUID']['input']>;
};

export type UploadedFile = {
  fileName: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  mimeType: Scalars['String']['output'];
  sizeBytes: Scalars['Int']['output'];
  url: Scalars['String']['output'];
};

export type User = {
  avatarUrl: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  email: Maybe<Scalars['String']['output']>;
  fullName: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  isActive: Scalars['Boolean']['output'];
  jobTitle: Maybe<Scalars['String']['output']>;
  lastLoginAt: Maybe<Scalars['DateTime']['output']>;
  maxOpenTickets: Scalars['Int']['output'];
  phone: Maybe<Scalars['String']['output']>;
  role: UserRole;
  /** Carga actual del asesor. Alimenta el reparto y el panel del supervisor. */
  workload: Maybe<AgentWorkload>;
};

export type UserRole =
  | 'ADMIN'
  | 'ASESOR'
  | 'LECTURA'
  | 'SUPERVISOR'
  | 'TECNICO';

export type Warranty = {
  asset: Maybe<CustomerAsset>;
  claimCount: Scalars['Int']['output'];
  code: Scalars['String']['output'];
  coverage: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  customer: Customer;
  /** Días que faltan para vencer. Negativo si ya venció. */
  daysRemaining: Scalars['Int']['output'];
  endDate: Scalars['Date']['output'];
  id: Scalars['UUID']['output'];
  months: Scalars['Int']['output'];
  product: Product;
  sale: Maybe<Sale>;
  serialNumber: Maybe<Scalars['String']['output']>;
  startDate: Scalars['Date']['output'];
  status: WarrantyStatus;
  terms: Maybe<Scalars['String']['output']>;
};

export type WarrantyConnection = {
  nodes: Array<Warranty>;
  pageInfo: PageInfo;
};

export type WarrantyFilter = {
  customerId?: InputMaybe<Scalars['UUID']['input']>;
  /** Vencen dentro de N días. */
  expiringInDays?: InputMaybe<Scalars['Int']['input']>;
  productId?: InputMaybe<Scalars['UUID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<WarrantyStatus>>;
};

export type WarrantyInput = {
  assetId?: InputMaybe<Scalars['UUID']['input']>;
  coverage?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['UUID']['input'];
  months: Scalars['Int']['input'];
  productId: Scalars['UUID']['input'];
  saleId?: InputMaybe<Scalars['UUID']['input']>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['Date']['input'];
  terms?: InputMaybe<Scalars['String']['input']>;
};

export type WarrantySort = {
  direction?: SortDirection;
  field?: WarrantySortField;
};

/** `VENCIMIENTO` ordena por fecha de fin; `CLIENTE`, por razón social. */
export type WarrantySortField =
  | 'CLIENTE'
  | 'CREADO'
  | 'INICIO'
  | 'VENCIMIENTO';

export type WarrantyStatus =
  | 'ANULADA'
  | 'POR_VENCER'
  | 'VENCIDA'
  | 'VIGENTE';

export type WorkLog = {
  endedAt: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  isRunning: Scalars['Boolean']['output'];
  minutes: Maybe<Scalars['Int']['output']>;
  note: Maybe<Scalars['String']['output']>;
  startedAt: Scalars['DateTime']['output'];
  user: User;
};

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { me: { maxOpenTickets: number, lastLoginAt: string | null, createdAt: string, id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean, workload: { openTickets: number, newTickets: number, overdueTickets: number, avgTpaHours: number | null, avgMttrHours: number | null, fcrPct: number | null } | null } };

export type LoginMutationVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  device?: InputMaybe<Scalars['String']['input']>;
}>;


export type LoginMutation = { login: { accessToken: string, refreshToken: string, expiresIn: number, mustChangePassword: boolean, user: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } } };

export type RefreshTokenMutationVariables = Exact<{
  refreshToken: Scalars['String']['input'];
}>;


export type RefreshTokenMutation = { refreshToken: { accessToken: string, refreshToken: string, expiresIn: number, mustChangePassword: boolean, user: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } } };

export type LogoutMutationVariables = Exact<{
  refreshToken?: InputMaybe<Scalars['String']['input']>;
}>;


export type LogoutMutation = { logout: boolean };

export type ChangePasswordMutationVariables = Exact<{
  currentPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
}>;


export type ChangePasswordMutation = { changePassword: boolean };

export type UsersQueryVariables = Exact<{
  role?: InputMaybe<Array<UserRole> | UserRole>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type UsersQuery = { users: Array<{ maxOpenTickets: number, lastLoginAt: string | null, createdAt: string, id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean, workload: { openTickets: number, newTickets: number, overdueTickets: number, avgTpaHours: number | null, avgMttrHours: number | null, fcrPct: number | null } | null }> };

export type CreateUserMutationVariables = Exact<{
  fullName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  role: UserRole;
  phone?: InputMaybe<Scalars['String']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateUserMutation = { createUser: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } };

export type UpdateUserMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  fullName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<UserRole>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  maxOpenTickets?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UpdateUserMutation = { updateUser: { maxOpenTickets: number, id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } };

export type ResetUserPasswordMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  newPassword: Scalars['String']['input'];
}>;


export type ResetUserPasswordMutation = { resetUserPassword: boolean };

export type CampaignRecipientsQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  status?: InputMaybe<Array<CampaignRecipientStatus> | CampaignRecipientStatus>;
  page?: InputMaybe<PageInput>;
}>;


export type CampaignRecipientsQuery = { campaign: { id: string, recipients: { nodes: Array<{ id: string, status: CampaignRecipientStatus, phone: string | null, sentAt: string | null, deliveredAt: string | null, readAt: string | null, repliedAt: string | null, error: string | null, excludedReason: string | null, customer: { id: string, code: string, kind: CustomerKind, displayName: string, legalName: string, tradeName: string | null, docType: DocumentType, docNumber: string, phone: string | null, whatsapp: string | null, email: string | null, status: CustomerStatus, tier: CustomerTier, churnRisk: ChurnRisk, district: string | null, province: string | null, department: string | null }, convertedSale: { id: string, code: string, total: string } | null }>, pageInfo: { page: number, pageSize: number, totalCount: number, totalPages: number, hasNextPage: boolean, hasPreviousPage: boolean } } } | null };

export type CustomersQueryVariables = Exact<{
  filter?: InputMaybe<CustomerFilter>;
  sort?: InputMaybe<CustomerSort>;
  page?: InputMaybe<PageInput>;
}>;


export type CustomersQuery = { customers: { nodes: Array<{ churnScore: number | null, churnReason: string | null, lastPurchaseAt: string | null, firstPurchaseAt: string | null, purchaseCount: number, lifetimeValue: string, avgTicket: string, daysSincePurchase: number | null, source: ContactChannel, tags: Array<string>, marketingOptIn: boolean, openTicketCount: number, ticketCount: number, activeWarrantyCount: number, nextFollowupAt: string | null, createdAt: string, updatedAt: string, id: string, code: string, kind: CustomerKind, displayName: string, legalName: string, tradeName: string | null, docType: DocumentType, docNumber: string, phone: string | null, whatsapp: string | null, email: string | null, status: CustomerStatus, tier: CustomerTier, churnRisk: ChurnRisk, district: string | null, province: string | null, department: string | null, assignedUser: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } | null }>, pageInfo: { page: number, pageSize: number, totalCount: number, totalPages: number, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type CustomerDetailQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type CustomerDetailQuery = { customer: { address: string | null, latitude: number | null, longitude: number | null, notes: string | null, churnScore: number | null, churnReason: string | null, lastPurchaseAt: string | null, firstPurchaseAt: string | null, purchaseCount: number, lifetimeValue: string, avgTicket: string, daysSincePurchase: number | null, source: ContactChannel, tags: Array<string>, marketingOptIn: boolean, openTicketCount: number, ticketCount: number, activeWarrantyCount: number, nextFollowupAt: string | null, createdAt: string, updatedAt: string, id: string, code: string, kind: CustomerKind, displayName: string, legalName: string, tradeName: string | null, docType: DocumentType, docNumber: string, phone: string | null, whatsapp: string | null, email: string | null, status: CustomerStatus, tier: CustomerTier, churnRisk: ChurnRisk, district: string | null, province: string | null, department: string | null, contacts: Array<{ id: string, fullName: string, jobTitle: string | null, phone: string | null, whatsapp: string | null, email: string | null, isPrimary: boolean, notes: string | null }>, crops: Array<{ id: string, cropName: string, variety: string | null, hectares: string | null, seasonStart: number | null, seasonEnd: number | null, location: string | null, notes: string | null }>, assets: Array<{ id: string, serialNumber: string | null, alias: string | null, purchasedAt: string | null, installedAt: string | null, hoursUsed: string, lastMaintenanceAt: string | null, nextMaintenanceAt: string | null, location: string | null, isActive: boolean, notes: string | null, product: { id: string, sku: string, name: string, kind: ProductKind, brand: string | null, model: string | null, unit: string, price: string, currency: string, imageUrl: string | null }, warranty: { id: string, code: string, status: WarrantyStatus, endDate: string, daysRemaining: number } | null }>, warranties: Array<{ id: string, code: string, serialNumber: string | null, startDate: string, endDate: string, months: number, status: WarrantyStatus, coverage: string | null, terms: string | null, claimCount: number, daysRemaining: number, createdAt: string, customer: { id: string, code: string, kind: CustomerKind, displayName: string, legalName: string, tradeName: string | null, docType: DocumentType, docNumber: string, phone: string | null, whatsapp: string | null, email: string | null, status: CustomerStatus, tier: CustomerTier, churnRisk: ChurnRisk, district: string | null, province: string | null, department: string | null }, product: { id: string, sku: string, name: string, kind: ProductKind, brand: string | null, model: string | null, unit: string, price: string, currency: string, imageUrl: string | null } }>, followups: Array<{ id: string, code: string, type: FollowupType, status: FollowupStatus, title: string, description: string | null, scheduledAt: string, durationMinutes: number, location: string | null, performedAt: string | null, result: string | null, outcomePositive: boolean | null, nextActionAt: string | null, isOverdue: boolean, createdAt: string, customer: { id: string, code: string, kind: CustomerKind, displayName: string, legalName: string, tradeName: string | null, docType: DocumentType, docNumber: string, phone: string | null, whatsapp: string | null, email: string | null, status: CustomerStatus, tier: CustomerTier, churnRisk: ChurnRisk, district: string | null, province: string | null, department: string | null }, assignedUser: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } | null, ticket: { id: string, code: string, subject: string } | null }>, conversation: { id: string, channel: ContactChannel, externalId: string, status: ConversationStatus, phone: string | null, displayName: string | null, avatarUrl: string | null, canSendFreeform: boolean, windowExpiresAt: string | null, lastMessageAt: string | null, lastMessagePreview: string | null, unreadCount: number, botGreetedAt: string | null, handoffAt: string | null, createdAt: string, customer: { id: string, code: string, kind: CustomerKind, displayName: string, legalName: string, tradeName: string | null, docType: DocumentType, docNumber: string, phone: string | null, whatsapp: string | null, email: string | null, status: CustomerStatus, tier: CustomerTier, churnRisk: ChurnRisk, district: string | null, province: string | null, department: string | null } | null, assignedUser: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } | null, ticket: { id: string, code: string, status: TicketStatus, subject: string } | null } | null, assignedUser: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } | null } | null };

export type CustomerSalesQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  page?: InputMaybe<PageInput>;
}>;


export type CustomerSalesQuery = { customer: { id: string, sales: { nodes: Array<{ id: string, code: string, saleDate: string, status: SaleStatus, channel: ContactChannel, subtotal: string, discount: string, tax: string, total: string, currency: string, invoiceNumber: string | null, salesperson: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } | null, items: Array<{ id: string, quantity: string, unitPrice: string, discount: string, total: string, warrantyMonths: number, serialNumbers: Array<string>, product: { id: string, sku: string, name: string, kind: ProductKind, brand: string | null, model: string | null, unit: string, price: string, currency: string, imageUrl: string | null } }> }>, pageInfo: { page: number, pageSize: number, totalCount: number, totalPages: number, hasNextPage: boolean, hasPreviousPage: boolean } } } | null };

export type CustomerTicketsQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  status?: InputMaybe<Array<TicketStatus> | TicketStatus>;
  page?: InputMaybe<PageInput>;
}>;


export type CustomerTicketsQuery = { customer: { id: string, tickets: { nodes: Array<{ id: string, code: string, subject: string, type: TicketType, priority: TicketPriority, status: TicketStatus, channel: ContactChannel, openedAt: string, updatedAt: string, isOverdue: boolean, slaStatus: KpiStatus, elapsedMinutes: number, responseSlaMinutesLeft: number | null, resolutionSlaMinutesLeft: number | null, firstResponseDueAt: string | null, resolutionDueAt: string | null, firstResponseMinutes: number | null, resolutionMinutes: number | null, handlingMinutes: number, firstContactResolution: boolean, escalationLevel: number, reopenedCount: number, attachmentCount: number, tags: Array<string>, customer: { id: string, code: string, kind: CustomerKind, displayName: string, legalName: string, tradeName: string | null, docType: DocumentType, docNumber: string, phone: string | null, whatsapp: string | null, email: string | null, status: CustomerStatus, tier: CustomerTier, churnRisk: ChurnRisk, district: string | null, province: string | null, department: string | null }, assignedUser: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } | null, technician: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } | null, product: { id: string, sku: string, name: string, kind: ProductKind, brand: string | null, model: string | null, unit: string, price: string, currency: string, imageUrl: string | null } | null }>, pageInfo: { page: number, pageSize: number, totalCount: number, totalPages: number, hasNextPage: boolean, hasPreviousPage: boolean } } } | null };

export type CustomerSearchQueryVariables = Exact<{
  query: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CustomerSearchQuery = { customerSearch: Array<{ openTicketCount: number, lastPurchaseAt: string | null, id: string, code: string, kind: CustomerKind, displayName: string, legalName: string, tradeName: string | null, docType: DocumentType, docNumber: string, phone: string | null, whatsapp: string | null, email: string | null, status: CustomerStatus, tier: CustomerTier, churnRisk: ChurnRisk, district: string | null, province: string | null, department: string | null }> };

export type CreateCustomerMutationVariables = Exact<{
  input: CustomerInput;
}>;


export type CreateCustomerMutation = { createCustomer: { churnScore: number | null, churnReason: string | null, lastPurchaseAt: string | null, firstPurchaseAt: string | null, purchaseCount: number, lifetimeValue: string, avgTicket: string, daysSincePurchase: number | null, source: ContactChannel, tags: Array<string>, marketingOptIn: boolean, openTicketCount: number, ticketCount: number, activeWarrantyCount: number, nextFollowupAt: string | null, createdAt: string, updatedAt: string, id: string, code: string, kind: CustomerKind, displayName: string, legalName: string, tradeName: string | null, docType: DocumentType, docNumber: string, phone: string | null, whatsapp: string | null, email: string | null, status: CustomerStatus, tier: CustomerTier, churnRisk: ChurnRisk, district: string | null, province: string | null, department: string | null, assignedUser: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } | null } };

export type UpdateCustomerMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  input: CustomerInput;
}>;


export type UpdateCustomerMutation = { updateCustomer: { churnScore: number | null, churnReason: string | null, lastPurchaseAt: string | null, firstPurchaseAt: string | null, purchaseCount: number, lifetimeValue: string, avgTicket: string, daysSincePurchase: number | null, source: ContactChannel, tags: Array<string>, marketingOptIn: boolean, openTicketCount: number, ticketCount: number, activeWarrantyCount: number, nextFollowupAt: string | null, createdAt: string, updatedAt: string, id: string, code: string, kind: CustomerKind, displayName: string, legalName: string, tradeName: string | null, docType: DocumentType, docNumber: string, phone: string | null, whatsapp: string | null, email: string | null, status: CustomerStatus, tier: CustomerTier, churnRisk: ChurnRisk, district: string | null, province: string | null, department: string | null, assignedUser: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } | null } };

export type DeleteCustomerMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DeleteCustomerMutation = { deleteCustomer: boolean };

export type AddCustomerContactMutationVariables = Exact<{
  customerId: Scalars['UUID']['input'];
  input: CustomerContactInput;
}>;


export type AddCustomerContactMutation = { addCustomerContact: { id: string, fullName: string, jobTitle: string | null, phone: string | null, whatsapp: string | null, email: string | null, isPrimary: boolean, notes: string | null } };

export type UpdateCustomerContactMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  input: CustomerContactInput;
}>;


export type UpdateCustomerContactMutation = { updateCustomerContact: { id: string, fullName: string, jobTitle: string | null, phone: string | null, whatsapp: string | null, email: string | null, isPrimary: boolean, notes: string | null } };

export type DeleteCustomerContactMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DeleteCustomerContactMutation = { deleteCustomerContact: boolean };

export type AddCustomerCropMutationVariables = Exact<{
  customerId: Scalars['UUID']['input'];
  input: CustomerCropInput;
}>;


export type AddCustomerCropMutation = { addCustomerCrop: { id: string, cropName: string, variety: string | null, hectares: string | null, seasonStart: number | null, seasonEnd: number | null, location: string | null, notes: string | null } };

export type UpdateCustomerCropMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  input: CustomerCropInput;
}>;


export type UpdateCustomerCropMutation = { updateCustomerCrop: { id: string, cropName: string, variety: string | null, hectares: string | null, location: string | null } };

export type DeleteCustomerCropMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DeleteCustomerCropMutation = { deleteCustomerCrop: boolean };

export type AddCustomerAssetMutationVariables = Exact<{
  customerId: Scalars['UUID']['input'];
  input: CustomerAssetInput;
}>;


export type AddCustomerAssetMutation = { addCustomerAsset: { id: string, alias: string | null, serialNumber: string | null, hoursUsed: string, purchasedAt: string | null, nextMaintenanceAt: string | null, location: string | null, isActive: boolean, product: { id: string, sku: string, name: string, kind: ProductKind, brand: string | null, model: string | null, unit: string, price: string, currency: string, imageUrl: string | null } } };

export type DeleteCustomerAssetMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DeleteCustomerAssetMutation = { deleteCustomerAsset: boolean };

export type UpdateCustomerAssetMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  input: CustomerAssetInput;
}>;


export type UpdateCustomerAssetMutation = { updateCustomerAsset: { id: string, alias: string | null, serialNumber: string | null, hoursUsed: string, nextMaintenanceAt: string | null, location: string | null, isActive: boolean } };

export type DashboardQueryVariables = Exact<{
  range?: InputMaybe<DateRangeInput>;
}>;


export type DashboardQuery = { dashboard: { activeCustomers: number, newCustomers: number, openTickets: number, overdueTickets: number, ticketsCreated: number, ticketsResolved: number, resolvedPct: number | null, unreadConversations: number, scheduledFollowupsToday: number, warrantiesExpiringSoon: number, pendingPartRequests: number, range: { from: string, to: string }, kpis: Array<{ key: string, label: string, unit: string, dimension: number, value: number | null, numerator: number | null, denominator: number | null, sampleSize: number, target: number, goal: KpiGoal, status: KpiStatus, previousValue: number | null, delta: number | null, deltaPct: number | null, improved: boolean | null, baseline: number | null, baselineImprovementPct: number | null }>, ticketsByStatus: Array<{ key: string, label: string, count: number, pct: number }>, ticketsByPriority: Array<{ key: string, label: string, count: number, pct: number }>, ticketsByChannel: Array<{ key: string, label: string, count: number, pct: number }>, ticketsByType: Array<{ key: string, label: string, count: number, pct: number }>, customersByTier: Array<{ key: string, label: string, count: number, pct: number }>, topProducts: Array<{ unitsSold: string, revenue: string, margin: string, customerCount: number, ticketCount: number, claimRate: number | null, product: { id: string, sku: string, name: string, kind: ProductKind, brand: string | null, model: string | null, unit: string, price: string, currency: string, imageUrl: string | null } }>, topClaimedProducts: Array<{ unitsSold: string, revenue: string, margin: string, customerCount: number, ticketCount: number, claimRate: number | null, product: { id: string, sku: string, name: string, kind: ProductKind, brand: string | null, model: string | null, unit: string, price: string, currency: string, imageUrl: string | null } }>, agentLeaderboard: Array<{ id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean, workload: { openTickets: number, newTickets: number, overdueTickets: number, avgTpaHours: number | null, avgMttrHours: number | null, fcrPct: number | null } | null }>, customersAtRisk: Array<{ churnScore: number | null, churnReason: string | null, lastPurchaseAt: string | null, daysSincePurchase: number | null, lifetimeValue: string, openTicketCount: number, id: string, code: string, kind: CustomerKind, displayName: string, legalName: string, tradeName: string | null, docType: DocumentType, docNumber: string, phone: string | null, whatsapp: string | null, email: string | null, status: CustomerStatus, tier: CustomerTier, churnRisk: ChurnRisk, district: string | null, province: string | null, department: string | null }> } };

export type KpisQueryVariables = Exact<{
  keys?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  range?: InputMaybe<DateRangeInput>;
}>;


export type KpisQuery = { kpis: Array<{ key: string, label: string, unit: string, dimension: number, value: number | null, numerator: number | null, denominator: number | null, sampleSize: number, target: number, goal: KpiGoal, status: KpiStatus, previousValue: number | null, delta: number | null, deltaPct: number | null, improved: boolean | null, baseline: number | null, baselineImprovementPct: number | null }> };

export type KpiSeriesQueryVariables = Exact<{
  key: Scalars['String']['input'];
  range: DateRangeInput;
  granularity: KpiGranularity;
}>;


export type KpiSeriesQuery = { kpiSeries: { key: string, label: string, unit: string, target: number, goal: KpiGoal, granularity: KpiGranularity, points: Array<{ periodStart: string, periodEnd: string, value: number | null, numerator: number | null, denominator: number | null, sampleSize: number }> } };

export type UserBriefFragment = { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean };

export type CustomerBriefFragment = { id: string, code: string, kind: CustomerKind, displayName: string, legalName: string, tradeName: string | null, docType: DocumentType, docNumber: string, phone: string | null, whatsapp: string | null, email: string | null, status: CustomerStatus, tier: CustomerTier, churnRisk: ChurnRisk, district: string | null, province: string | null, department: string | null };

export type CustomerRowFragment = { churnScore: number | null, churnReason: string | null, lastPurchaseAt: string | null, firstPurchaseAt: string | null, purchaseCount: number, lifetimeValue: string, avgTicket: string, daysSincePurchase: number | null, source: ContactChannel, tags: Array<string>, marketingOptIn: boolean, openTicketCount: number, ticketCount: number, activeWarrantyCount: number, nextFollowupAt: string | null, createdAt: string, updatedAt: string, id: string, code: string, kind: CustomerKind, displayName: string, legalName: string, tradeName: string | null, docType: DocumentType, docNumber: string, phone: string | null, whatsapp: string | null, email: string | null, status: CustomerStatus, tier: CustomerTier, churnRisk: ChurnRisk, district: string | null, province: string | null, department: string | null, assignedUser: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } | null };

export type ProductBriefFragment = { id: string, sku: string, name: string, kind: ProductKind, brand: string | null, model: string | null, unit: string, price: string, currency: string, imageUrl: string | null };

export type ProductRowFragment = { description: string | null, cost: string, marginPct: number | null, stock: number, minStock: number, reservedStock: number, isLowStock: boolean, warrantyMonths: number, maintenanceIntervalDays: number | null, isActive: boolean, id: string, sku: string, name: string, kind: ProductKind, brand: string | null, model: string | null, unit: string, price: string, currency: string, imageUrl: string | null, category: { id: string, name: string, slug: string } | null };

export type TicketRowFragment = { id: string, code: string, subject: string, type: TicketType, priority: TicketPriority, status: TicketStatus, channel: ContactChannel, openedAt: string, updatedAt: string, isOverdue: boolean, slaStatus: KpiStatus, elapsedMinutes: number, responseSlaMinutesLeft: number | null, resolutionSlaMinutesLeft: number | null, firstResponseDueAt: string | null, resolutionDueAt: string | null, firstResponseMinutes: number | null, resolutionMinutes: number | null, handlingMinutes: number, firstContactResolution: boolean, escalationLevel: number, reopenedCount: number, attachmentCount: number, tags: Array<string>, customer: { id: string, code: string, kind: CustomerKind, displayName: string, legalName: string, tradeName: string | null, docType: DocumentType, docNumber: string, phone: string | null, whatsapp: string | null, email: string | null, status: CustomerStatus, tier: CustomerTier, churnRisk: ChurnRisk, district: string | null, province: string | null, department: string | null }, assignedUser: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } | null, technician: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } | null, product: { id: string, sku: string, name: string, kind: ProductKind, brand: string | null, model: string | null, unit: string, price: string, currency: string, imageUrl: string | null } | null };

export type AttachmentFieldsFragment = { id: string, kind: AttachmentKind, fileName: string, mimeType: string, sizeBytes: number, url: string, width: number | null, height: number | null, caption: string | null, createdAt: string, uploadedBy: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } | null };

export type TicketEventFieldsFragment = { id: string, kind: TicketEventKind, body: string | null, isPublic: boolean, channel: ContactChannel | null, fromStatus: TicketStatus | null, toStatus: TicketStatus | null, metadata: Record<string, unknown>, occurredAt: string, actorUser: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } | null, actorContact: { id: string, fullName: string } | null, fromUser: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } | null, toUser: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } | null, attachments: Array<{ id: string, kind: AttachmentKind, fileName: string, mimeType: string, sizeBytes: number, url: string, width: number | null, height: number | null, caption: string | null, createdAt: string, uploadedBy: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } | null }> };

export type TicketDetailFragment = { description: string | null, sourceReference: string | null, assignedAt: string | null, workStartedAt: string | null, firstResponseAt: string | null, resolvedAt: string | null, closedAt: string | null, escalatedAt: string | null, overdueReason: string | null, customerReplies: number, resolutionSummary: string | null, rootCause: string | null, satisfactionScore: number | null, satisfactionComment: string | null, createdAt: string, id: string, code: string, subject: string, type: TicketType, priority: TicketPriority, status: TicketStatus, channel: ContactChannel, openedAt: string, updatedAt: string, isOverdue: boolean, slaStatus: KpiStatus, elapsedMinutes: number, responseSlaMinutesLeft: number | null, resolutionSlaMinutesLeft: number | null, firstResponseDueAt: string | null, resolutionDueAt: string | null, firstResponseMinutes: number | null, resolutionMinutes: number | null, handlingMinutes: number, firstContactResolution: boolean, escalationLevel: number, reopenedCount: number, attachmentCount: number, tags: Array<string>, contact: { id: string, fullName: string, phone: string | null, email: string | null } | null, asset: { id: string, alias: string | null, serialNumber: string | null, hoursUsed: string, product: { id: string, sku: string, name: string, kind: ProductKind, brand: string | null, model: string | null, unit: string, price: string, currency: string, imageUrl: string | null } } | null, sale: { id: string, code: string, saleDate: string, total: string } | null, warranty: { id: string, code: string, status: WarrantyStatus, endDate: string, daysRemaining: number } | null, createdBy: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } | null, attachments: Array<{ id: string, kind: AttachmentKind, fileName: string, mimeType: string, sizeBytes: number, url: string, width: number | null, height: number | null, caption: string | null, createdAt: string, uploadedBy: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } | null }>, correctiveActions: Array<{ id: string, actionType: CorrectiveActionType, description: string, performedAt: string, durationMinutes: number | null, cost: string, result: string | null, isEffective: boolean | null, technician: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } | null }>, workLogs: Array<{ id: string, startedAt: string, endedAt: string | null, minutes: number | null, note: string | null, isRunning: boolean, user: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } }>, partRequests: Array<{ id: string, code: string, status: PartRequestStatus, quantity: string, underWarranty: boolean, total: string, requestedAt: string, neededBy: string | null, isOverdue: boolean, product: { id: string, sku: string, name: string, kind: ProductKind, brand: string | null, model: string | null, unit: string, price: string, currency: string, imageUrl: string | null } }>, customer: { id: string, code: string, kind: CustomerKind, displayName: string, legalName: string, tradeName: string | null, docType: DocumentType, docNumber: string, phone: string | null, whatsapp: string | null, email: string | null, status: CustomerStatus, tier: CustomerTier, churnRisk: ChurnRisk, district: string | null, province: string | null, department: string | null }, assignedUser: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } | null, technician: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } | null, product: { id: string, sku: string, name: string, kind: ProductKind, brand: string | null, model: string | null, unit: string, price: string, currency: string, imageUrl: string | null } | null };

export type PageFieldsFragment = { page: number, pageSize: number, totalCount: number, totalPages: number, hasNextPage: boolean, hasPreviousPage: boolean };

export type KpiValueFieldsFragment = { key: string, label: string, unit: string, dimension: number, value: number | null, numerator: number | null, denominator: number | null, sampleSize: number, target: number, goal: KpiGoal, status: KpiStatus, previousValue: number | null, delta: number | null, deltaPct: number | null, improved: boolean | null, baseline: number | null, baselineImprovementPct: number | null };

export type StatusCountFieldsFragment = { key: string, label: string, count: number, pct: number };

export type ConversationRowFragment = { id: string, channel: ContactChannel, externalId: string, status: ConversationStatus, phone: string | null, displayName: string | null, avatarUrl: string | null, canSendFreeform: boolean, windowExpiresAt: string | null, lastMessageAt: string | null, lastMessagePreview: string | null, unreadCount: number, botGreetedAt: string | null, handoffAt: string | null, createdAt: string, customer: { id: string, code: string, kind: CustomerKind, displayName: string, legalName: string, tradeName: string | null, docType: DocumentType, docNumber: string, phone: string | null, whatsapp: string | null, email: string | null, status: CustomerStatus, tier: CustomerTier, churnRisk: ChurnRisk, district: string | null, province: string | null, department: string | null } | null, assignedUser: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } | null, ticket: { id: string, code: string, status: TicketStatus, subject: string } | null };

export type MessageFieldsFragment = { id: string, conversationId: string, direction: MessageDirection, senderType: MessageSenderType, kind: MessageKind, body: string | null, mediaUrl: string | null, mediaMime: string | null, mediaName: string | null, latitude: number | null, longitude: number | null, templateName: string | null, status: MessageStatus, errorMessage: string | null, sentAt: string | null, deliveredAt: string | null, readAt: string | null, createdAt: string, senderUser: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } | null, repliedTo: { id: string, body: string | null, senderType: MessageSenderType, kind: MessageKind } | null };

export type FollowupFieldsFragment = { id: string, code: string, type: FollowupType, status: FollowupStatus, title: string, description: string | null, scheduledAt: string, durationMinutes: number, location: string | null, performedAt: string | null, result: string | null, outcomePositive: boolean | null, nextActionAt: string | null, isOverdue: boolean, createdAt: string, customer: { id: string, code: string, kind: CustomerKind, displayName: string, legalName: string, tradeName: string | null, docType: DocumentType, docNumber: string, phone: string | null, whatsapp: string | null, email: string | null, status: CustomerStatus, tier: CustomerTier, churnRisk: ChurnRisk, district: string | null, province: string | null, department: string | null }, assignedUser: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } | null, ticket: { id: string, code: string, subject: string } | null };

export type WarrantyFieldsFragment = { id: string, code: string, serialNumber: string | null, startDate: string, endDate: string, months: number, status: WarrantyStatus, coverage: string | null, terms: string | null, claimCount: number, daysRemaining: number, createdAt: string, customer: { id: string, code: string, kind: CustomerKind, displayName: string, legalName: string, tradeName: string | null, docType: DocumentType, docNumber: string, phone: string | null, whatsapp: string | null, email: string | null, status: CustomerStatus, tier: CustomerTier, churnRisk: ChurnRisk, district: string | null, province: string | null, department: string | null }, product: { id: string, sku: string, name: string, kind: ProductKind, brand: string | null, model: string | null, unit: string, price: string, currency: string, imageUrl: string | null } };

export type PartRequestFieldsFragment = { id: string, code: string, quantity: string, status: PartRequestStatus, underWarranty: boolean, unitPrice: string, total: string, supplier: string | null, requestedAt: string, neededBy: string | null, quotedAt: string | null, approvedAt: string | null, shippedAt: string | null, deliveredAt: string | null, rejectedReason: string | null, notes: string | null, isOverdue: boolean, customer: { id: string, code: string, kind: CustomerKind, displayName: string, legalName: string, tradeName: string | null, docType: DocumentType, docNumber: string, phone: string | null, whatsapp: string | null, email: string | null, status: CustomerStatus, tier: CustomerTier, churnRisk: ChurnRisk, district: string | null, province: string | null, department: string | null }, product: { id: string, sku: string, name: string, kind: ProductKind, brand: string | null, model: string | null, unit: string, price: string, currency: string, imageUrl: string | null }, ticket: { id: string, code: string, subject: string } | null, requestedBy: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } | null };

export type CampaignFieldsFragment = { id: string, code: string, name: string, description: string | null, channel: ContactChannel, status: CampaignStatus, messageBody: string | null, mediaUrl: string | null, audienceFilter: Record<string, unknown>, attributionDays: number, scheduledAt: string | null, startedAt: string | null, finishedAt: string | null, totalRecipients: number, sentCount: number, deliveredCount: number, readCount: number, repliedCount: number, failedCount: number, convertedCount: number, revenue: string, cost: string, deliveryRate: number | null, readRate: number | null, replyRate: number | null, conversionRate: number | null, roi: number | null, createdAt: string, template: { id: string, name: string, body: string, header: string | null, footer: string | null, variables: Record<string, unknown> } | null, products: Array<{ id: string, sku: string, name: string, kind: ProductKind, brand: string | null, model: string | null, unit: string, price: string, currency: string, imageUrl: string | null }>, createdBy: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } | null };

export type NotificationFieldsFragment = { id: string, kind: NotificationKind, title: string, body: string | null, entity: string | null, entityId: string | null, deepLink: string | null, readAt: string | null, createdAt: string };

export type ConversationsQueryVariables = Exact<{
  filter?: InputMaybe<ConversationFilter>;
  page?: InputMaybe<PageInput>;
}>;


export type ConversationsQuery = { conversations: { nodes: Array<{ id: string, channel: ContactChannel, externalId: string, status: ConversationStatus, phone: string | null, displayName: string | null, avatarUrl: string | null, canSendFreeform: boolean, windowExpiresAt: string | null, lastMessageAt: string | null, lastMessagePreview: string | null, unreadCount: number, botGreetedAt: string | null, handoffAt: string | null, createdAt: string, customer: { id: string, code: string, kind: CustomerKind, displayName: string, legalName: string, tradeName: string | null, docType: DocumentType, docNumber: string, phone: string | null, whatsapp: string | null, email: string | null, status: CustomerStatus, tier: CustomerTier, churnRisk: ChurnRisk, district: string | null, province: string | null, department: string | null } | null, assignedUser: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } | null, ticket: { id: string, code: string, status: TicketStatus, subject: string } | null }>, pageInfo: { page: number, pageSize: number, totalCount: number, totalPages: number, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type ConversationDetailQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  page?: InputMaybe<PageInput>;
}>;


export type ConversationDetailQuery = { conversation: { id: string, channel: ContactChannel, externalId: string, status: ConversationStatus, phone: string | null, displayName: string | null, avatarUrl: string | null, canSendFreeform: boolean, windowExpiresAt: string | null, lastMessageAt: string | null, lastMessagePreview: string | null, unreadCount: number, botGreetedAt: string | null, handoffAt: string | null, createdAt: string, contact: { id: string, fullName: string, phone: string | null, email: string | null } | null, messages: { nodes: Array<{ id: string, conversationId: string, direction: MessageDirection, senderType: MessageSenderType, kind: MessageKind, body: string | null, mediaUrl: string | null, mediaMime: string | null, mediaName: string | null, latitude: number | null, longitude: number | null, templateName: string | null, status: MessageStatus, errorMessage: string | null, sentAt: string | null, deliveredAt: string | null, readAt: string | null, createdAt: string, senderUser: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } | null, repliedTo: { id: string, body: string | null, senderType: MessageSenderType, kind: MessageKind } | null }>, pageInfo: { page: number, pageSize: number, totalCount: number, totalPages: number, hasNextPage: boolean, hasPreviousPage: boolean } }, customer: { id: string, code: string, kind: CustomerKind, displayName: string, legalName: string, tradeName: string | null, docType: DocumentType, docNumber: string, phone: string | null, whatsapp: string | null, email: string | null, status: CustomerStatus, tier: CustomerTier, churnRisk: ChurnRisk, district: string | null, province: string | null, department: string | null } | null, assignedUser: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } | null, ticket: { id: string, code: string, status: TicketStatus, subject: string } | null } | null };

export type MessageTemplatesQueryVariables = Exact<{
  channel?: InputMaybe<ContactChannel>;
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type MessageTemplatesQuery = { messageTemplates: Array<{ id: string, name: string, channel: ContactChannel, language: string, category: string, header: string | null, body: string, footer: string | null, variables: Record<string, unknown>, providerStatus: string, isActive: boolean }> };

export type SendMessageMutationVariables = Exact<{
  input: SendMessageInput;
}>;


export type SendMessageMutation = { sendMessage: { id: string, conversationId: string, direction: MessageDirection, senderType: MessageSenderType, kind: MessageKind, body: string | null, mediaUrl: string | null, mediaMime: string | null, mediaName: string | null, latitude: number | null, longitude: number | null, templateName: string | null, status: MessageStatus, errorMessage: string | null, sentAt: string | null, deliveredAt: string | null, readAt: string | null, createdAt: string, senderUser: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } | null, repliedTo: { id: string, body: string | null, senderType: MessageSenderType, kind: MessageKind } | null } };

export type MarkConversationReadMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type MarkConversationReadMutation = { markConversationRead: { id: string, unreadCount: number } };

export type AssignConversationMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  userId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type AssignConversationMutation = { assignConversation: { id: string, channel: ContactChannel, externalId: string, status: ConversationStatus, phone: string | null, displayName: string | null, avatarUrl: string | null, canSendFreeform: boolean, windowExpiresAt: string | null, lastMessageAt: string | null, lastMessagePreview: string | null, unreadCount: number, botGreetedAt: string | null, handoffAt: string | null, createdAt: string, customer: { id: string, code: string, kind: CustomerKind, displayName: string, legalName: string, tradeName: string | null, docType: DocumentType, docNumber: string, phone: string | null, whatsapp: string | null, email: string | null, status: CustomerStatus, tier: CustomerTier, churnRisk: ChurnRisk, district: string | null, province: string | null, department: string | null } | null, assignedUser: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } | null, ticket: { id: string, code: string, status: TicketStatus, subject: string } | null } };

export type CloseConversationMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type CloseConversationMutation = { closeConversation: { id: string, channel: ContactChannel, externalId: string, status: ConversationStatus, phone: string | null, displayName: string | null, avatarUrl: string | null, canSendFreeform: boolean, windowExpiresAt: string | null, lastMessageAt: string | null, lastMessagePreview: string | null, unreadCount: number, botGreetedAt: string | null, handoffAt: string | null, createdAt: string, customer: { id: string, code: string, kind: CustomerKind, displayName: string, legalName: string, tradeName: string | null, docType: DocumentType, docNumber: string, phone: string | null, whatsapp: string | null, email: string | null, status: CustomerStatus, tier: CustomerTier, churnRisk: ChurnRisk, district: string | null, province: string | null, department: string | null } | null, assignedUser: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } | null, ticket: { id: string, code: string, status: TicketStatus, subject: string } | null } };

export type HandoffConversationMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  userId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type HandoffConversationMutation = { handoffConversation: { id: string, channel: ContactChannel, externalId: string, status: ConversationStatus, phone: string | null, displayName: string | null, avatarUrl: string | null, canSendFreeform: boolean, windowExpiresAt: string | null, lastMessageAt: string | null, lastMessagePreview: string | null, unreadCount: number, botGreetedAt: string | null, handoffAt: string | null, createdAt: string, customer: { id: string, code: string, kind: CustomerKind, displayName: string, legalName: string, tradeName: string | null, docType: DocumentType, docNumber: string, phone: string | null, whatsapp: string | null, email: string | null, status: CustomerStatus, tier: CustomerTier, churnRisk: ChurnRisk, district: string | null, province: string | null, department: string | null } | null, assignedUser: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } | null, ticket: { id: string, code: string, status: TicketStatus, subject: string } | null } };

export type LinkConversationToCustomerMutationVariables = Exact<{
  conversationId: Scalars['UUID']['input'];
  customerId?: InputMaybe<Scalars['UUID']['input']>;
  newCustomer?: InputMaybe<CustomerInput>;
}>;


export type LinkConversationToCustomerMutation = { linkConversationToCustomer: { id: string, channel: ContactChannel, externalId: string, status: ConversationStatus, phone: string | null, displayName: string | null, avatarUrl: string | null, canSendFreeform: boolean, windowExpiresAt: string | null, lastMessageAt: string | null, lastMessagePreview: string | null, unreadCount: number, botGreetedAt: string | null, handoffAt: string | null, createdAt: string, customer: { id: string, code: string, kind: CustomerKind, displayName: string, legalName: string, tradeName: string | null, docType: DocumentType, docNumber: string, phone: string | null, whatsapp: string | null, email: string | null, status: CustomerStatus, tier: CustomerTier, churnRisk: ChurnRisk, district: string | null, province: string | null, department: string | null } | null, assignedUser: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } | null, ticket: { id: string, code: string, status: TicketStatus, subject: string } | null } };

export type CreateTicketFromConversationMutationVariables = Exact<{
  conversationId: Scalars['UUID']['input'];
  input?: InputMaybe<TicketInput>;
}>;


export type CreateTicketFromConversationMutation = { createTicketFromConversation: { id: string, code: string, subject: string, type: TicketType, priority: TicketPriority, status: TicketStatus, channel: ContactChannel, openedAt: string, updatedAt: string, isOverdue: boolean, slaStatus: KpiStatus, elapsedMinutes: number, responseSlaMinutesLeft: number | null, resolutionSlaMinutesLeft: number | null, firstResponseDueAt: string | null, resolutionDueAt: string | null, firstResponseMinutes: number | null, resolutionMinutes: number | null, handlingMinutes: number, firstContactResolution: boolean, escalationLevel: number, reopenedCount: number, attachmentCount: number, tags: Array<string>, customer: { id: string, code: string, kind: CustomerKind, displayName: string, legalName: string, tradeName: string | null, docType: DocumentType, docNumber: string, phone: string | null, whatsapp: string | null, email: string | null, status: CustomerStatus, tier: CustomerTier, churnRisk: ChurnRisk, district: string | null, province: string | null, department: string | null }, assignedUser: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } | null, technician: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } | null, product: { id: string, sku: string, name: string, kind: ProductKind, brand: string | null, model: string | null, unit: string, price: string, currency: string, imageUrl: string | null } | null } };

export type BotRulesQueryVariables = Exact<{
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type BotRulesQuery = { botRules: Array<{ id: string, name: string, keywords: Array<string>, pattern: string | null, action: BotAction, response: string | null, params: Record<string, unknown>, priority: number, isActive: boolean, matchCount: number }> };

export type CreateBotRuleMutationVariables = Exact<{
  input: BotRuleInput;
}>;


export type CreateBotRuleMutation = { createBotRule: { id: string, name: string, keywords: Array<string>, pattern: string | null, action: BotAction, response: string | null, params: Record<string, unknown>, priority: number, isActive: boolean, matchCount: number } };

export type UpdateBotRuleMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  input: BotRuleInput;
}>;


export type UpdateBotRuleMutation = { updateBotRule: { id: string, name: string, keywords: Array<string>, pattern: string | null, action: BotAction, response: string | null, params: Record<string, unknown>, priority: number, isActive: boolean, matchCount: number } };

export type DeleteBotRuleMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DeleteBotRuleMutation = { deleteBotRule: boolean };

export type FollowupsQueryVariables = Exact<{
  filter?: InputMaybe<FollowupFilter>;
  page?: InputMaybe<PageInput>;
}>;


export type FollowupsQuery = { followups: { nodes: Array<{ id: string, code: string, type: FollowupType, status: FollowupStatus, title: string, description: string | null, scheduledAt: string, durationMinutes: number, location: string | null, performedAt: string | null, result: string | null, outcomePositive: boolean | null, nextActionAt: string | null, isOverdue: boolean, createdAt: string, customer: { id: string, code: string, kind: CustomerKind, displayName: string, legalName: string, tradeName: string | null, docType: DocumentType, docNumber: string, phone: string | null, whatsapp: string | null, email: string | null, status: CustomerStatus, tier: CustomerTier, churnRisk: ChurnRisk, district: string | null, province: string | null, department: string | null }, assignedUser: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } | null, ticket: { id: string, code: string, subject: string } | null }>, pageInfo: { page: number, pageSize: number, totalCount: number, totalPages: number, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type AgendaQueryVariables = Exact<{
  day?: InputMaybe<Scalars['Date']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type AgendaQuery = { agenda: Array<{ id: string, code: string, type: FollowupType, status: FollowupStatus, title: string, description: string | null, scheduledAt: string, durationMinutes: number, location: string | null, performedAt: string | null, result: string | null, outcomePositive: boolean | null, nextActionAt: string | null, isOverdue: boolean, createdAt: string, customer: { id: string, code: string, kind: CustomerKind, displayName: string, legalName: string, tradeName: string | null, docType: DocumentType, docNumber: string, phone: string | null, whatsapp: string | null, email: string | null, status: CustomerStatus, tier: CustomerTier, churnRisk: ChurnRisk, district: string | null, province: string | null, department: string | null }, assignedUser: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } | null, ticket: { id: string, code: string, subject: string } | null }> };

export type CreateFollowupMutationVariables = Exact<{
  input: FollowupInput;
}>;


export type CreateFollowupMutation = { createFollowup: { id: string, code: string, type: FollowupType, status: FollowupStatus, title: string, description: string | null, scheduledAt: string, durationMinutes: number, location: string | null, performedAt: string | null, result: string | null, outcomePositive: boolean | null, nextActionAt: string | null, isOverdue: boolean, createdAt: string, customer: { id: string, code: string, kind: CustomerKind, displayName: string, legalName: string, tradeName: string | null, docType: DocumentType, docNumber: string, phone: string | null, whatsapp: string | null, email: string | null, status: CustomerStatus, tier: CustomerTier, churnRisk: ChurnRisk, district: string | null, province: string | null, department: string | null }, assignedUser: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } | null, ticket: { id: string, code: string, subject: string } | null } };

export type UpdateFollowupMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  input: FollowupInput;
}>;


export type UpdateFollowupMutation = { updateFollowup: { id: string, code: string, type: FollowupType, status: FollowupStatus, title: string, description: string | null, scheduledAt: string, durationMinutes: number, location: string | null, performedAt: string | null, result: string | null, outcomePositive: boolean | null, nextActionAt: string | null, isOverdue: boolean, createdAt: string, customer: { id: string, code: string, kind: CustomerKind, displayName: string, legalName: string, tradeName: string | null, docType: DocumentType, docNumber: string, phone: string | null, whatsapp: string | null, email: string | null, status: CustomerStatus, tier: CustomerTier, churnRisk: ChurnRisk, district: string | null, province: string | null, department: string | null }, assignedUser: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } | null, ticket: { id: string, code: string, subject: string } | null } };

export type CompleteFollowupMutationVariables = Exact<{
  input: FollowupResultInput;
}>;


export type CompleteFollowupMutation = { completeFollowup: { id: string, code: string, type: FollowupType, status: FollowupStatus, title: string, description: string | null, scheduledAt: string, durationMinutes: number, location: string | null, performedAt: string | null, result: string | null, outcomePositive: boolean | null, nextActionAt: string | null, isOverdue: boolean, createdAt: string, customer: { id: string, code: string, kind: CustomerKind, displayName: string, legalName: string, tradeName: string | null, docType: DocumentType, docNumber: string, phone: string | null, whatsapp: string | null, email: string | null, status: CustomerStatus, tier: CustomerTier, churnRisk: ChurnRisk, district: string | null, province: string | null, department: string | null }, assignedUser: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } | null, ticket: { id: string, code: string, subject: string } | null } };

export type CancelFollowupMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
}>;


export type CancelFollowupMutation = { cancelFollowup: { id: string, code: string, type: FollowupType, status: FollowupStatus, title: string, description: string | null, scheduledAt: string, durationMinutes: number, location: string | null, performedAt: string | null, result: string | null, outcomePositive: boolean | null, nextActionAt: string | null, isOverdue: boolean, createdAt: string, customer: { id: string, code: string, kind: CustomerKind, displayName: string, legalName: string, tradeName: string | null, docType: DocumentType, docNumber: string, phone: string | null, whatsapp: string | null, email: string | null, status: CustomerStatus, tier: CustomerTier, churnRisk: ChurnRisk, district: string | null, province: string | null, department: string | null }, assignedUser: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } | null, ticket: { id: string, code: string, subject: string } | null } };

export type WarrantiesQueryVariables = Exact<{
  filter?: InputMaybe<WarrantyFilter>;
  sort?: InputMaybe<WarrantySort>;
  page?: InputMaybe<PageInput>;
}>;


export type WarrantiesQuery = { warranties: { nodes: Array<{ id: string, code: string, serialNumber: string | null, startDate: string, endDate: string, months: number, status: WarrantyStatus, coverage: string | null, terms: string | null, claimCount: number, daysRemaining: number, createdAt: string, customer: { id: string, code: string, kind: CustomerKind, displayName: string, legalName: string, tradeName: string | null, docType: DocumentType, docNumber: string, phone: string | null, whatsapp: string | null, email: string | null, status: CustomerStatus, tier: CustomerTier, churnRisk: ChurnRisk, district: string | null, province: string | null, department: string | null }, product: { id: string, sku: string, name: string, kind: ProductKind, brand: string | null, model: string | null, unit: string, price: string, currency: string, imageUrl: string | null } }>, pageInfo: { page: number, pageSize: number, totalCount: number, totalPages: number, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type CreateWarrantyMutationVariables = Exact<{
  input: WarrantyInput;
}>;


export type CreateWarrantyMutation = { createWarranty: { id: string, code: string, serialNumber: string | null, startDate: string, endDate: string, months: number, status: WarrantyStatus, coverage: string | null, terms: string | null, claimCount: number, daysRemaining: number, createdAt: string, customer: { id: string, code: string, kind: CustomerKind, displayName: string, legalName: string, tradeName: string | null, docType: DocumentType, docNumber: string, phone: string | null, whatsapp: string | null, email: string | null, status: CustomerStatus, tier: CustomerTier, churnRisk: ChurnRisk, district: string | null, province: string | null, department: string | null }, product: { id: string, sku: string, name: string, kind: ProductKind, brand: string | null, model: string | null, unit: string, price: string, currency: string, imageUrl: string | null } } };

export type VoidWarrantyMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  reason: Scalars['String']['input'];
}>;


export type VoidWarrantyMutation = { voidWarranty: { id: string, code: string, serialNumber: string | null, startDate: string, endDate: string, months: number, status: WarrantyStatus, coverage: string | null, terms: string | null, claimCount: number, daysRemaining: number, createdAt: string, customer: { id: string, code: string, kind: CustomerKind, displayName: string, legalName: string, tradeName: string | null, docType: DocumentType, docNumber: string, phone: string | null, whatsapp: string | null, email: string | null, status: CustomerStatus, tier: CustomerTier, churnRisk: ChurnRisk, district: string | null, province: string | null, department: string | null }, product: { id: string, sku: string, name: string, kind: ProductKind, brand: string | null, model: string | null, unit: string, price: string, currency: string, imageUrl: string | null } } };

export type PartRequestsQueryVariables = Exact<{
  filter?: InputMaybe<PartRequestFilter>;
  sort?: InputMaybe<PartRequestSort>;
  page?: InputMaybe<PageInput>;
}>;


export type PartRequestsQuery = { partRequests: { nodes: Array<{ id: string, code: string, quantity: string, status: PartRequestStatus, underWarranty: boolean, unitPrice: string, total: string, supplier: string | null, requestedAt: string, neededBy: string | null, quotedAt: string | null, approvedAt: string | null, shippedAt: string | null, deliveredAt: string | null, rejectedReason: string | null, notes: string | null, isOverdue: boolean, customer: { id: string, code: string, kind: CustomerKind, displayName: string, legalName: string, tradeName: string | null, docType: DocumentType, docNumber: string, phone: string | null, whatsapp: string | null, email: string | null, status: CustomerStatus, tier: CustomerTier, churnRisk: ChurnRisk, district: string | null, province: string | null, department: string | null }, product: { id: string, sku: string, name: string, kind: ProductKind, brand: string | null, model: string | null, unit: string, price: string, currency: string, imageUrl: string | null }, ticket: { id: string, code: string, subject: string } | null, requestedBy: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } | null }>, pageInfo: { page: number, pageSize: number, totalCount: number, totalPages: number, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type CreatePartRequestMutationVariables = Exact<{
  input: PartRequestInput;
}>;


export type CreatePartRequestMutation = { createPartRequest: { id: string, code: string, quantity: string, status: PartRequestStatus, underWarranty: boolean, unitPrice: string, total: string, supplier: string | null, requestedAt: string, neededBy: string | null, quotedAt: string | null, approvedAt: string | null, shippedAt: string | null, deliveredAt: string | null, rejectedReason: string | null, notes: string | null, isOverdue: boolean, customer: { id: string, code: string, kind: CustomerKind, displayName: string, legalName: string, tradeName: string | null, docType: DocumentType, docNumber: string, phone: string | null, whatsapp: string | null, email: string | null, status: CustomerStatus, tier: CustomerTier, churnRisk: ChurnRisk, district: string | null, province: string | null, department: string | null }, product: { id: string, sku: string, name: string, kind: ProductKind, brand: string | null, model: string | null, unit: string, price: string, currency: string, imageUrl: string | null }, ticket: { id: string, code: string, subject: string } | null, requestedBy: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } | null } };

export type UpdatePartRequestStatusMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  status: PartRequestStatus;
  note?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdatePartRequestStatusMutation = { updatePartRequestStatus: { id: string, code: string, quantity: string, status: PartRequestStatus, underWarranty: boolean, unitPrice: string, total: string, supplier: string | null, requestedAt: string, neededBy: string | null, quotedAt: string | null, approvedAt: string | null, shippedAt: string | null, deliveredAt: string | null, rejectedReason: string | null, notes: string | null, isOverdue: boolean, customer: { id: string, code: string, kind: CustomerKind, displayName: string, legalName: string, tradeName: string | null, docType: DocumentType, docNumber: string, phone: string | null, whatsapp: string | null, email: string | null, status: CustomerStatus, tier: CustomerTier, churnRisk: ChurnRisk, district: string | null, province: string | null, department: string | null }, product: { id: string, sku: string, name: string, kind: ProductKind, brand: string | null, model: string | null, unit: string, price: string, currency: string, imageUrl: string | null }, ticket: { id: string, code: string, subject: string } | null, requestedBy: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } | null } };

export type ProductsQueryVariables = Exact<{
  filter?: InputMaybe<ProductFilter>;
  sort?: InputMaybe<ProductSort>;
  page?: InputMaybe<PageInput>;
}>;


export type ProductsQuery = { products: { nodes: Array<{ description: string | null, cost: string, marginPct: number | null, stock: number, minStock: number, reservedStock: number, isLowStock: boolean, warrantyMonths: number, maintenanceIntervalDays: number | null, isActive: boolean, id: string, sku: string, name: string, kind: ProductKind, brand: string | null, model: string | null, unit: string, price: string, currency: string, imageUrl: string | null, category: { id: string, name: string, slug: string } | null }>, pageInfo: { page: number, pageSize: number, totalCount: number, totalPages: number, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type ProductDetailQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  range?: InputMaybe<DateRangeInput>;
}>;


export type ProductDetailQuery = { product: { attributes: Record<string, unknown>, description: string | null, cost: string, marginPct: number | null, stock: number, minStock: number, reservedStock: number, isLowStock: boolean, warrantyMonths: number, maintenanceIntervalDays: number | null, isActive: boolean, id: string, sku: string, name: string, kind: ProductKind, brand: string | null, model: string | null, unit: string, price: string, currency: string, imageUrl: string | null, compatibleParts: Array<{ stock: number, minStock: number, isLowStock: boolean, id: string, sku: string, name: string, kind: ProductKind, brand: string | null, model: string | null, unit: string, price: string, currency: string, imageUrl: string | null }>, fitsMachines: Array<{ id: string, sku: string, name: string, kind: ProductKind, brand: string | null, model: string | null, unit: string, price: string, currency: string, imageUrl: string | null }>, performance: { unitsSold: string, revenue: string, margin: string, customerCount: number, ticketCount: number, claimRate: number | null }, category: { id: string, name: string, slug: string } | null } | null };

export type ProductCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type ProductCategoriesQuery = { productCategories: Array<{ id: string, name: string, slug: string, productCount: number, parent: { id: string, name: string } | null }> };

export type CreateProductMutationVariables = Exact<{
  input: ProductInput;
}>;


export type CreateProductMutation = { createProduct: { description: string | null, cost: string, marginPct: number | null, stock: number, minStock: number, reservedStock: number, isLowStock: boolean, warrantyMonths: number, maintenanceIntervalDays: number | null, isActive: boolean, id: string, sku: string, name: string, kind: ProductKind, brand: string | null, model: string | null, unit: string, price: string, currency: string, imageUrl: string | null, category: { id: string, name: string, slug: string } | null } };

export type UpdateProductMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  input: ProductInput;
}>;


export type UpdateProductMutation = { updateProduct: { description: string | null, cost: string, marginPct: number | null, stock: number, minStock: number, reservedStock: number, isLowStock: boolean, warrantyMonths: number, maintenanceIntervalDays: number | null, isActive: boolean, id: string, sku: string, name: string, kind: ProductKind, brand: string | null, model: string | null, unit: string, price: string, currency: string, imageUrl: string | null, category: { id: string, name: string, slug: string } | null } };

export type AdjustStockMutationVariables = Exact<{
  productId: Scalars['UUID']['input'];
  delta: Scalars['Int']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
}>;


export type AdjustStockMutation = { adjustStock: { id: string, stock: number, minStock: number, isLowStock: boolean } };

export type SetProductCompatibilityMutationVariables = Exact<{
  machineId: Scalars['UUID']['input'];
  partIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
}>;


export type SetProductCompatibilityMutation = { setProductCompatibility: { id: string, compatibleParts: Array<{ id: string, sku: string, name: string, kind: ProductKind, brand: string | null, model: string | null, unit: string, price: string, currency: string, imageUrl: string | null }> } };

export type CampaignsQueryVariables = Exact<{
  filter?: InputMaybe<CampaignFilter>;
  page?: InputMaybe<PageInput>;
}>;


export type CampaignsQuery = { campaigns: { nodes: Array<{ id: string, code: string, name: string, description: string | null, channel: ContactChannel, status: CampaignStatus, messageBody: string | null, mediaUrl: string | null, audienceFilter: Record<string, unknown>, attributionDays: number, scheduledAt: string | null, startedAt: string | null, finishedAt: string | null, totalRecipients: number, sentCount: number, deliveredCount: number, readCount: number, repliedCount: number, failedCount: number, convertedCount: number, revenue: string, cost: string, deliveryRate: number | null, readRate: number | null, replyRate: number | null, conversionRate: number | null, roi: number | null, createdAt: string, template: { id: string, name: string, body: string, header: string | null, footer: string | null, variables: Record<string, unknown> } | null, products: Array<{ id: string, sku: string, name: string, kind: ProductKind, brand: string | null, model: string | null, unit: string, price: string, currency: string, imageUrl: string | null }>, createdBy: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } | null }>, pageInfo: { page: number, pageSize: number, totalCount: number, totalPages: number, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type CampaignDetailQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  page?: InputMaybe<PageInput>;
}>;


export type CampaignDetailQuery = { campaign: { id: string, code: string, name: string, description: string | null, channel: ContactChannel, status: CampaignStatus, messageBody: string | null, mediaUrl: string | null, audienceFilter: Record<string, unknown>, attributionDays: number, scheduledAt: string | null, startedAt: string | null, finishedAt: string | null, totalRecipients: number, sentCount: number, deliveredCount: number, readCount: number, repliedCount: number, failedCount: number, convertedCount: number, revenue: string, cost: string, deliveryRate: number | null, readRate: number | null, replyRate: number | null, conversionRate: number | null, roi: number | null, createdAt: string, recipients: { nodes: Array<{ id: string, status: CampaignRecipientStatus, phone: string | null, sentAt: string | null, deliveredAt: string | null, readAt: string | null, repliedAt: string | null, error: string | null, excludedReason: string | null, customer: { id: string, code: string, kind: CustomerKind, displayName: string, legalName: string, tradeName: string | null, docType: DocumentType, docNumber: string, phone: string | null, whatsapp: string | null, email: string | null, status: CustomerStatus, tier: CustomerTier, churnRisk: ChurnRisk, district: string | null, province: string | null, department: string | null }, convertedSale: { id: string, code: string, total: string } | null }>, pageInfo: { page: number, pageSize: number, totalCount: number, totalPages: number, hasNextPage: boolean, hasPreviousPage: boolean } }, template: { id: string, name: string, body: string, header: string | null, footer: string | null, variables: Record<string, unknown> } | null, products: Array<{ id: string, sku: string, name: string, kind: ProductKind, brand: string | null, model: string | null, unit: string, price: string, currency: string, imageUrl: string | null }>, createdBy: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } | null } | null };

export type AudiencePreviewQueryVariables = Exact<{
  filter: CustomerFilter;
  sampleSize?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AudiencePreviewQuery = { audiencePreview: { totalMatched: number, reachable: number, excludedNoWhatsapp: number, excludedOptOut: number, sample: Array<{ id: string, code: string, kind: CustomerKind, displayName: string, legalName: string, tradeName: string | null, docType: DocumentType, docNumber: string, phone: string | null, whatsapp: string | null, email: string | null, status: CustomerStatus, tier: CustomerTier, churnRisk: ChurnRisk, district: string | null, province: string | null, department: string | null }> } };

export type CreateCampaignMutationVariables = Exact<{
  input: CampaignInput;
}>;


export type CreateCampaignMutation = { createCampaign: { id: string, code: string, name: string, description: string | null, channel: ContactChannel, status: CampaignStatus, messageBody: string | null, mediaUrl: string | null, audienceFilter: Record<string, unknown>, attributionDays: number, scheduledAt: string | null, startedAt: string | null, finishedAt: string | null, totalRecipients: number, sentCount: number, deliveredCount: number, readCount: number, repliedCount: number, failedCount: number, convertedCount: number, revenue: string, cost: string, deliveryRate: number | null, readRate: number | null, replyRate: number | null, conversionRate: number | null, roi: number | null, createdAt: string, template: { id: string, name: string, body: string, header: string | null, footer: string | null, variables: Record<string, unknown> } | null, products: Array<{ id: string, sku: string, name: string, kind: ProductKind, brand: string | null, model: string | null, unit: string, price: string, currency: string, imageUrl: string | null }>, createdBy: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } | null } };

export type UpdateCampaignMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  input: CampaignInput;
}>;


export type UpdateCampaignMutation = { updateCampaign: { id: string, code: string, name: string, description: string | null, channel: ContactChannel, status: CampaignStatus, messageBody: string | null, mediaUrl: string | null, audienceFilter: Record<string, unknown>, attributionDays: number, scheduledAt: string | null, startedAt: string | null, finishedAt: string | null, totalRecipients: number, sentCount: number, deliveredCount: number, readCount: number, repliedCount: number, failedCount: number, convertedCount: number, revenue: string, cost: string, deliveryRate: number | null, readRate: number | null, replyRate: number | null, conversionRate: number | null, roi: number | null, createdAt: string, template: { id: string, name: string, body: string, header: string | null, footer: string | null, variables: Record<string, unknown> } | null, products: Array<{ id: string, sku: string, name: string, kind: ProductKind, brand: string | null, model: string | null, unit: string, price: string, currency: string, imageUrl: string | null }>, createdBy: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } | null } };

export type LaunchCampaignMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type LaunchCampaignMutation = { launchCampaign: { id: string, code: string, name: string, description: string | null, channel: ContactChannel, status: CampaignStatus, messageBody: string | null, mediaUrl: string | null, audienceFilter: Record<string, unknown>, attributionDays: number, scheduledAt: string | null, startedAt: string | null, finishedAt: string | null, totalRecipients: number, sentCount: number, deliveredCount: number, readCount: number, repliedCount: number, failedCount: number, convertedCount: number, revenue: string, cost: string, deliveryRate: number | null, readRate: number | null, replyRate: number | null, conversionRate: number | null, roi: number | null, createdAt: string, template: { id: string, name: string, body: string, header: string | null, footer: string | null, variables: Record<string, unknown> } | null, products: Array<{ id: string, sku: string, name: string, kind: ProductKind, brand: string | null, model: string | null, unit: string, price: string, currency: string, imageUrl: string | null }>, createdBy: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } | null } };

export type CancelCampaignMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type CancelCampaignMutation = { cancelCampaign: { id: string, code: string, name: string, description: string | null, channel: ContactChannel, status: CampaignStatus, messageBody: string | null, mediaUrl: string | null, audienceFilter: Record<string, unknown>, attributionDays: number, scheduledAt: string | null, startedAt: string | null, finishedAt: string | null, totalRecipients: number, sentCount: number, deliveredCount: number, readCount: number, repliedCount: number, failedCount: number, convertedCount: number, revenue: string, cost: string, deliveryRate: number | null, readRate: number | null, replyRate: number | null, conversionRate: number | null, roi: number | null, createdAt: string, template: { id: string, name: string, body: string, header: string | null, footer: string | null, variables: Record<string, unknown> } | null, products: Array<{ id: string, sku: string, name: string, kind: ProductKind, brand: string | null, model: string | null, unit: string, price: string, currency: string, imageUrl: string | null }>, createdBy: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } | null } };

export type DeleteCampaignMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DeleteCampaignMutation = { deleteCampaign: boolean };

export type SalesQueryVariables = Exact<{
  filter?: InputMaybe<SaleFilter>;
  page?: InputMaybe<PageInput>;
}>;


export type SalesQuery = { sales: { nodes: Array<{ id: string, code: string, saleDate: string, status: SaleStatus, channel: ContactChannel, total: string, currency: string, invoiceNumber: string | null, customer: { id: string, code: string, kind: CustomerKind, displayName: string, legalName: string, tradeName: string | null, docType: DocumentType, docNumber: string, phone: string | null, whatsapp: string | null, email: string | null, status: CustomerStatus, tier: CustomerTier, churnRisk: ChurnRisk, district: string | null, province: string | null, department: string | null }, salesperson: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } | null }>, pageInfo: { page: number, pageSize: number, totalCount: number, totalPages: number, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type NotificationsQueryVariables = Exact<{
  unreadOnly?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<PageInput>;
}>;


export type NotificationsQuery = { notifications: Array<{ id: string, kind: NotificationKind, title: string, body: string | null, entity: string | null, entityId: string | null, deepLink: string | null, readAt: string | null, createdAt: string }> };

export type UnreadNotificationCountQueryVariables = Exact<{ [key: string]: never; }>;


export type UnreadNotificationCountQuery = { unreadNotificationCount: number };

export type MarkNotificationReadMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type MarkNotificationReadMutation = { markNotificationRead: { id: string, kind: NotificationKind, title: string, body: string | null, entity: string | null, entityId: string | null, deepLink: string | null, readAt: string | null, createdAt: string } };

export type MarkAllNotificationsReadMutationVariables = Exact<{ [key: string]: never; }>;


export type MarkAllNotificationsReadMutation = { markAllNotificationsRead: number };

export type SettingsQueryVariables = Exact<{
  keys?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type SettingsQuery = { settings: Array<{ key: string, value: Record<string, unknown>, description: string | null, updatedAt: string }> };

export type UpdateSettingMutationVariables = Exact<{
  key: Scalars['String']['input'];
  value: Scalars['JSON']['input'];
}>;


export type UpdateSettingMutation = { updateSetting: { key: string, value: Record<string, unknown>, description: string | null, updatedAt: string } };

export type KpiTargetsQueryVariables = Exact<{ [key: string]: never; }>;


export type KpiTargetsQuery = { kpiTargets: Array<{ key: string, label: string, description: string | null, dimension: number, targetValue: number, unit: string, goal: KpiGoal, tolerancePct: number, isActive: boolean }> };

export type UpdateKpiTargetMutationVariables = Exact<{
  key: Scalars['String']['input'];
  targetValue: Scalars['Float']['input'];
  tolerancePct?: InputMaybe<Scalars['Float']['input']>;
}>;


export type UpdateKpiTargetMutation = { updateKpiTarget: { key: string, label: string, targetValue: number, tolerancePct: number, unit: string, goal: KpiGoal, dimension: number, isActive: boolean } };

export type SetKpiBaselineMutationVariables = Exact<{
  key: Scalars['String']['input'];
  value: Scalars['Float']['input'];
  periodStart: Scalars['Date']['input'];
  periodEnd: Scalars['Date']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
}>;


export type SetKpiBaselineMutation = { setKpiBaseline: boolean };

export type ImportJobsQueryVariables = Exact<{
  kind?: InputMaybe<ImportKind>;
  page?: InputMaybe<PageInput>;
}>;


export type ImportJobsQuery = { importJobs: Array<{ id: string, kind: ImportKind, status: JobStatus, fileName: string, totalRows: number, okRows: number, errorRows: number, errors: Record<string, unknown>, dryRun: boolean, createdAt: string, finishedAt: string | null, createdBy: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } | null }> };

export type ImportFromExcelMutationVariables = Exact<{
  kind: ImportKind;
  file: Scalars['Upload']['input'];
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ImportFromExcelMutation = { importFromExcel: { id: string, kind: ImportKind, status: JobStatus, fileName: string, totalRows: number, okRows: number, errorRows: number, errors: Record<string, unknown>, dryRun: boolean, createdAt: string, finishedAt: string | null } };

export type UploadFileMutationVariables = Exact<{
  file: Scalars['Upload']['input'];
}>;


export type UploadFileMutation = { uploadFile: { id: string, fileName: string, mimeType: string, sizeBytes: number, url: string } };

export type TicketsQueryVariables = Exact<{
  filter?: InputMaybe<TicketFilter>;
  sort?: InputMaybe<TicketSort>;
  page?: InputMaybe<PageInput>;
}>;


export type TicketsQuery = { tickets: { nodes: Array<{ id: string, code: string, subject: string, type: TicketType, priority: TicketPriority, status: TicketStatus, channel: ContactChannel, openedAt: string, updatedAt: string, isOverdue: boolean, slaStatus: KpiStatus, elapsedMinutes: number, responseSlaMinutesLeft: number | null, resolutionSlaMinutesLeft: number | null, firstResponseDueAt: string | null, resolutionDueAt: string | null, firstResponseMinutes: number | null, resolutionMinutes: number | null, handlingMinutes: number, firstContactResolution: boolean, escalationLevel: number, reopenedCount: number, attachmentCount: number, tags: Array<string>, customer: { id: string, code: string, kind: CustomerKind, displayName: string, legalName: string, tradeName: string | null, docType: DocumentType, docNumber: string, phone: string | null, whatsapp: string | null, email: string | null, status: CustomerStatus, tier: CustomerTier, churnRisk: ChurnRisk, district: string | null, province: string | null, department: string | null }, assignedUser: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } | null, technician: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } | null, product: { id: string, sku: string, name: string, kind: ProductKind, brand: string | null, model: string | null, unit: string, price: string, currency: string, imageUrl: string | null } | null }>, pageInfo: { page: number, pageSize: number, totalCount: number, totalPages: number, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type MyTicketsQueryVariables = Exact<{
  status?: InputMaybe<Array<TicketStatus> | TicketStatus>;
  page?: InputMaybe<PageInput>;
}>;


export type MyTicketsQuery = { myTickets: { nodes: Array<{ id: string, code: string, subject: string, type: TicketType, priority: TicketPriority, status: TicketStatus, channel: ContactChannel, openedAt: string, updatedAt: string, isOverdue: boolean, slaStatus: KpiStatus, elapsedMinutes: number, responseSlaMinutesLeft: number | null, resolutionSlaMinutesLeft: number | null, firstResponseDueAt: string | null, resolutionDueAt: string | null, firstResponseMinutes: number | null, resolutionMinutes: number | null, handlingMinutes: number, firstContactResolution: boolean, escalationLevel: number, reopenedCount: number, attachmentCount: number, tags: Array<string>, customer: { id: string, code: string, kind: CustomerKind, displayName: string, legalName: string, tradeName: string | null, docType: DocumentType, docNumber: string, phone: string | null, whatsapp: string | null, email: string | null, status: CustomerStatus, tier: CustomerTier, churnRisk: ChurnRisk, district: string | null, province: string | null, department: string | null }, assignedUser: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } | null, technician: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } | null, product: { id: string, sku: string, name: string, kind: ProductKind, brand: string | null, model: string | null, unit: string, price: string, currency: string, imageUrl: string | null } | null }>, pageInfo: { page: number, pageSize: number, totalCount: number, totalPages: number, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type TicketDetailQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type TicketDetailQuery = { ticket: { description: string | null, sourceReference: string | null, assignedAt: string | null, workStartedAt: string | null, firstResponseAt: string | null, resolvedAt: string | null, closedAt: string | null, escalatedAt: string | null, overdueReason: string | null, customerReplies: number, resolutionSummary: string | null, rootCause: string | null, satisfactionScore: number | null, satisfactionComment: string | null, createdAt: string, id: string, code: string, subject: string, type: TicketType, priority: TicketPriority, status: TicketStatus, channel: ContactChannel, openedAt: string, updatedAt: string, isOverdue: boolean, slaStatus: KpiStatus, elapsedMinutes: number, responseSlaMinutesLeft: number | null, resolutionSlaMinutesLeft: number | null, firstResponseDueAt: string | null, resolutionDueAt: string | null, firstResponseMinutes: number | null, resolutionMinutes: number | null, handlingMinutes: number, firstContactResolution: boolean, escalationLevel: number, reopenedCount: number, attachmentCount: number, tags: Array<string>, contact: { id: string, fullName: string, phone: string | null, email: string | null } | null, asset: { id: string, alias: string | null, serialNumber: string | null, hoursUsed: string, product: { id: string, sku: string, name: string, kind: ProductKind, brand: string | null, model: string | null, unit: string, price: string, currency: string, imageUrl: string | null } } | null, sale: { id: string, code: string, saleDate: string, total: string } | null, warranty: { id: string, code: string, status: WarrantyStatus, endDate: string, daysRemaining: number } | null, createdBy: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } | null, attachments: Array<{ id: string, kind: AttachmentKind, fileName: string, mimeType: string, sizeBytes: number, url: string, width: number | null, height: number | null, caption: string | null, createdAt: string, uploadedBy: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } | null }>, correctiveActions: Array<{ id: string, actionType: CorrectiveActionType, description: string, performedAt: string, durationMinutes: number | null, cost: string, result: string | null, isEffective: boolean | null, technician: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } | null }>, workLogs: Array<{ id: string, startedAt: string, endedAt: string | null, minutes: number | null, note: string | null, isRunning: boolean, user: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } }>, partRequests: Array<{ id: string, code: string, status: PartRequestStatus, quantity: string, underWarranty: boolean, total: string, requestedAt: string, neededBy: string | null, isOverdue: boolean, product: { id: string, sku: string, name: string, kind: ProductKind, brand: string | null, model: string | null, unit: string, price: string, currency: string, imageUrl: string | null } }>, customer: { id: string, code: string, kind: CustomerKind, displayName: string, legalName: string, tradeName: string | null, docType: DocumentType, docNumber: string, phone: string | null, whatsapp: string | null, email: string | null, status: CustomerStatus, tier: CustomerTier, churnRisk: ChurnRisk, district: string | null, province: string | null, department: string | null }, assignedUser: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } | null, technician: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } | null, product: { id: string, sku: string, name: string, kind: ProductKind, brand: string | null, model: string | null, unit: string, price: string, currency: string, imageUrl: string | null } | null } | null };

export type TicketEventsQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  publicOnly?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type TicketEventsQuery = { ticket: { id: string, events: Array<{ id: string, kind: TicketEventKind, body: string | null, isPublic: boolean, channel: ContactChannel | null, fromStatus: TicketStatus | null, toStatus: TicketStatus | null, metadata: Record<string, unknown>, occurredAt: string, actorUser: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } | null, actorContact: { id: string, fullName: string } | null, fromUser: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } | null, toUser: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } | null, attachments: Array<{ id: string, kind: AttachmentKind, fileName: string, mimeType: string, sizeBytes: number, url: string, width: number | null, height: number | null, caption: string | null, createdAt: string, uploadedBy: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } | null }> }> } | null };

export type CreateTicketMutationVariables = Exact<{
  input: TicketInput;
}>;


export type CreateTicketMutation = { createTicket: { id: string, code: string, subject: string, type: TicketType, priority: TicketPriority, status: TicketStatus, channel: ContactChannel, openedAt: string, updatedAt: string, isOverdue: boolean, slaStatus: KpiStatus, elapsedMinutes: number, responseSlaMinutesLeft: number | null, resolutionSlaMinutesLeft: number | null, firstResponseDueAt: string | null, resolutionDueAt: string | null, firstResponseMinutes: number | null, resolutionMinutes: number | null, handlingMinutes: number, firstContactResolution: boolean, escalationLevel: number, reopenedCount: number, attachmentCount: number, tags: Array<string>, customer: { id: string, code: string, kind: CustomerKind, displayName: string, legalName: string, tradeName: string | null, docType: DocumentType, docNumber: string, phone: string | null, whatsapp: string | null, email: string | null, status: CustomerStatus, tier: CustomerTier, churnRisk: ChurnRisk, district: string | null, province: string | null, department: string | null }, assignedUser: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } | null, technician: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } | null, product: { id: string, sku: string, name: string, kind: ProductKind, brand: string | null, model: string | null, unit: string, price: string, currency: string, imageUrl: string | null } | null } };

export type UpdateTicketMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  input: TicketUpdateInput;
}>;


export type UpdateTicketMutation = { updateTicket: { description: string | null, sourceReference: string | null, assignedAt: string | null, workStartedAt: string | null, firstResponseAt: string | null, resolvedAt: string | null, closedAt: string | null, escalatedAt: string | null, overdueReason: string | null, customerReplies: number, resolutionSummary: string | null, rootCause: string | null, satisfactionScore: number | null, satisfactionComment: string | null, createdAt: string, id: string, code: string, subject: string, type: TicketType, priority: TicketPriority, status: TicketStatus, channel: ContactChannel, openedAt: string, updatedAt: string, isOverdue: boolean, slaStatus: KpiStatus, elapsedMinutes: number, responseSlaMinutesLeft: number | null, resolutionSlaMinutesLeft: number | null, firstResponseDueAt: string | null, resolutionDueAt: string | null, firstResponseMinutes: number | null, resolutionMinutes: number | null, handlingMinutes: number, firstContactResolution: boolean, escalationLevel: number, reopenedCount: number, attachmentCount: number, tags: Array<string>, contact: { id: string, fullName: string, phone: string | null, email: string | null } | null, asset: { id: string, alias: string | null, serialNumber: string | null, hoursUsed: string, product: { id: string, sku: string, name: string, kind: ProductKind, brand: string | null, model: string | null, unit: string, price: string, currency: string, imageUrl: string | null } } | null, sale: { id: string, code: string, saleDate: string, total: string } | null, warranty: { id: string, code: string, status: WarrantyStatus, endDate: string, daysRemaining: number } | null, createdBy: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } | null, attachments: Array<{ id: string, kind: AttachmentKind, fileName: string, mimeType: string, sizeBytes: number, url: string, width: number | null, height: number | null, caption: string | null, createdAt: string, uploadedBy: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } | null }>, correctiveActions: Array<{ id: string, actionType: CorrectiveActionType, description: string, performedAt: string, durationMinutes: number | null, cost: string, result: string | null, isEffective: boolean | null, technician: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } | null }>, workLogs: Array<{ id: string, startedAt: string, endedAt: string | null, minutes: number | null, note: string | null, isRunning: boolean, user: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } }>, partRequests: Array<{ id: string, code: string, status: PartRequestStatus, quantity: string, underWarranty: boolean, total: string, requestedAt: string, neededBy: string | null, isOverdue: boolean, product: { id: string, sku: string, name: string, kind: ProductKind, brand: string | null, model: string | null, unit: string, price: string, currency: string, imageUrl: string | null } }>, customer: { id: string, code: string, kind: CustomerKind, displayName: string, legalName: string, tradeName: string | null, docType: DocumentType, docNumber: string, phone: string | null, whatsapp: string | null, email: string | null, status: CustomerStatus, tier: CustomerTier, churnRisk: ChurnRisk, district: string | null, province: string | null, department: string | null }, assignedUser: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } | null, technician: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } | null, product: { id: string, sku: string, name: string, kind: ProductKind, brand: string | null, model: string | null, unit: string, price: string, currency: string, imageUrl: string | null } | null } };

export type AssignTicketMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  userId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type AssignTicketMutation = { assignTicket: { id: string, code: string, subject: string, type: TicketType, priority: TicketPriority, status: TicketStatus, channel: ContactChannel, openedAt: string, updatedAt: string, isOverdue: boolean, slaStatus: KpiStatus, elapsedMinutes: number, responseSlaMinutesLeft: number | null, resolutionSlaMinutesLeft: number | null, firstResponseDueAt: string | null, resolutionDueAt: string | null, firstResponseMinutes: number | null, resolutionMinutes: number | null, handlingMinutes: number, firstContactResolution: boolean, escalationLevel: number, reopenedCount: number, attachmentCount: number, tags: Array<string>, customer: { id: string, code: string, kind: CustomerKind, displayName: string, legalName: string, tradeName: string | null, docType: DocumentType, docNumber: string, phone: string | null, whatsapp: string | null, email: string | null, status: CustomerStatus, tier: CustomerTier, churnRisk: ChurnRisk, district: string | null, province: string | null, department: string | null }, assignedUser: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } | null, technician: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } | null, product: { id: string, sku: string, name: string, kind: ProductKind, brand: string | null, model: string | null, unit: string, price: string, currency: string, imageUrl: string | null } | null } };

export type ChangeTicketStatusMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  status: TicketStatus;
  note?: InputMaybe<Scalars['String']['input']>;
}>;


export type ChangeTicketStatusMutation = { changeTicketStatus: { id: string, code: string, subject: string, type: TicketType, priority: TicketPriority, status: TicketStatus, channel: ContactChannel, openedAt: string, updatedAt: string, isOverdue: boolean, slaStatus: KpiStatus, elapsedMinutes: number, responseSlaMinutesLeft: number | null, resolutionSlaMinutesLeft: number | null, firstResponseDueAt: string | null, resolutionDueAt: string | null, firstResponseMinutes: number | null, resolutionMinutes: number | null, handlingMinutes: number, firstContactResolution: boolean, escalationLevel: number, reopenedCount: number, attachmentCount: number, tags: Array<string>, customer: { id: string, code: string, kind: CustomerKind, displayName: string, legalName: string, tradeName: string | null, docType: DocumentType, docNumber: string, phone: string | null, whatsapp: string | null, email: string | null, status: CustomerStatus, tier: CustomerTier, churnRisk: ChurnRisk, district: string | null, province: string | null, department: string | null }, assignedUser: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } | null, technician: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } | null, product: { id: string, sku: string, name: string, kind: ProductKind, brand: string | null, model: string | null, unit: string, price: string, currency: string, imageUrl: string | null } | null } };

export type ChangeTicketPriorityMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  priority: TicketPriority;
  reason?: InputMaybe<Scalars['String']['input']>;
}>;


export type ChangeTicketPriorityMutation = { changeTicketPriority: { id: string, code: string, subject: string, type: TicketType, priority: TicketPriority, status: TicketStatus, channel: ContactChannel, openedAt: string, updatedAt: string, isOverdue: boolean, slaStatus: KpiStatus, elapsedMinutes: number, responseSlaMinutesLeft: number | null, resolutionSlaMinutesLeft: number | null, firstResponseDueAt: string | null, resolutionDueAt: string | null, firstResponseMinutes: number | null, resolutionMinutes: number | null, handlingMinutes: number, firstContactResolution: boolean, escalationLevel: number, reopenedCount: number, attachmentCount: number, tags: Array<string>, customer: { id: string, code: string, kind: CustomerKind, displayName: string, legalName: string, tradeName: string | null, docType: DocumentType, docNumber: string, phone: string | null, whatsapp: string | null, email: string | null, status: CustomerStatus, tier: CustomerTier, churnRisk: ChurnRisk, district: string | null, province: string | null, department: string | null }, assignedUser: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } | null, technician: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } | null, product: { id: string, sku: string, name: string, kind: ProductKind, brand: string | null, model: string | null, unit: string, price: string, currency: string, imageUrl: string | null } | null } };

export type EscalateTicketMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  toUserId?: InputMaybe<Scalars['UUID']['input']>;
  reason: Scalars['String']['input'];
}>;


export type EscalateTicketMutation = { escalateTicket: { id: string, code: string, subject: string, type: TicketType, priority: TicketPriority, status: TicketStatus, channel: ContactChannel, openedAt: string, updatedAt: string, isOverdue: boolean, slaStatus: KpiStatus, elapsedMinutes: number, responseSlaMinutesLeft: number | null, resolutionSlaMinutesLeft: number | null, firstResponseDueAt: string | null, resolutionDueAt: string | null, firstResponseMinutes: number | null, resolutionMinutes: number | null, handlingMinutes: number, firstContactResolution: boolean, escalationLevel: number, reopenedCount: number, attachmentCount: number, tags: Array<string>, customer: { id: string, code: string, kind: CustomerKind, displayName: string, legalName: string, tradeName: string | null, docType: DocumentType, docNumber: string, phone: string | null, whatsapp: string | null, email: string | null, status: CustomerStatus, tier: CustomerTier, churnRisk: ChurnRisk, district: string | null, province: string | null, department: string | null }, assignedUser: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } | null, technician: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } | null, product: { id: string, sku: string, name: string, kind: ProductKind, brand: string | null, model: string | null, unit: string, price: string, currency: string, imageUrl: string | null } | null } };

export type ResolveTicketMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  resolutionSummary: Scalars['String']['input'];
  rootCause?: InputMaybe<Scalars['String']['input']>;
}>;


export type ResolveTicketMutation = { resolveTicket: { resolutionSummary: string | null, rootCause: string | null, resolvedAt: string | null, id: string, code: string, subject: string, type: TicketType, priority: TicketPriority, status: TicketStatus, channel: ContactChannel, openedAt: string, updatedAt: string, isOverdue: boolean, slaStatus: KpiStatus, elapsedMinutes: number, responseSlaMinutesLeft: number | null, resolutionSlaMinutesLeft: number | null, firstResponseDueAt: string | null, resolutionDueAt: string | null, firstResponseMinutes: number | null, resolutionMinutes: number | null, handlingMinutes: number, firstContactResolution: boolean, escalationLevel: number, reopenedCount: number, attachmentCount: number, tags: Array<string>, customer: { id: string, code: string, kind: CustomerKind, displayName: string, legalName: string, tradeName: string | null, docType: DocumentType, docNumber: string, phone: string | null, whatsapp: string | null, email: string | null, status: CustomerStatus, tier: CustomerTier, churnRisk: ChurnRisk, district: string | null, province: string | null, department: string | null }, assignedUser: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } | null, technician: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } | null, product: { id: string, sku: string, name: string, kind: ProductKind, brand: string | null, model: string | null, unit: string, price: string, currency: string, imageUrl: string | null } | null } };

export type ReopenTicketMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  reason: Scalars['String']['input'];
}>;


export type ReopenTicketMutation = { reopenTicket: { id: string, code: string, subject: string, type: TicketType, priority: TicketPriority, status: TicketStatus, channel: ContactChannel, openedAt: string, updatedAt: string, isOverdue: boolean, slaStatus: KpiStatus, elapsedMinutes: number, responseSlaMinutesLeft: number | null, resolutionSlaMinutesLeft: number | null, firstResponseDueAt: string | null, resolutionDueAt: string | null, firstResponseMinutes: number | null, resolutionMinutes: number | null, handlingMinutes: number, firstContactResolution: boolean, escalationLevel: number, reopenedCount: number, attachmentCount: number, tags: Array<string>, customer: { id: string, code: string, kind: CustomerKind, displayName: string, legalName: string, tradeName: string | null, docType: DocumentType, docNumber: string, phone: string | null, whatsapp: string | null, email: string | null, status: CustomerStatus, tier: CustomerTier, churnRisk: ChurnRisk, district: string | null, province: string | null, department: string | null }, assignedUser: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } | null, technician: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } | null, product: { id: string, sku: string, name: string, kind: ProductKind, brand: string | null, model: string | null, unit: string, price: string, currency: string, imageUrl: string | null } | null } };

export type CloseTicketMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type CloseTicketMutation = { closeTicket: { id: string, code: string, subject: string, type: TicketType, priority: TicketPriority, status: TicketStatus, channel: ContactChannel, openedAt: string, updatedAt: string, isOverdue: boolean, slaStatus: KpiStatus, elapsedMinutes: number, responseSlaMinutesLeft: number | null, resolutionSlaMinutesLeft: number | null, firstResponseDueAt: string | null, resolutionDueAt: string | null, firstResponseMinutes: number | null, resolutionMinutes: number | null, handlingMinutes: number, firstContactResolution: boolean, escalationLevel: number, reopenedCount: number, attachmentCount: number, tags: Array<string>, customer: { id: string, code: string, kind: CustomerKind, displayName: string, legalName: string, tradeName: string | null, docType: DocumentType, docNumber: string, phone: string | null, whatsapp: string | null, email: string | null, status: CustomerStatus, tier: CustomerTier, churnRisk: ChurnRisk, district: string | null, province: string | null, department: string | null }, assignedUser: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } | null, technician: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } | null, product: { id: string, sku: string, name: string, kind: ProductKind, brand: string | null, model: string | null, unit: string, price: string, currency: string, imageUrl: string | null } | null } };

export type ReplyToTicketMutationVariables = Exact<{
  input: TicketReplyInput;
}>;


export type ReplyToTicketMutation = { replyToTicket: { id: string, kind: TicketEventKind, body: string | null, isPublic: boolean, channel: ContactChannel | null, fromStatus: TicketStatus | null, toStatus: TicketStatus | null, metadata: Record<string, unknown>, occurredAt: string, actorUser: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } | null, actorContact: { id: string, fullName: string } | null, fromUser: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } | null, toUser: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } | null, attachments: Array<{ id: string, kind: AttachmentKind, fileName: string, mimeType: string, sizeBytes: number, url: string, width: number | null, height: number | null, caption: string | null, createdAt: string, uploadedBy: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } | null }> } };

export type AddTicketNoteMutationVariables = Exact<{
  ticketId: Scalars['UUID']['input'];
  body: Scalars['String']['input'];
}>;


export type AddTicketNoteMutation = { addTicketNote: { id: string, kind: TicketEventKind, body: string | null, isPublic: boolean, channel: ContactChannel | null, fromStatus: TicketStatus | null, toStatus: TicketStatus | null, metadata: Record<string, unknown>, occurredAt: string, actorUser: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } | null, actorContact: { id: string, fullName: string } | null, fromUser: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } | null, toUser: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } | null, attachments: Array<{ id: string, kind: AttachmentKind, fileName: string, mimeType: string, sizeBytes: number, url: string, width: number | null, height: number | null, caption: string | null, createdAt: string, uploadedBy: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } | null }> } };

export type AddCorrectiveActionMutationVariables = Exact<{
  input: CorrectiveActionInput;
}>;


export type AddCorrectiveActionMutation = { addCorrectiveAction: { id: string, actionType: CorrectiveActionType, description: string, performedAt: string, durationMinutes: number | null, cost: string, result: string | null, isEffective: boolean | null, technician: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } | null } };

export type RateTicketMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  score: Scalars['Int']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
}>;


export type RateTicketMutation = { rateTicket: { id: string, satisfactionScore: number | null, satisfactionComment: string | null } };

export type StartWorkMutationVariables = Exact<{
  ticketId: Scalars['UUID']['input'];
}>;


export type StartWorkMutation = { startWork: { id: string, startedAt: string, endedAt: string | null, minutes: number | null, isRunning: boolean, user: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } } };

export type StopWorkMutationVariables = Exact<{
  workLogId: Scalars['UUID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
}>;


export type StopWorkMutation = { stopWork: { id: string, startedAt: string, endedAt: string | null, minutes: number | null, note: string | null, isRunning: boolean } };

export type UploadAttachmentMutationVariables = Exact<{
  ticketId: Scalars['UUID']['input'];
  file: Scalars['Upload']['input'];
  kind?: InputMaybe<AttachmentKind>;
  caption?: InputMaybe<Scalars['String']['input']>;
}>;


export type UploadAttachmentMutation = { uploadAttachment: { id: string, kind: AttachmentKind, fileName: string, mimeType: string, sizeBytes: number, url: string, width: number | null, height: number | null, caption: string | null, createdAt: string, uploadedBy: { id: string, code: string, fullName: string, email: string | null, phone: string | null, role: UserRole, jobTitle: string | null, avatarUrl: string | null, isActive: boolean } | null } };

export type DeleteAttachmentMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DeleteAttachmentMutation = { deleteAttachment: boolean };

export const CustomerBriefFragmentDoc = gql`
    fragment CustomerBrief on Customer {
  id
  code
  kind
  displayName
  legalName
  tradeName
  docType
  docNumber
  phone
  whatsapp
  email
  status
  tier
  churnRisk
  district
  province
  department
}
    `;
export const UserBriefFragmentDoc = gql`
    fragment UserBrief on User {
  id
  code
  fullName
  email
  phone
  role
  jobTitle
  avatarUrl
  isActive
}
    `;
export const CustomerRowFragmentDoc = gql`
    fragment CustomerRow on Customer {
  ...CustomerBrief
  churnScore
  churnReason
  lastPurchaseAt
  firstPurchaseAt
  purchaseCount
  lifetimeValue
  avgTicket
  daysSincePurchase
  source
  tags
  marketingOptIn
  openTicketCount
  ticketCount
  activeWarrantyCount
  nextFollowupAt
  createdAt
  updatedAt
  assignedUser {
    ...UserBrief
  }
}
    ${CustomerBriefFragmentDoc}
${UserBriefFragmentDoc}`;
export const ProductBriefFragmentDoc = gql`
    fragment ProductBrief on Product {
  id
  sku
  name
  kind
  brand
  model
  unit
  price
  currency
  imageUrl
}
    `;
export const ProductRowFragmentDoc = gql`
    fragment ProductRow on Product {
  ...ProductBrief
  description
  cost
  marginPct
  stock
  minStock
  reservedStock
  isLowStock
  warrantyMonths
  maintenanceIntervalDays
  isActive
  category {
    id
    name
    slug
  }
}
    ${ProductBriefFragmentDoc}`;
export const AttachmentFieldsFragmentDoc = gql`
    fragment AttachmentFields on TicketAttachment {
  id
  kind
  fileName
  mimeType
  sizeBytes
  url
  width
  height
  caption
  createdAt
  uploadedBy {
    ...UserBrief
  }
}
    ${UserBriefFragmentDoc}`;
export const TicketEventFieldsFragmentDoc = gql`
    fragment TicketEventFields on TicketEvent {
  id
  kind
  body
  isPublic
  channel
  fromStatus
  toStatus
  metadata
  occurredAt
  actorUser {
    ...UserBrief
  }
  actorContact {
    id
    fullName
  }
  fromUser {
    ...UserBrief
  }
  toUser {
    ...UserBrief
  }
  attachments {
    ...AttachmentFields
  }
}
    ${UserBriefFragmentDoc}
${AttachmentFieldsFragmentDoc}`;
export const TicketRowFragmentDoc = gql`
    fragment TicketRow on Ticket {
  id
  code
  subject
  type
  priority
  status
  channel
  openedAt
  updatedAt
  isOverdue
  slaStatus
  elapsedMinutes
  responseSlaMinutesLeft
  resolutionSlaMinutesLeft
  firstResponseDueAt
  resolutionDueAt
  firstResponseMinutes
  resolutionMinutes
  handlingMinutes
  firstContactResolution
  escalationLevel
  reopenedCount
  attachmentCount
  tags
  customer {
    ...CustomerBrief
  }
  assignedUser {
    ...UserBrief
  }
  technician {
    ...UserBrief
  }
  product {
    ...ProductBrief
  }
}
    ${CustomerBriefFragmentDoc}
${UserBriefFragmentDoc}
${ProductBriefFragmentDoc}`;
export const TicketDetailFragmentDoc = gql`
    fragment TicketDetail on Ticket {
  ...TicketRow
  description
  sourceReference
  assignedAt
  workStartedAt
  firstResponseAt
  resolvedAt
  closedAt
  escalatedAt
  overdueReason
  customerReplies
  resolutionSummary
  rootCause
  satisfactionScore
  satisfactionComment
  createdAt
  contact {
    id
    fullName
    phone
    email
  }
  asset {
    id
    alias
    serialNumber
    hoursUsed
    product {
      ...ProductBrief
    }
  }
  sale {
    id
    code
    saleDate
    total
  }
  warranty {
    id
    code
    status
    endDate
    daysRemaining
  }
  createdBy {
    ...UserBrief
  }
  attachments {
    ...AttachmentFields
  }
  correctiveActions {
    id
    actionType
    description
    performedAt
    durationMinutes
    cost
    result
    isEffective
    technician {
      ...UserBrief
    }
  }
  workLogs {
    id
    startedAt
    endedAt
    minutes
    note
    isRunning
    user {
      ...UserBrief
    }
  }
  partRequests {
    id
    code
    status
    quantity
    underWarranty
    total
    requestedAt
    neededBy
    isOverdue
    product {
      ...ProductBrief
    }
  }
}
    ${TicketRowFragmentDoc}
${ProductBriefFragmentDoc}
${UserBriefFragmentDoc}
${AttachmentFieldsFragmentDoc}`;
export const PageFieldsFragmentDoc = gql`
    fragment PageFields on PageInfo {
  page
  pageSize
  totalCount
  totalPages
  hasNextPage
  hasPreviousPage
}
    `;
export const KpiValueFieldsFragmentDoc = gql`
    fragment KpiValueFields on KpiValue {
  key
  label
  unit
  dimension
  value
  numerator
  denominator
  sampleSize
  target
  goal
  status
  previousValue
  delta
  deltaPct
  improved
  baseline
  baselineImprovementPct
}
    `;
export const StatusCountFieldsFragmentDoc = gql`
    fragment StatusCountFields on StatusCount {
  key
  label
  count
  pct
}
    `;
export const ConversationRowFragmentDoc = gql`
    fragment ConversationRow on Conversation {
  id
  channel
  externalId
  status
  phone
  displayName
  avatarUrl
  canSendFreeform
  windowExpiresAt
  lastMessageAt
  lastMessagePreview
  unreadCount
  botGreetedAt
  handoffAt
  createdAt
  customer {
    ...CustomerBrief
  }
  assignedUser {
    ...UserBrief
  }
  ticket {
    id
    code
    status
    subject
  }
}
    ${CustomerBriefFragmentDoc}
${UserBriefFragmentDoc}`;
export const MessageFieldsFragmentDoc = gql`
    fragment MessageFields on Message {
  id
  conversationId
  direction
  senderType
  kind
  body
  mediaUrl
  mediaMime
  mediaName
  latitude
  longitude
  templateName
  status
  errorMessage
  sentAt
  deliveredAt
  readAt
  createdAt
  senderUser {
    ...UserBrief
  }
  repliedTo {
    id
    body
    senderType
    kind
  }
}
    ${UserBriefFragmentDoc}`;
export const FollowupFieldsFragmentDoc = gql`
    fragment FollowupFields on Followup {
  id
  code
  type
  status
  title
  description
  scheduledAt
  durationMinutes
  location
  performedAt
  result
  outcomePositive
  nextActionAt
  isOverdue
  createdAt
  customer {
    ...CustomerBrief
  }
  assignedUser {
    ...UserBrief
  }
  ticket {
    id
    code
    subject
  }
}
    ${CustomerBriefFragmentDoc}
${UserBriefFragmentDoc}`;
export const WarrantyFieldsFragmentDoc = gql`
    fragment WarrantyFields on Warranty {
  id
  code
  serialNumber
  startDate
  endDate
  months
  status
  coverage
  terms
  claimCount
  daysRemaining
  createdAt
  customer {
    ...CustomerBrief
  }
  product {
    ...ProductBrief
  }
}
    ${CustomerBriefFragmentDoc}
${ProductBriefFragmentDoc}`;
export const PartRequestFieldsFragmentDoc = gql`
    fragment PartRequestFields on PartRequest {
  id
  code
  quantity
  status
  underWarranty
  unitPrice
  total
  supplier
  requestedAt
  neededBy
  quotedAt
  approvedAt
  shippedAt
  deliveredAt
  rejectedReason
  notes
  isOverdue
  customer {
    ...CustomerBrief
  }
  product {
    ...ProductBrief
  }
  ticket {
    id
    code
    subject
  }
  requestedBy {
    ...UserBrief
  }
}
    ${CustomerBriefFragmentDoc}
${ProductBriefFragmentDoc}
${UserBriefFragmentDoc}`;
export const CampaignFieldsFragmentDoc = gql`
    fragment CampaignFields on Campaign {
  id
  code
  name
  description
  channel
  status
  messageBody
  mediaUrl
  audienceFilter
  attributionDays
  scheduledAt
  startedAt
  finishedAt
  totalRecipients
  sentCount
  deliveredCount
  readCount
  repliedCount
  failedCount
  convertedCount
  revenue
  cost
  deliveryRate
  readRate
  replyRate
  conversionRate
  roi
  createdAt
  template {
    id
    name
    body
    header
    footer
    variables
  }
  products {
    ...ProductBrief
  }
  createdBy {
    ...UserBrief
  }
}
    ${ProductBriefFragmentDoc}
${UserBriefFragmentDoc}`;
export const NotificationFieldsFragmentDoc = gql`
    fragment NotificationFields on Notification {
  id
  kind
  title
  body
  entity
  entityId
  deepLink
  readAt
  createdAt
}
    `;
export const MeDocument = gql`
    query Me {
  me {
    ...UserBrief
    maxOpenTickets
    lastLoginAt
    createdAt
    workload {
      openTickets
      newTickets
      overdueTickets
      avgTpaHours
      avgMttrHours
      fcrPct
    }
  }
}
    ${UserBriefFragmentDoc}`;
export const LoginDocument = gql`
    mutation Login($email: String!, $password: String!, $device: String) {
  login(email: $email, password: $password, device: $device) {
    accessToken
    refreshToken
    expiresIn
    mustChangePassword
    user {
      ...UserBrief
    }
  }
}
    ${UserBriefFragmentDoc}`;
export const RefreshTokenDocument = gql`
    mutation RefreshToken($refreshToken: String!) {
  refreshToken(refreshToken: $refreshToken) {
    accessToken
    refreshToken
    expiresIn
    mustChangePassword
    user {
      ...UserBrief
    }
  }
}
    ${UserBriefFragmentDoc}`;
export const LogoutDocument = gql`
    mutation Logout($refreshToken: String) {
  logout(refreshToken: $refreshToken)
}
    `;
export const ChangePasswordDocument = gql`
    mutation ChangePassword($currentPassword: String!, $newPassword: String!) {
  changePassword(currentPassword: $currentPassword, newPassword: $newPassword)
}
    `;
export const UsersDocument = gql`
    query Users($role: [UserRole!], $isActive: Boolean, $search: String) {
  users(role: $role, isActive: $isActive, search: $search) {
    ...UserBrief
    maxOpenTickets
    lastLoginAt
    createdAt
    workload {
      openTickets
      newTickets
      overdueTickets
      avgTpaHours
      avgMttrHours
      fcrPct
    }
  }
}
    ${UserBriefFragmentDoc}`;
export const CreateUserDocument = gql`
    mutation CreateUser($fullName: String!, $email: String!, $password: String!, $role: UserRole!, $phone: String, $jobTitle: String) {
  createUser(
    fullName: $fullName
    email: $email
    password: $password
    role: $role
    phone: $phone
    jobTitle: $jobTitle
  ) {
    ...UserBrief
  }
}
    ${UserBriefFragmentDoc}`;
export const UpdateUserDocument = gql`
    mutation UpdateUser($id: UUID!, $fullName: String, $email: String, $phone: String, $role: UserRole, $jobTitle: String, $isActive: Boolean, $maxOpenTickets: Int) {
  updateUser(
    id: $id
    fullName: $fullName
    email: $email
    phone: $phone
    role: $role
    jobTitle: $jobTitle
    isActive: $isActive
    maxOpenTickets: $maxOpenTickets
  ) {
    ...UserBrief
    maxOpenTickets
  }
}
    ${UserBriefFragmentDoc}`;
export const ResetUserPasswordDocument = gql`
    mutation ResetUserPassword($id: UUID!, $newPassword: String!) {
  resetUserPassword(id: $id, newPassword: $newPassword)
}
    `;
export const CampaignRecipientsDocument = gql`
    query CampaignRecipients($id: UUID!, $status: [CampaignRecipientStatus!], $page: PageInput) {
  campaign(id: $id) {
    id
    recipients(status: $status, page: $page) {
      nodes {
        id
        status
        phone
        sentAt
        deliveredAt
        readAt
        repliedAt
        error
        excludedReason
        customer {
          ...CustomerBrief
        }
        convertedSale {
          id
          code
          total
        }
      }
      pageInfo {
        ...PageFields
      }
    }
  }
}
    ${CustomerBriefFragmentDoc}
${PageFieldsFragmentDoc}`;
export const CustomersDocument = gql`
    query Customers($filter: CustomerFilter, $sort: CustomerSort, $page: PageInput) {
  customers(filter: $filter, sort: $sort, page: $page) {
    nodes {
      ...CustomerRow
    }
    pageInfo {
      ...PageFields
    }
  }
}
    ${CustomerRowFragmentDoc}
${PageFieldsFragmentDoc}`;
export const CustomerDetailDocument = gql`
    query CustomerDetail($id: UUID!) {
  customer(id: $id) {
    ...CustomerRow
    address
    latitude
    longitude
    notes
    contacts {
      id
      fullName
      jobTitle
      phone
      whatsapp
      email
      isPrimary
      notes
    }
    crops {
      id
      cropName
      variety
      hectares
      seasonStart
      seasonEnd
      location
      notes
    }
    assets {
      id
      serialNumber
      alias
      purchasedAt
      installedAt
      hoursUsed
      lastMaintenanceAt
      nextMaintenanceAt
      location
      isActive
      notes
      product {
        ...ProductBrief
      }
      warranty {
        id
        code
        status
        endDate
        daysRemaining
      }
    }
    warranties {
      ...WarrantyFields
    }
    followups {
      ...FollowupFields
    }
    conversation {
      ...ConversationRow
    }
  }
}
    ${CustomerRowFragmentDoc}
${ProductBriefFragmentDoc}
${WarrantyFieldsFragmentDoc}
${FollowupFieldsFragmentDoc}
${ConversationRowFragmentDoc}`;
export const CustomerSalesDocument = gql`
    query CustomerSales($id: UUID!, $page: PageInput) {
  customer(id: $id) {
    id
    sales(page: $page) {
      nodes {
        id
        code
        saleDate
        status
        channel
        subtotal
        discount
        tax
        total
        currency
        invoiceNumber
        salesperson {
          ...UserBrief
        }
        items {
          id
          quantity
          unitPrice
          discount
          total
          warrantyMonths
          serialNumbers
          product {
            ...ProductBrief
          }
        }
      }
      pageInfo {
        ...PageFields
      }
    }
  }
}
    ${UserBriefFragmentDoc}
${ProductBriefFragmentDoc}
${PageFieldsFragmentDoc}`;
export const CustomerTicketsDocument = gql`
    query CustomerTickets($id: UUID!, $status: [TicketStatus!], $page: PageInput) {
  customer(id: $id) {
    id
    tickets(status: $status, page: $page) {
      nodes {
        ...TicketRow
      }
      pageInfo {
        ...PageFields
      }
    }
  }
}
    ${TicketRowFragmentDoc}
${PageFieldsFragmentDoc}`;
export const CustomerSearchDocument = gql`
    query CustomerSearch($query: String!, $limit: Int) {
  customerSearch(query: $query, limit: $limit) {
    ...CustomerBrief
    openTicketCount
    lastPurchaseAt
  }
}
    ${CustomerBriefFragmentDoc}`;
export const CreateCustomerDocument = gql`
    mutation CreateCustomer($input: CustomerInput!) {
  createCustomer(input: $input) {
    ...CustomerRow
  }
}
    ${CustomerRowFragmentDoc}`;
export const UpdateCustomerDocument = gql`
    mutation UpdateCustomer($id: UUID!, $input: CustomerInput!) {
  updateCustomer(id: $id, input: $input) {
    ...CustomerRow
  }
}
    ${CustomerRowFragmentDoc}`;
export const DeleteCustomerDocument = gql`
    mutation DeleteCustomer($id: UUID!) {
  deleteCustomer(id: $id)
}
    `;
export const AddCustomerContactDocument = gql`
    mutation AddCustomerContact($customerId: UUID!, $input: CustomerContactInput!) {
  addCustomerContact(customerId: $customerId, input: $input) {
    id
    fullName
    jobTitle
    phone
    whatsapp
    email
    isPrimary
    notes
  }
}
    `;
export const UpdateCustomerContactDocument = gql`
    mutation UpdateCustomerContact($id: UUID!, $input: CustomerContactInput!) {
  updateCustomerContact(id: $id, input: $input) {
    id
    fullName
    jobTitle
    phone
    whatsapp
    email
    isPrimary
    notes
  }
}
    `;
export const DeleteCustomerContactDocument = gql`
    mutation DeleteCustomerContact($id: UUID!) {
  deleteCustomerContact(id: $id)
}
    `;
export const AddCustomerCropDocument = gql`
    mutation AddCustomerCrop($customerId: UUID!, $input: CustomerCropInput!) {
  addCustomerCrop(customerId: $customerId, input: $input) {
    id
    cropName
    variety
    hectares
    seasonStart
    seasonEnd
    location
    notes
  }
}
    `;
export const UpdateCustomerCropDocument = gql`
    mutation UpdateCustomerCrop($id: UUID!, $input: CustomerCropInput!) {
  updateCustomerCrop(id: $id, input: $input) {
    id
    cropName
    variety
    hectares
    location
  }
}
    `;
export const DeleteCustomerCropDocument = gql`
    mutation DeleteCustomerCrop($id: UUID!) {
  deleteCustomerCrop(id: $id)
}
    `;
export const AddCustomerAssetDocument = gql`
    mutation AddCustomerAsset($customerId: UUID!, $input: CustomerAssetInput!) {
  addCustomerAsset(customerId: $customerId, input: $input) {
    id
    alias
    serialNumber
    hoursUsed
    purchasedAt
    nextMaintenanceAt
    location
    isActive
    product {
      ...ProductBrief
    }
  }
}
    ${ProductBriefFragmentDoc}`;
export const DeleteCustomerAssetDocument = gql`
    mutation DeleteCustomerAsset($id: UUID!) {
  deleteCustomerAsset(id: $id)
}
    `;
export const UpdateCustomerAssetDocument = gql`
    mutation UpdateCustomerAsset($id: UUID!, $input: CustomerAssetInput!) {
  updateCustomerAsset(id: $id, input: $input) {
    id
    alias
    serialNumber
    hoursUsed
    nextMaintenanceAt
    location
    isActive
  }
}
    `;
export const DashboardDocument = gql`
    query Dashboard($range: DateRangeInput) {
  dashboard(range: $range) {
    range {
      from
      to
    }
    activeCustomers
    newCustomers
    openTickets
    overdueTickets
    ticketsCreated
    ticketsResolved
    resolvedPct
    unreadConversations
    scheduledFollowupsToday
    warrantiesExpiringSoon
    pendingPartRequests
    kpis {
      ...KpiValueFields
    }
    ticketsByStatus {
      ...StatusCountFields
    }
    ticketsByPriority {
      ...StatusCountFields
    }
    ticketsByChannel {
      ...StatusCountFields
    }
    ticketsByType {
      ...StatusCountFields
    }
    customersByTier {
      ...StatusCountFields
    }
    topProducts {
      unitsSold
      revenue
      margin
      customerCount
      ticketCount
      claimRate
      product {
        ...ProductBrief
      }
    }
    topClaimedProducts {
      unitsSold
      revenue
      margin
      customerCount
      ticketCount
      claimRate
      product {
        ...ProductBrief
      }
    }
    agentLeaderboard {
      ...UserBrief
      workload {
        openTickets
        newTickets
        overdueTickets
        avgTpaHours
        avgMttrHours
        fcrPct
      }
    }
    customersAtRisk {
      ...CustomerBrief
      churnScore
      churnReason
      lastPurchaseAt
      daysSincePurchase
      lifetimeValue
      openTicketCount
    }
  }
}
    ${KpiValueFieldsFragmentDoc}
${StatusCountFieldsFragmentDoc}
${ProductBriefFragmentDoc}
${UserBriefFragmentDoc}
${CustomerBriefFragmentDoc}`;
export const KpisDocument = gql`
    query Kpis($keys: [String!], $range: DateRangeInput) {
  kpis(keys: $keys, range: $range) {
    ...KpiValueFields
  }
}
    ${KpiValueFieldsFragmentDoc}`;
export const KpiSeriesQueryDocument = gql`
    query KpiSeriesQuery($key: String!, $range: DateRangeInput!, $granularity: KpiGranularity!) {
  kpiSeries(key: $key, range: $range, granularity: $granularity) {
    key
    label
    unit
    target
    goal
    granularity
    points {
      periodStart
      periodEnd
      value
      numerator
      denominator
      sampleSize
    }
  }
}
    `;
export const ConversationsDocument = gql`
    query Conversations($filter: ConversationFilter, $page: PageInput) {
  conversations(filter: $filter, page: $page) {
    nodes {
      ...ConversationRow
    }
    pageInfo {
      ...PageFields
    }
  }
}
    ${ConversationRowFragmentDoc}
${PageFieldsFragmentDoc}`;
export const ConversationDetailDocument = gql`
    query ConversationDetail($id: UUID!, $page: PageInput) {
  conversation(id: $id) {
    ...ConversationRow
    contact {
      id
      fullName
      phone
      email
    }
    messages(page: $page) {
      nodes {
        ...MessageFields
      }
      pageInfo {
        ...PageFields
      }
    }
  }
}
    ${ConversationRowFragmentDoc}
${MessageFieldsFragmentDoc}
${PageFieldsFragmentDoc}`;
export const MessageTemplatesDocument = gql`
    query MessageTemplates($channel: ContactChannel, $activeOnly: Boolean) {
  messageTemplates(channel: $channel, activeOnly: $activeOnly) {
    id
    name
    channel
    language
    category
    header
    body
    footer
    variables
    providerStatus
    isActive
  }
}
    `;
export const SendMessageDocument = gql`
    mutation SendMessage($input: SendMessageInput!) {
  sendMessage(input: $input) {
    ...MessageFields
  }
}
    ${MessageFieldsFragmentDoc}`;
export const MarkConversationReadDocument = gql`
    mutation MarkConversationRead($id: UUID!) {
  markConversationRead(id: $id) {
    id
    unreadCount
  }
}
    `;
export const AssignConversationDocument = gql`
    mutation AssignConversation($id: UUID!, $userId: UUID) {
  assignConversation(id: $id, userId: $userId) {
    ...ConversationRow
  }
}
    ${ConversationRowFragmentDoc}`;
export const CloseConversationDocument = gql`
    mutation CloseConversation($id: UUID!) {
  closeConversation(id: $id) {
    ...ConversationRow
  }
}
    ${ConversationRowFragmentDoc}`;
export const HandoffConversationDocument = gql`
    mutation HandoffConversation($id: UUID!, $userId: UUID) {
  handoffConversation(id: $id, userId: $userId) {
    ...ConversationRow
  }
}
    ${ConversationRowFragmentDoc}`;
export const LinkConversationToCustomerDocument = gql`
    mutation LinkConversationToCustomer($conversationId: UUID!, $customerId: UUID, $newCustomer: CustomerInput) {
  linkConversationToCustomer(
    conversationId: $conversationId
    customerId: $customerId
    newCustomer: $newCustomer
  ) {
    ...ConversationRow
  }
}
    ${ConversationRowFragmentDoc}`;
export const CreateTicketFromConversationDocument = gql`
    mutation CreateTicketFromConversation($conversationId: UUID!, $input: TicketInput) {
  createTicketFromConversation(conversationId: $conversationId, input: $input) {
    ...TicketRow
  }
}
    ${TicketRowFragmentDoc}`;
export const BotRulesDocument = gql`
    query BotRules($activeOnly: Boolean) {
  botRules(activeOnly: $activeOnly) {
    id
    name
    keywords
    pattern
    action
    response
    params
    priority
    isActive
    matchCount
  }
}
    `;
export const CreateBotRuleDocument = gql`
    mutation CreateBotRule($input: BotRuleInput!) {
  createBotRule(input: $input) {
    id
    name
    keywords
    pattern
    action
    response
    params
    priority
    isActive
    matchCount
  }
}
    `;
export const UpdateBotRuleDocument = gql`
    mutation UpdateBotRule($id: UUID!, $input: BotRuleInput!) {
  updateBotRule(id: $id, input: $input) {
    id
    name
    keywords
    pattern
    action
    response
    params
    priority
    isActive
    matchCount
  }
}
    `;
export const DeleteBotRuleDocument = gql`
    mutation DeleteBotRule($id: UUID!) {
  deleteBotRule(id: $id)
}
    `;
export const FollowupsDocument = gql`
    query Followups($filter: FollowupFilter, $page: PageInput) {
  followups(filter: $filter, page: $page) {
    nodes {
      ...FollowupFields
    }
    pageInfo {
      ...PageFields
    }
  }
}
    ${FollowupFieldsFragmentDoc}
${PageFieldsFragmentDoc}`;
export const AgendaDocument = gql`
    query Agenda($day: Date, $userId: UUID) {
  agenda(day: $day, userId: $userId) {
    ...FollowupFields
  }
}
    ${FollowupFieldsFragmentDoc}`;
export const CreateFollowupDocument = gql`
    mutation CreateFollowup($input: FollowupInput!) {
  createFollowup(input: $input) {
    ...FollowupFields
  }
}
    ${FollowupFieldsFragmentDoc}`;
export const UpdateFollowupDocument = gql`
    mutation UpdateFollowup($id: UUID!, $input: FollowupInput!) {
  updateFollowup(id: $id, input: $input) {
    ...FollowupFields
  }
}
    ${FollowupFieldsFragmentDoc}`;
export const CompleteFollowupDocument = gql`
    mutation CompleteFollowup($input: FollowupResultInput!) {
  completeFollowup(input: $input) {
    ...FollowupFields
  }
}
    ${FollowupFieldsFragmentDoc}`;
export const CancelFollowupDocument = gql`
    mutation CancelFollowup($id: UUID!, $reason: String) {
  cancelFollowup(id: $id, reason: $reason) {
    ...FollowupFields
  }
}
    ${FollowupFieldsFragmentDoc}`;
export const WarrantiesDocument = gql`
    query Warranties($filter: WarrantyFilter, $sort: WarrantySort, $page: PageInput) {
  warranties(filter: $filter, sort: $sort, page: $page) {
    nodes {
      ...WarrantyFields
    }
    pageInfo {
      ...PageFields
    }
  }
}
    ${WarrantyFieldsFragmentDoc}
${PageFieldsFragmentDoc}`;
export const CreateWarrantyDocument = gql`
    mutation CreateWarranty($input: WarrantyInput!) {
  createWarranty(input: $input) {
    ...WarrantyFields
  }
}
    ${WarrantyFieldsFragmentDoc}`;
export const VoidWarrantyDocument = gql`
    mutation VoidWarranty($id: UUID!, $reason: String!) {
  voidWarranty(id: $id, reason: $reason) {
    ...WarrantyFields
  }
}
    ${WarrantyFieldsFragmentDoc}`;
export const PartRequestsDocument = gql`
    query PartRequests($filter: PartRequestFilter, $sort: PartRequestSort, $page: PageInput) {
  partRequests(filter: $filter, sort: $sort, page: $page) {
    nodes {
      ...PartRequestFields
    }
    pageInfo {
      ...PageFields
    }
  }
}
    ${PartRequestFieldsFragmentDoc}
${PageFieldsFragmentDoc}`;
export const CreatePartRequestDocument = gql`
    mutation CreatePartRequest($input: PartRequestInput!) {
  createPartRequest(input: $input) {
    ...PartRequestFields
  }
}
    ${PartRequestFieldsFragmentDoc}`;
export const UpdatePartRequestStatusDocument = gql`
    mutation UpdatePartRequestStatus($id: UUID!, $status: PartRequestStatus!, $note: String) {
  updatePartRequestStatus(id: $id, status: $status, note: $note) {
    ...PartRequestFields
  }
}
    ${PartRequestFieldsFragmentDoc}`;
export const ProductsDocument = gql`
    query Products($filter: ProductFilter, $sort: ProductSort, $page: PageInput) {
  products(filter: $filter, sort: $sort, page: $page) {
    nodes {
      ...ProductRow
    }
    pageInfo {
      ...PageFields
    }
  }
}
    ${ProductRowFragmentDoc}
${PageFieldsFragmentDoc}`;
export const ProductDetailDocument = gql`
    query ProductDetail($id: UUID!, $range: DateRangeInput) {
  product(id: $id) {
    ...ProductRow
    attributes
    compatibleParts {
      ...ProductBrief
      stock
      minStock
      isLowStock
    }
    fitsMachines {
      ...ProductBrief
    }
    performance(range: $range) {
      unitsSold
      revenue
      margin
      customerCount
      ticketCount
      claimRate
    }
  }
}
    ${ProductRowFragmentDoc}
${ProductBriefFragmentDoc}`;
export const ProductCategoriesDocument = gql`
    query ProductCategories {
  productCategories {
    id
    name
    slug
    productCount
    parent {
      id
      name
    }
  }
}
    `;
export const CreateProductDocument = gql`
    mutation CreateProduct($input: ProductInput!) {
  createProduct(input: $input) {
    ...ProductRow
  }
}
    ${ProductRowFragmentDoc}`;
export const UpdateProductDocument = gql`
    mutation UpdateProduct($id: UUID!, $input: ProductInput!) {
  updateProduct(id: $id, input: $input) {
    ...ProductRow
  }
}
    ${ProductRowFragmentDoc}`;
export const AdjustStockDocument = gql`
    mutation AdjustStock($productId: UUID!, $delta: Int!, $reason: String) {
  adjustStock(productId: $productId, delta: $delta, reason: $reason) {
    id
    stock
    minStock
    isLowStock
  }
}
    `;
export const SetProductCompatibilityDocument = gql`
    mutation SetProductCompatibility($machineId: UUID!, $partIds: [UUID!]!) {
  setProductCompatibility(machineId: $machineId, partIds: $partIds) {
    id
    compatibleParts {
      ...ProductBrief
    }
  }
}
    ${ProductBriefFragmentDoc}`;
export const CampaignsDocument = gql`
    query Campaigns($filter: CampaignFilter, $page: PageInput) {
  campaigns(filter: $filter, page: $page) {
    nodes {
      ...CampaignFields
    }
    pageInfo {
      ...PageFields
    }
  }
}
    ${CampaignFieldsFragmentDoc}
${PageFieldsFragmentDoc}`;
export const CampaignDetailDocument = gql`
    query CampaignDetail($id: UUID!, $page: PageInput) {
  campaign(id: $id) {
    ...CampaignFields
    recipients(page: $page) {
      nodes {
        id
        status
        phone
        sentAt
        deliveredAt
        readAt
        repliedAt
        error
        excludedReason
        customer {
          ...CustomerBrief
        }
        convertedSale {
          id
          code
          total
        }
      }
      pageInfo {
        ...PageFields
      }
    }
  }
}
    ${CampaignFieldsFragmentDoc}
${CustomerBriefFragmentDoc}
${PageFieldsFragmentDoc}`;
export const AudiencePreviewDocument = gql`
    query AudiencePreview($filter: CustomerFilter!, $sampleSize: Int) {
  audiencePreview(filter: $filter, sampleSize: $sampleSize) {
    totalMatched
    reachable
    excludedNoWhatsapp
    excludedOptOut
    sample {
      ...CustomerBrief
    }
  }
}
    ${CustomerBriefFragmentDoc}`;
export const CreateCampaignDocument = gql`
    mutation CreateCampaign($input: CampaignInput!) {
  createCampaign(input: $input) {
    ...CampaignFields
  }
}
    ${CampaignFieldsFragmentDoc}`;
export const UpdateCampaignDocument = gql`
    mutation UpdateCampaign($id: UUID!, $input: CampaignInput!) {
  updateCampaign(id: $id, input: $input) {
    ...CampaignFields
  }
}
    ${CampaignFieldsFragmentDoc}`;
export const LaunchCampaignDocument = gql`
    mutation LaunchCampaign($id: UUID!) {
  launchCampaign(id: $id) {
    ...CampaignFields
  }
}
    ${CampaignFieldsFragmentDoc}`;
export const CancelCampaignDocument = gql`
    mutation CancelCampaign($id: UUID!) {
  cancelCampaign(id: $id) {
    ...CampaignFields
  }
}
    ${CampaignFieldsFragmentDoc}`;
export const DeleteCampaignDocument = gql`
    mutation DeleteCampaign($id: UUID!) {
  deleteCampaign(id: $id)
}
    `;
export const SalesDocument = gql`
    query Sales($filter: SaleFilter, $page: PageInput) {
  sales(filter: $filter, page: $page) {
    nodes {
      id
      code
      saleDate
      status
      channel
      total
      currency
      invoiceNumber
      customer {
        ...CustomerBrief
      }
      salesperson {
        ...UserBrief
      }
    }
    pageInfo {
      ...PageFields
    }
  }
}
    ${CustomerBriefFragmentDoc}
${UserBriefFragmentDoc}
${PageFieldsFragmentDoc}`;
export const NotificationsDocument = gql`
    query Notifications($unreadOnly: Boolean, $page: PageInput) {
  notifications(unreadOnly: $unreadOnly, page: $page) {
    ...NotificationFields
  }
}
    ${NotificationFieldsFragmentDoc}`;
export const UnreadNotificationCountDocument = gql`
    query UnreadNotificationCount {
  unreadNotificationCount
}
    `;
export const MarkNotificationReadDocument = gql`
    mutation MarkNotificationRead($id: UUID!) {
  markNotificationRead(id: $id) {
    ...NotificationFields
  }
}
    ${NotificationFieldsFragmentDoc}`;
export const MarkAllNotificationsReadDocument = gql`
    mutation MarkAllNotificationsRead {
  markAllNotificationsRead
}
    `;
export const SettingsDocument = gql`
    query Settings($keys: [String!]) {
  settings(keys: $keys) {
    key
    value
    description
    updatedAt
  }
}
    `;
export const UpdateSettingDocument = gql`
    mutation UpdateSetting($key: String!, $value: JSON!) {
  updateSetting(key: $key, value: $value) {
    key
    value
    description
    updatedAt
  }
}
    `;
export const KpiTargetsDocument = gql`
    query KpiTargets {
  kpiTargets {
    key
    label
    description
    dimension
    targetValue
    unit
    goal
    tolerancePct
    isActive
  }
}
    `;
export const UpdateKpiTargetDocument = gql`
    mutation UpdateKpiTarget($key: String!, $targetValue: Float!, $tolerancePct: Float) {
  updateKpiTarget(
    key: $key
    targetValue: $targetValue
    tolerancePct: $tolerancePct
  ) {
    key
    label
    targetValue
    tolerancePct
    unit
    goal
    dimension
    isActive
  }
}
    `;
export const SetKpiBaselineDocument = gql`
    mutation SetKpiBaseline($key: String!, $value: Float!, $periodStart: Date!, $periodEnd: Date!, $note: String) {
  setKpiBaseline(
    key: $key
    value: $value
    periodStart: $periodStart
    periodEnd: $periodEnd
    note: $note
  )
}
    `;
export const ImportJobsDocument = gql`
    query ImportJobs($kind: ImportKind, $page: PageInput) {
  importJobs(kind: $kind, page: $page) {
    id
    kind
    status
    fileName
    totalRows
    okRows
    errorRows
    errors
    dryRun
    createdAt
    finishedAt
    createdBy {
      ...UserBrief
    }
  }
}
    ${UserBriefFragmentDoc}`;
export const ImportFromExcelDocument = gql`
    mutation ImportFromExcel($kind: ImportKind!, $file: Upload!, $dryRun: Boolean) {
  importFromExcel(kind: $kind, file: $file, dryRun: $dryRun) {
    id
    kind
    status
    fileName
    totalRows
    okRows
    errorRows
    errors
    dryRun
    createdAt
    finishedAt
  }
}
    `;
export const UploadFileDocument = gql`
    mutation UploadFile($file: Upload!) {
  uploadFile(file: $file) {
    id
    fileName
    mimeType
    sizeBytes
    url
  }
}
    `;
export const TicketsDocument = gql`
    query Tickets($filter: TicketFilter, $sort: TicketSort, $page: PageInput) {
  tickets(filter: $filter, sort: $sort, page: $page) {
    nodes {
      ...TicketRow
    }
    pageInfo {
      ...PageFields
    }
  }
}
    ${TicketRowFragmentDoc}
${PageFieldsFragmentDoc}`;
export const MyTicketsDocument = gql`
    query MyTickets($status: [TicketStatus!], $page: PageInput) {
  myTickets(status: $status, page: $page) {
    nodes {
      ...TicketRow
    }
    pageInfo {
      ...PageFields
    }
  }
}
    ${TicketRowFragmentDoc}
${PageFieldsFragmentDoc}`;
export const TicketDetailDocument = gql`
    query TicketDetail($id: UUID!) {
  ticket(id: $id) {
    ...TicketDetail
  }
}
    ${TicketDetailFragmentDoc}`;
export const TicketEventsDocument = gql`
    query TicketEvents($id: UUID!, $publicOnly: Boolean) {
  ticket(id: $id) {
    id
    events(publicOnly: $publicOnly) {
      ...TicketEventFields
    }
  }
}
    ${TicketEventFieldsFragmentDoc}`;
export const CreateTicketDocument = gql`
    mutation CreateTicket($input: TicketInput!) {
  createTicket(input: $input) {
    ...TicketRow
  }
}
    ${TicketRowFragmentDoc}`;
export const UpdateTicketDocument = gql`
    mutation UpdateTicket($id: UUID!, $input: TicketUpdateInput!) {
  updateTicket(id: $id, input: $input) {
    ...TicketDetail
  }
}
    ${TicketDetailFragmentDoc}`;
export const AssignTicketDocument = gql`
    mutation AssignTicket($id: UUID!, $userId: UUID) {
  assignTicket(id: $id, userId: $userId) {
    ...TicketRow
  }
}
    ${TicketRowFragmentDoc}`;
export const ChangeTicketStatusDocument = gql`
    mutation ChangeTicketStatus($id: UUID!, $status: TicketStatus!, $note: String) {
  changeTicketStatus(id: $id, status: $status, note: $note) {
    ...TicketRow
  }
}
    ${TicketRowFragmentDoc}`;
export const ChangeTicketPriorityDocument = gql`
    mutation ChangeTicketPriority($id: UUID!, $priority: TicketPriority!, $reason: String) {
  changeTicketPriority(id: $id, priority: $priority, reason: $reason) {
    ...TicketRow
  }
}
    ${TicketRowFragmentDoc}`;
export const EscalateTicketDocument = gql`
    mutation EscalateTicket($id: UUID!, $toUserId: UUID, $reason: String!) {
  escalateTicket(id: $id, toUserId: $toUserId, reason: $reason) {
    ...TicketRow
  }
}
    ${TicketRowFragmentDoc}`;
export const ResolveTicketDocument = gql`
    mutation ResolveTicket($id: UUID!, $resolutionSummary: String!, $rootCause: String) {
  resolveTicket(
    id: $id
    resolutionSummary: $resolutionSummary
    rootCause: $rootCause
  ) {
    ...TicketRow
    resolutionSummary
    rootCause
    resolvedAt
  }
}
    ${TicketRowFragmentDoc}`;
export const ReopenTicketDocument = gql`
    mutation ReopenTicket($id: UUID!, $reason: String!) {
  reopenTicket(id: $id, reason: $reason) {
    ...TicketRow
  }
}
    ${TicketRowFragmentDoc}`;
export const CloseTicketDocument = gql`
    mutation CloseTicket($id: UUID!) {
  closeTicket(id: $id) {
    ...TicketRow
  }
}
    ${TicketRowFragmentDoc}`;
export const ReplyToTicketDocument = gql`
    mutation ReplyToTicket($input: TicketReplyInput!) {
  replyToTicket(input: $input) {
    ...TicketEventFields
  }
}
    ${TicketEventFieldsFragmentDoc}`;
export const AddTicketNoteDocument = gql`
    mutation AddTicketNote($ticketId: UUID!, $body: String!) {
  addTicketNote(ticketId: $ticketId, body: $body) {
    ...TicketEventFields
  }
}
    ${TicketEventFieldsFragmentDoc}`;
export const AddCorrectiveActionDocument = gql`
    mutation AddCorrectiveAction($input: CorrectiveActionInput!) {
  addCorrectiveAction(input: $input) {
    id
    actionType
    description
    performedAt
    durationMinutes
    cost
    result
    isEffective
    technician {
      ...UserBrief
    }
  }
}
    ${UserBriefFragmentDoc}`;
export const RateTicketDocument = gql`
    mutation RateTicket($id: UUID!, $score: Int!, $comment: String) {
  rateTicket(id: $id, score: $score, comment: $comment) {
    id
    satisfactionScore
    satisfactionComment
  }
}
    `;
export const StartWorkDocument = gql`
    mutation StartWork($ticketId: UUID!) {
  startWork(ticketId: $ticketId) {
    id
    startedAt
    endedAt
    minutes
    isRunning
    user {
      ...UserBrief
    }
  }
}
    ${UserBriefFragmentDoc}`;
export const StopWorkDocument = gql`
    mutation StopWork($workLogId: UUID!, $note: String) {
  stopWork(workLogId: $workLogId, note: $note) {
    id
    startedAt
    endedAt
    minutes
    note
    isRunning
  }
}
    `;
export const UploadAttachmentDocument = gql`
    mutation UploadAttachment($ticketId: UUID!, $file: Upload!, $kind: AttachmentKind, $caption: String) {
  uploadAttachment(
    ticketId: $ticketId
    file: $file
    kind: $kind
    caption: $caption
  ) {
    ...AttachmentFields
  }
}
    ${AttachmentFieldsFragmentDoc}`;
export const DeleteAttachmentDocument = gql`
    mutation DeleteAttachment($id: UUID!) {
  deleteAttachment(id: $id)
}
    `;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string, variables?: any) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType, _variables) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    Me(variables?: MeQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<MeQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MeQuery>({ document: MeDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'Me', 'query', variables);
    },
    Login(variables: LoginMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<LoginMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<LoginMutation>({ document: LoginDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'Login', 'mutation', variables);
    },
    RefreshToken(variables: RefreshTokenMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<RefreshTokenMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RefreshTokenMutation>({ document: RefreshTokenDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'RefreshToken', 'mutation', variables);
    },
    Logout(variables?: LogoutMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<LogoutMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<LogoutMutation>({ document: LogoutDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'Logout', 'mutation', variables);
    },
    ChangePassword(variables: ChangePasswordMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ChangePasswordMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ChangePasswordMutation>({ document: ChangePasswordDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'ChangePassword', 'mutation', variables);
    },
    Users(variables?: UsersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UsersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UsersQuery>({ document: UsersDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'Users', 'query', variables);
    },
    CreateUser(variables: CreateUserMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CreateUserMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateUserMutation>({ document: CreateUserDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CreateUser', 'mutation', variables);
    },
    UpdateUser(variables: UpdateUserMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UpdateUserMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateUserMutation>({ document: UpdateUserDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'UpdateUser', 'mutation', variables);
    },
    ResetUserPassword(variables: ResetUserPasswordMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ResetUserPasswordMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ResetUserPasswordMutation>({ document: ResetUserPasswordDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'ResetUserPassword', 'mutation', variables);
    },
    CampaignRecipients(variables: CampaignRecipientsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CampaignRecipientsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CampaignRecipientsQuery>({ document: CampaignRecipientsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CampaignRecipients', 'query', variables);
    },
    Customers(variables?: CustomersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CustomersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CustomersQuery>({ document: CustomersDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'Customers', 'query', variables);
    },
    CustomerDetail(variables: CustomerDetailQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CustomerDetailQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CustomerDetailQuery>({ document: CustomerDetailDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CustomerDetail', 'query', variables);
    },
    CustomerSales(variables: CustomerSalesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CustomerSalesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CustomerSalesQuery>({ document: CustomerSalesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CustomerSales', 'query', variables);
    },
    CustomerTickets(variables: CustomerTicketsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CustomerTicketsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CustomerTicketsQuery>({ document: CustomerTicketsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CustomerTickets', 'query', variables);
    },
    CustomerSearch(variables: CustomerSearchQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CustomerSearchQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CustomerSearchQuery>({ document: CustomerSearchDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CustomerSearch', 'query', variables);
    },
    CreateCustomer(variables: CreateCustomerMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CreateCustomerMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateCustomerMutation>({ document: CreateCustomerDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CreateCustomer', 'mutation', variables);
    },
    UpdateCustomer(variables: UpdateCustomerMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UpdateCustomerMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateCustomerMutation>({ document: UpdateCustomerDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'UpdateCustomer', 'mutation', variables);
    },
    DeleteCustomer(variables: DeleteCustomerMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DeleteCustomerMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteCustomerMutation>({ document: DeleteCustomerDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'DeleteCustomer', 'mutation', variables);
    },
    AddCustomerContact(variables: AddCustomerContactMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AddCustomerContactMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddCustomerContactMutation>({ document: AddCustomerContactDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'AddCustomerContact', 'mutation', variables);
    },
    UpdateCustomerContact(variables: UpdateCustomerContactMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UpdateCustomerContactMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateCustomerContactMutation>({ document: UpdateCustomerContactDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'UpdateCustomerContact', 'mutation', variables);
    },
    DeleteCustomerContact(variables: DeleteCustomerContactMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DeleteCustomerContactMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteCustomerContactMutation>({ document: DeleteCustomerContactDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'DeleteCustomerContact', 'mutation', variables);
    },
    AddCustomerCrop(variables: AddCustomerCropMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AddCustomerCropMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddCustomerCropMutation>({ document: AddCustomerCropDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'AddCustomerCrop', 'mutation', variables);
    },
    UpdateCustomerCrop(variables: UpdateCustomerCropMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UpdateCustomerCropMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateCustomerCropMutation>({ document: UpdateCustomerCropDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'UpdateCustomerCrop', 'mutation', variables);
    },
    DeleteCustomerCrop(variables: DeleteCustomerCropMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DeleteCustomerCropMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteCustomerCropMutation>({ document: DeleteCustomerCropDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'DeleteCustomerCrop', 'mutation', variables);
    },
    AddCustomerAsset(variables: AddCustomerAssetMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AddCustomerAssetMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddCustomerAssetMutation>({ document: AddCustomerAssetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'AddCustomerAsset', 'mutation', variables);
    },
    DeleteCustomerAsset(variables: DeleteCustomerAssetMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DeleteCustomerAssetMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteCustomerAssetMutation>({ document: DeleteCustomerAssetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'DeleteCustomerAsset', 'mutation', variables);
    },
    UpdateCustomerAsset(variables: UpdateCustomerAssetMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UpdateCustomerAssetMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateCustomerAssetMutation>({ document: UpdateCustomerAssetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'UpdateCustomerAsset', 'mutation', variables);
    },
    Dashboard(variables?: DashboardQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DashboardQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DashboardQuery>({ document: DashboardDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'Dashboard', 'query', variables);
    },
    Kpis(variables?: KpisQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<KpisQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<KpisQuery>({ document: KpisDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'Kpis', 'query', variables);
    },
    KpiSeriesQuery(variables: KpiSeriesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<KpiSeriesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<KpiSeriesQuery>({ document: KpiSeriesQueryDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'KpiSeriesQuery', 'query', variables);
    },
    Conversations(variables?: ConversationsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ConversationsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ConversationsQuery>({ document: ConversationsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'Conversations', 'query', variables);
    },
    ConversationDetail(variables: ConversationDetailQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ConversationDetailQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ConversationDetailQuery>({ document: ConversationDetailDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'ConversationDetail', 'query', variables);
    },
    MessageTemplates(variables?: MessageTemplatesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<MessageTemplatesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MessageTemplatesQuery>({ document: MessageTemplatesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'MessageTemplates', 'query', variables);
    },
    SendMessage(variables: SendMessageMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SendMessageMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SendMessageMutation>({ document: SendMessageDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SendMessage', 'mutation', variables);
    },
    MarkConversationRead(variables: MarkConversationReadMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<MarkConversationReadMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MarkConversationReadMutation>({ document: MarkConversationReadDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'MarkConversationRead', 'mutation', variables);
    },
    AssignConversation(variables: AssignConversationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AssignConversationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AssignConversationMutation>({ document: AssignConversationDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'AssignConversation', 'mutation', variables);
    },
    CloseConversation(variables: CloseConversationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CloseConversationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CloseConversationMutation>({ document: CloseConversationDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CloseConversation', 'mutation', variables);
    },
    HandoffConversation(variables: HandoffConversationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<HandoffConversationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<HandoffConversationMutation>({ document: HandoffConversationDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'HandoffConversation', 'mutation', variables);
    },
    LinkConversationToCustomer(variables: LinkConversationToCustomerMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<LinkConversationToCustomerMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<LinkConversationToCustomerMutation>({ document: LinkConversationToCustomerDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'LinkConversationToCustomer', 'mutation', variables);
    },
    CreateTicketFromConversation(variables: CreateTicketFromConversationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CreateTicketFromConversationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateTicketFromConversationMutation>({ document: CreateTicketFromConversationDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CreateTicketFromConversation', 'mutation', variables);
    },
    BotRules(variables?: BotRulesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<BotRulesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BotRulesQuery>({ document: BotRulesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'BotRules', 'query', variables);
    },
    CreateBotRule(variables: CreateBotRuleMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CreateBotRuleMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateBotRuleMutation>({ document: CreateBotRuleDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CreateBotRule', 'mutation', variables);
    },
    UpdateBotRule(variables: UpdateBotRuleMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UpdateBotRuleMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateBotRuleMutation>({ document: UpdateBotRuleDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'UpdateBotRule', 'mutation', variables);
    },
    DeleteBotRule(variables: DeleteBotRuleMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DeleteBotRuleMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteBotRuleMutation>({ document: DeleteBotRuleDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'DeleteBotRule', 'mutation', variables);
    },
    Followups(variables?: FollowupsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<FollowupsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FollowupsQuery>({ document: FollowupsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'Followups', 'query', variables);
    },
    Agenda(variables?: AgendaQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AgendaQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AgendaQuery>({ document: AgendaDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'Agenda', 'query', variables);
    },
    CreateFollowup(variables: CreateFollowupMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CreateFollowupMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateFollowupMutation>({ document: CreateFollowupDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CreateFollowup', 'mutation', variables);
    },
    UpdateFollowup(variables: UpdateFollowupMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UpdateFollowupMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateFollowupMutation>({ document: UpdateFollowupDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'UpdateFollowup', 'mutation', variables);
    },
    CompleteFollowup(variables: CompleteFollowupMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CompleteFollowupMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CompleteFollowupMutation>({ document: CompleteFollowupDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CompleteFollowup', 'mutation', variables);
    },
    CancelFollowup(variables: CancelFollowupMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CancelFollowupMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CancelFollowupMutation>({ document: CancelFollowupDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CancelFollowup', 'mutation', variables);
    },
    Warranties(variables?: WarrantiesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<WarrantiesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<WarrantiesQuery>({ document: WarrantiesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'Warranties', 'query', variables);
    },
    CreateWarranty(variables: CreateWarrantyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CreateWarrantyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateWarrantyMutation>({ document: CreateWarrantyDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CreateWarranty', 'mutation', variables);
    },
    VoidWarranty(variables: VoidWarrantyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<VoidWarrantyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<VoidWarrantyMutation>({ document: VoidWarrantyDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'VoidWarranty', 'mutation', variables);
    },
    PartRequests(variables?: PartRequestsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PartRequestsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PartRequestsQuery>({ document: PartRequestsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'PartRequests', 'query', variables);
    },
    CreatePartRequest(variables: CreatePartRequestMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CreatePartRequestMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreatePartRequestMutation>({ document: CreatePartRequestDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CreatePartRequest', 'mutation', variables);
    },
    UpdatePartRequestStatus(variables: UpdatePartRequestStatusMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UpdatePartRequestStatusMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdatePartRequestStatusMutation>({ document: UpdatePartRequestStatusDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'UpdatePartRequestStatus', 'mutation', variables);
    },
    Products(variables?: ProductsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ProductsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProductsQuery>({ document: ProductsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'Products', 'query', variables);
    },
    ProductDetail(variables: ProductDetailQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ProductDetailQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProductDetailQuery>({ document: ProductDetailDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'ProductDetail', 'query', variables);
    },
    ProductCategories(variables?: ProductCategoriesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ProductCategoriesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProductCategoriesQuery>({ document: ProductCategoriesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'ProductCategories', 'query', variables);
    },
    CreateProduct(variables: CreateProductMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CreateProductMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateProductMutation>({ document: CreateProductDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CreateProduct', 'mutation', variables);
    },
    UpdateProduct(variables: UpdateProductMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UpdateProductMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateProductMutation>({ document: UpdateProductDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'UpdateProduct', 'mutation', variables);
    },
    AdjustStock(variables: AdjustStockMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AdjustStockMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdjustStockMutation>({ document: AdjustStockDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'AdjustStock', 'mutation', variables);
    },
    SetProductCompatibility(variables: SetProductCompatibilityMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SetProductCompatibilityMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SetProductCompatibilityMutation>({ document: SetProductCompatibilityDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SetProductCompatibility', 'mutation', variables);
    },
    Campaigns(variables?: CampaignsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CampaignsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CampaignsQuery>({ document: CampaignsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'Campaigns', 'query', variables);
    },
    CampaignDetail(variables: CampaignDetailQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CampaignDetailQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CampaignDetailQuery>({ document: CampaignDetailDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CampaignDetail', 'query', variables);
    },
    AudiencePreview(variables: AudiencePreviewQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AudiencePreviewQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AudiencePreviewQuery>({ document: AudiencePreviewDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'AudiencePreview', 'query', variables);
    },
    CreateCampaign(variables: CreateCampaignMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CreateCampaignMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateCampaignMutation>({ document: CreateCampaignDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CreateCampaign', 'mutation', variables);
    },
    UpdateCampaign(variables: UpdateCampaignMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UpdateCampaignMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateCampaignMutation>({ document: UpdateCampaignDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'UpdateCampaign', 'mutation', variables);
    },
    LaunchCampaign(variables: LaunchCampaignMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<LaunchCampaignMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<LaunchCampaignMutation>({ document: LaunchCampaignDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'LaunchCampaign', 'mutation', variables);
    },
    CancelCampaign(variables: CancelCampaignMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CancelCampaignMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CancelCampaignMutation>({ document: CancelCampaignDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CancelCampaign', 'mutation', variables);
    },
    DeleteCampaign(variables: DeleteCampaignMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DeleteCampaignMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteCampaignMutation>({ document: DeleteCampaignDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'DeleteCampaign', 'mutation', variables);
    },
    Sales(variables?: SalesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SalesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SalesQuery>({ document: SalesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'Sales', 'query', variables);
    },
    Notifications(variables?: NotificationsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<NotificationsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<NotificationsQuery>({ document: NotificationsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'Notifications', 'query', variables);
    },
    UnreadNotificationCount(variables?: UnreadNotificationCountQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UnreadNotificationCountQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UnreadNotificationCountQuery>({ document: UnreadNotificationCountDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'UnreadNotificationCount', 'query', variables);
    },
    MarkNotificationRead(variables: MarkNotificationReadMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<MarkNotificationReadMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MarkNotificationReadMutation>({ document: MarkNotificationReadDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'MarkNotificationRead', 'mutation', variables);
    },
    MarkAllNotificationsRead(variables?: MarkAllNotificationsReadMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<MarkAllNotificationsReadMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MarkAllNotificationsReadMutation>({ document: MarkAllNotificationsReadDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'MarkAllNotificationsRead', 'mutation', variables);
    },
    Settings(variables?: SettingsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SettingsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SettingsQuery>({ document: SettingsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'Settings', 'query', variables);
    },
    UpdateSetting(variables: UpdateSettingMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UpdateSettingMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateSettingMutation>({ document: UpdateSettingDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'UpdateSetting', 'mutation', variables);
    },
    KpiTargets(variables?: KpiTargetsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<KpiTargetsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<KpiTargetsQuery>({ document: KpiTargetsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'KpiTargets', 'query', variables);
    },
    UpdateKpiTarget(variables: UpdateKpiTargetMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UpdateKpiTargetMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateKpiTargetMutation>({ document: UpdateKpiTargetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'UpdateKpiTarget', 'mutation', variables);
    },
    SetKpiBaseline(variables: SetKpiBaselineMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SetKpiBaselineMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SetKpiBaselineMutation>({ document: SetKpiBaselineDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SetKpiBaseline', 'mutation', variables);
    },
    ImportJobs(variables?: ImportJobsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ImportJobsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ImportJobsQuery>({ document: ImportJobsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'ImportJobs', 'query', variables);
    },
    ImportFromExcel(variables: ImportFromExcelMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ImportFromExcelMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ImportFromExcelMutation>({ document: ImportFromExcelDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'ImportFromExcel', 'mutation', variables);
    },
    UploadFile(variables: UploadFileMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UploadFileMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UploadFileMutation>({ document: UploadFileDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'UploadFile', 'mutation', variables);
    },
    Tickets(variables?: TicketsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TicketsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TicketsQuery>({ document: TicketsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'Tickets', 'query', variables);
    },
    MyTickets(variables?: MyTicketsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<MyTicketsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MyTicketsQuery>({ document: MyTicketsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'MyTickets', 'query', variables);
    },
    TicketDetail(variables: TicketDetailQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TicketDetailQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TicketDetailQuery>({ document: TicketDetailDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'TicketDetail', 'query', variables);
    },
    TicketEvents(variables: TicketEventsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TicketEventsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TicketEventsQuery>({ document: TicketEventsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'TicketEvents', 'query', variables);
    },
    CreateTicket(variables: CreateTicketMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CreateTicketMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateTicketMutation>({ document: CreateTicketDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CreateTicket', 'mutation', variables);
    },
    UpdateTicket(variables: UpdateTicketMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UpdateTicketMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateTicketMutation>({ document: UpdateTicketDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'UpdateTicket', 'mutation', variables);
    },
    AssignTicket(variables: AssignTicketMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AssignTicketMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AssignTicketMutation>({ document: AssignTicketDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'AssignTicket', 'mutation', variables);
    },
    ChangeTicketStatus(variables: ChangeTicketStatusMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ChangeTicketStatusMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ChangeTicketStatusMutation>({ document: ChangeTicketStatusDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'ChangeTicketStatus', 'mutation', variables);
    },
    ChangeTicketPriority(variables: ChangeTicketPriorityMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ChangeTicketPriorityMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ChangeTicketPriorityMutation>({ document: ChangeTicketPriorityDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'ChangeTicketPriority', 'mutation', variables);
    },
    EscalateTicket(variables: EscalateTicketMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<EscalateTicketMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<EscalateTicketMutation>({ document: EscalateTicketDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'EscalateTicket', 'mutation', variables);
    },
    ResolveTicket(variables: ResolveTicketMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ResolveTicketMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ResolveTicketMutation>({ document: ResolveTicketDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'ResolveTicket', 'mutation', variables);
    },
    ReopenTicket(variables: ReopenTicketMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ReopenTicketMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ReopenTicketMutation>({ document: ReopenTicketDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'ReopenTicket', 'mutation', variables);
    },
    CloseTicket(variables: CloseTicketMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CloseTicketMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CloseTicketMutation>({ document: CloseTicketDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CloseTicket', 'mutation', variables);
    },
    ReplyToTicket(variables: ReplyToTicketMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ReplyToTicketMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ReplyToTicketMutation>({ document: ReplyToTicketDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'ReplyToTicket', 'mutation', variables);
    },
    AddTicketNote(variables: AddTicketNoteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AddTicketNoteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddTicketNoteMutation>({ document: AddTicketNoteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'AddTicketNote', 'mutation', variables);
    },
    AddCorrectiveAction(variables: AddCorrectiveActionMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AddCorrectiveActionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddCorrectiveActionMutation>({ document: AddCorrectiveActionDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'AddCorrectiveAction', 'mutation', variables);
    },
    RateTicket(variables: RateTicketMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<RateTicketMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RateTicketMutation>({ document: RateTicketDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'RateTicket', 'mutation', variables);
    },
    StartWork(variables: StartWorkMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<StartWorkMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<StartWorkMutation>({ document: StartWorkDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'StartWork', 'mutation', variables);
    },
    StopWork(variables: StopWorkMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<StopWorkMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<StopWorkMutation>({ document: StopWorkDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'StopWork', 'mutation', variables);
    },
    UploadAttachment(variables: UploadAttachmentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UploadAttachmentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UploadAttachmentMutation>({ document: UploadAttachmentDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'UploadAttachment', 'mutation', variables);
    },
    DeleteAttachment(variables: DeleteAttachmentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DeleteAttachmentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteAttachmentMutation>({ document: DeleteAttachmentDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'DeleteAttachment', 'mutation', variables);
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;